
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bLtXM", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $axutP = parcelRequire("axutP");


var $42omo = parcelRequire("42omo");


var $diswb = parcelRequire("diswb");


var $eSUdr = parcelRequire("eSUdr");


var $hnvzE = parcelRequire("hnvzE");


var $jMyy4 = parcelRequire("jMyy4");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $3jwuS = parcelRequire("3jwuS");


var $2VZOl = parcelRequire("2VZOl");


var $de2j9 = parcelRequire("de2j9");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $cLo2u = parcelRequire("cLo2u");


var $7Sm4c = parcelRequire("7Sm4c");


var $efvKr = parcelRequire("efvKr");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");


var $jyw2s = parcelRequire("jyw2s");


var $9HkI0 = parcelRequire("9HkI0");




var $aFUXX = parcelRequire("aFUXX");


var $T9xHm = parcelRequire("T9xHm");


var $6mKj3 = parcelRequire("6mKj3");

const $6bda54ffb0f4283a$export$2fbd87a2176aa7cf = (id)=>{
    if (!id) return (0, $aFUXX.participantColors)[0];
    return (0, $jyw2s.getParticipantColor)(id).color;
};
const $6bda54ffb0f4283a$export$fecb54e21647ae4f = ()=>{
    return {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    };
};
const $6bda54ffb0f4283a$export$a8078789f7ade13a = (participants, sessionId)=>{
    if (sessionId) return [
        ...participants.values()
    ].find((p)=>p.sessions[sessionId]);
};
const $6bda54ffb0f4283a$export$8c4801f1df434a3 = (sessionData, currentUserSessionId, defaultActivity)=>{
    if (currentUserSessionId) return sessionData[currentUserSessionId]?.activity ?? defaultActivity ?? 'viewer';
    else {
        const hasEditor = Object.keys(sessionData).find((sessionId)=>sessionData[sessionId]?.activity === 'editor');
        return hasEditor ? 'editor' : 'viewer';
    }
};
const $6bda54ffb0f4283a$export$cd367e77e21c7f3d = ()=>{
    const route = 'collab-presence-confluence';
    if (window.location.hostname === 'localhost' && true) {
        const host = window.__backendOriginHost;
        return `https://${host}/${route}`;
    }
    return `${window.location.origin}/${route}`;
};
const $6bda54ffb0f4283a$export$324e5039614a122a = (cloudId, activationId)=>{
    let path = '';
    if ((0, $T9xHm.isIsolatedCloud)() && (0, $6mKj3.expVal)('platform_editor_use_pmr_for_collab_presence_in_ic', 'isEnabled', false) || !(0, $T9xHm.isIsolatedCloud)() && (0, $6mKj3.expVal)('platform_editor_use_pmr_for_collab_presence_non_ic', 'isEnabled', false)) {
        const presencePrefix = '/ncs-presence';
        path = `${presencePrefix}/${cloudId}/${activationId}/confluence`;
    }
    return path;
};
const $6bda54ffb0f4283a$var$presenceCanvasContentTypes = [
    'database',
    'whiteboard'
];
const $6bda54ffb0f4283a$export$ea7ca1acbbc07168 = (contentType)=>$6bda54ffb0f4283a$var$presenceCanvasContentTypes.includes(contentType);
const $6bda54ffb0f4283a$export$73e42e5abf6898ab = ()=>`presence-${(0, $9HkI0.v4)()}`;
const $6bda54ffb0f4283a$export$dd4b75f1a6268a6b = 4;
const $6bda54ffb0f4283a$export$a9b806721f7a3927 = 'dummy-session-id';
const $6bda54ffb0f4283a$export$72a96dbd0b162542 = 'unidentified';


// yes, all this is hella messy right now, will be refactoring and moving out of a store
const $2960af57d9597263$var$PresenceStore = (0, $1P1Tu.createStore)({
    initialState: {
        participants: new Map(),
        telepointers: new Map()
    },
    actions: {
        add: (participant)=>({ getState: getState, setState: setState })=>{
                const { participants: participants } = getState();
                // can't be null in confluence, ultimately is the userId for logged in users and presenceId for anonymous
                const { presenceId: id } = participant;
                const currentParticipants = new Map(participants);
                if (id) {
                    const previousParticipant = currentParticipants.get(id);
                    const entry = {
                        id: id,
                        userId: participant.userId,
                        presenceId: participant.presenceId,
                        name: participant.name,
                        isGuest: participant.isGuest,
                        isCurrentUser: Boolean(previousParticipant?.isCurrentUser),
                        src: participant.avatar,
                        sessions: {
                            ...previousParticipant?.sessions,
                            [participant.sessionId]: {
                                activity: participant.presenceActivity ?? 'viewer'
                            }
                        }
                    };
                    currentParticipants.set(id, entry);
                    setState({
                        participants: currentParticipants
                    });
                } else // eslint-disable-next-line no-console
                console.error("presenceId is null for participant when it shouldn't be for ", participant);
            },
        remove: (sessionId)=>({ getState: getState, setState: setState })=>{
                const { participants: participants } = getState();
                const currentParticipants = new Map(participants);
                const participant = (0, $6bda54ffb0f4283a$export$a8078789f7ade13a)(participants, sessionId);
                if (participant) {
                    if (Object.keys(participant.sessions).length === 1) {
                        currentParticipants.delete(participant.id);
                        setState({
                            participants: currentParticipants
                        });
                    } else {
                        delete participant.sessions[sessionId];
                        currentParticipants.set(participant.id, participant);
                        setState({
                            participants: currentParticipants
                        });
                    }
                } else // eslint-disable-next-line no-console
                console.error('Could not remove participant with sessionId of ', sessionId);
            },
        addTelepointerData: (data)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const participant = (0, $6bda54ffb0f4283a$export$a8078789f7ade13a)(state.participants, data.sessionId);
                if (// Don't track the telepointer data for the current user
                Boolean(participant?.isCurrentUser)) return;
                const telepointers = new Map(state.telepointers);
                telepointers.set(data.sessionId, {
                    ...data,
                    timestamp: Date.now()
                });
                setState({
                    telepointers: telepointers
                });
            }
    },
    name: 'PresenceStore'
});
const $2960af57d9597263$export$7033f12ef2e1cbf5 = (0, $9zUhf.createHook)($2960af57d9597263$var$PresenceStore);
const $2960af57d9597263$export$afdb9ee4b69111fa = (0, $9zUhf.createActionsHook)($2960af57d9597263$var$PresenceStore);
const $2960af57d9597263$export$23e4fe06e7659b53 = (0, $9zUhf.createStateHook)($2960af57d9597263$var$PresenceStore, {
    selector: (state)=>state.participants
});
const $2960af57d9597263$export$d8ba5bfd88808651 = (state, props)=>{
    const { participants: participants } = state;
    const currentUser = (0, $6bda54ffb0f4283a$export$a8078789f7ade13a)(participants, props.sessionId);
    const participantValues = [
        ...participants.values()
    ].filter((p)=>p.presenceId !== currentUser?.presenceId);
    if (currentUser) participantValues.unshift(currentUser);
    return participantValues.map((participant)=>{
        const isAnonymous = participant.userId === (0, $6bda54ffb0f4283a$export$72a96dbd0b162542);
        // When the user is anonymous, we attempt to use the localized name from the anonymous asset or a default name
        const name = isAnonymous ? participant.name || props.anonymousName : participant.name;
        return {
            ...participant,
            participantColor: isAnonymous ? (0, $jyw2s.getParticipantColor)(participant.id).color.backgroundColor : undefined,
            isCurrentUser: participant.isCurrentUser || participant.id === currentUser?.id,
            name: name,
            activity: participant.isCurrentUser && currentUser ? (0, $6bda54ffb0f4283a$export$8c4801f1df434a3)(participant.sessions, props.sessionId, props.activity) : (0, $6bda54ffb0f4283a$export$8c4801f1df434a3)(participant.sessions)
        };
    });
};
const $2960af57d9597263$export$5a5a291828ecb5e4 = (0, $9zUhf.createStateHook)($2960af57d9597263$var$PresenceStore, {
    selector: $2960af57d9597263$export$d8ba5bfd88808651
});
const $2960af57d9597263$export$172cef4c4690b3ab = (state, sessions)=>Object.keys(sessions).map((sId)=>state.telepointers.get(sId)).filter((tData)=>!!tData).sort((a, b)=>b?.timestamp - a?.timestamp)?.[0];
const $2960af57d9597263$export$f1a08937c1f9340b = (0, $9zUhf.createHook)($2960af57d9597263$var$PresenceStore, {
    selector: $2960af57d9597263$export$172cef4c4690b3ab
});
const $2960af57d9597263$export$f642eede20cf74c0 = (0, $FOT9i.createContainer)($2960af57d9597263$var$PresenceStore, {
    onInit: ()=>({ setState: setState }, { participant: participant, fetchAnonymousAsset: fetchAnonymousAsset, onError: onError })=>{
            if (participant) {
                const defaultParticipants = new Map();
                if (participant.userId === (0, $6bda54ffb0f4283a$export$72a96dbd0b162542)) fetchAnonymousAsset(participant.presenceId).then((asset)=>{
                    defaultParticipants.set(participant.id, {
                        ...participant,
                        src: asset?.src || participant.src,
                        name: asset?.name || participant.name
                    });
                }).catch(onError).finally(()=>{
                    setState({
                        participants: defaultParticipants
                    });
                });
                else {
                    defaultParticipants.set(participant.id, {
                        ...participant
                    });
                    setState({
                        participants: defaultParticipants
                    });
                }
            } else setState({
                participants: new Map()
            });
        }
});













var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $5ig3T = parcelRequire("5ig3T");





function $ac008d3f6652bd26$var$s() {
    return $ac008d3f6652bd26$var$s = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = arguments[t];
            for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
    }, $ac008d3f6652bd26$var$s.apply(this, arguments);
}
function $ac008d3f6652bd26$var$c(e, t) {
    return $ac008d3f6652bd26$var$c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
        return e.__proto__ = t, e;
    }, $ac008d3f6652bd26$var$c(e, t);
}
function $ac008d3f6652bd26$var$d(e, t) {
    if (null == e) return {};
    var r, n, i = {}, o = Object.keys(e);
    for(n = 0; n < o.length; n++)t.indexOf(r = o[n]) >= 0 || (i[r] = e[r]);
    return i;
}
var $ac008d3f6652bd26$var$f = /*#__PURE__*/ (0, $42omo.createContext)({}), $ac008d3f6652bd26$var$u = /*#__PURE__*/ (0, $42omo.createContext)("portal"), $ac008d3f6652bd26$export$3e759dc50fe56038 = /*#__PURE__*/ function(r) {
    var n, o;
    function p() {
        for(var e, t = arguments.length, n = new Array(t), i = 0; i < t; i++)n[i] = arguments[i];
        return (e = r.call.apply(r, [
            this
        ].concat(n)) || this).inProgressAnimations = {}, e.flipCallbacks = {}, e.el = void 0, e;
    }
    o = r, (n = p).prototype = Object.create(o.prototype), n.prototype.constructor = n, $ac008d3f6652bd26$var$c(n, o);
    var l = p.prototype;
    return l.getSnapshotBeforeUpdate = function(t) {
        return t.flipKey !== this.props.flipKey && this.el ? (0, $5ig3T.getFlippedElementPositionsBeforeUpdate)({
            element: this.el,
            flipCallbacks: this.flipCallbacks,
            inProgressAnimations: this.inProgressAnimations,
            portalKey: this.props.portalKey
        }) : null;
    }, l.componentDidUpdate = function(e, r, n) {
        this.props.flipKey !== e.flipKey && this.el && (0, $5ig3T.onFlipKeyUpdate)({
            flippedElementPositionsBeforeUpdate: n.flippedElementPositions,
            cachedOrderedFlipIds: n.cachedOrderedFlipIds,
            containerEl: this.el,
            inProgressAnimations: this.inProgressAnimations,
            flipCallbacks: this.flipCallbacks,
            applyTransformOrigin: this.props.applyTransformOrigin,
            spring: this.props.spring,
            debug: this.props.debug,
            portalKey: this.props.portalKey,
            staggerConfig: this.props.staggerConfig,
            handleEnterUpdateDelete: this.props.handleEnterUpdateDelete,
            decisionData: {
                previous: e.decisionData,
                current: this.props.decisionData
            },
            onComplete: this.props.onComplete,
            onStart: this.props.onStart
        });
    }, l.render = function() {
        var e = this, t = this.props, r = t.portalKey, n = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac008d3f6652bd26$var$f.Provider, {
            value: this.flipCallbacks
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(t.element, {
            className: t.className,
            ref: function(t) {
                return e.el = t;
            }
        }, this.props.children));
        return r && (n = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac008d3f6652bd26$var$u.Provider, {
            value: r
        }, n)), n;
    }, p;
}((0, $42omo.Component));
$ac008d3f6652bd26$export$3e759dc50fe56038.defaultProps = {
    applyTransformOrigin: !0,
    element: "div"
};
var $ac008d3f6652bd26$var$m = [
    "children",
    "flipId",
    "inverseFlipId",
    "portalKey"
], $ac008d3f6652bd26$var$y = [
    "children",
    "flipId",
    "shouldFlip",
    "shouldInvert",
    "onAppear",
    "onStart",
    "onStartImmediate",
    "onComplete",
    "onExit",
    "onSpringUpdate"
], $ac008d3f6652bd26$var$g = function(e) {
    var t, i = e.children, o = e.flipId, p = e.inverseFlipId, s = e.portalKey, c = $ac008d3f6652bd26$var$d(e, $ac008d3f6652bd26$var$m), f = i, u = function(e) {
        return "function" == typeof e;
    }(f);
    if (!u) try {
        f = (0, $42omo.Children).only(i);
    } catch (e) {
        throw new Error("Each Flipped component must wrap a single child");
    }
    c.scale || c.translate || c.opacity || (0, $5ig3T.utilities).assign(c, {
        translate: !0,
        scale: !0,
        opacity: !0
    });
    var h = ((t = {})[(0, $5ig3T.constants).DATA_FLIP_CONFIG] = JSON.stringify(c), t);
    return void 0 !== o ? h[(0, $5ig3T.constants).DATA_FLIP_ID] = String(o) : p && (h[(0, $5ig3T.constants).DATA_INVERSE_FLIP_ID] = String(p)), void 0 !== s && (h[(0, $5ig3T.constants).DATA_PORTAL_KEY] = s), u ? f(h) : /*#__PURE__*/ (0, $42omo.cloneElement)(f, h);
}, $ac008d3f6652bd26$export$c3816ea9cb166de0 = function(e) {
    var t = e.children, n = e.flipId, o = e.shouldFlip, p = e.shouldInvert, l = e.onAppear, a = e.onStart, c = e.onStartImmediate, h = e.onComplete, m = e.onExit, v = e.onSpringUpdate, I = $ac008d3f6652bd26$var$d(e, $ac008d3f6652bd26$var$y);
    return t ? I.inverseFlipId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac008d3f6652bd26$var$g, $ac008d3f6652bd26$var$s({}, I), t) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac008d3f6652bd26$var$u.Consumer, null, function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac008d3f6652bd26$var$f.Consumer, null, function(d) {
            return (0, $5ig3T.utilities).isObject(d) && n && (d[n] = {
                shouldFlip: o,
                shouldInvert: p,
                onAppear: l,
                onStart: a,
                onStartImmediate: c,
                onComplete: h,
                onExit: m,
                onSpringUpdate: v
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac008d3f6652bd26$var$g, $ac008d3f6652bd26$var$s({
                flipId: n
            }, I, {
                portalKey: e
            }), t);
        });
    }) : null;
};
$ac008d3f6652bd26$export$c3816ea9cb166de0.displayName = "Flipped";
var $ac008d3f6652bd26$export$1ee2e655748633b0 = function(e) {
    var t; /*#__PURE__*/ 
    return (0, $42omo.cloneElement)(e.children, ((t = {})[(0, $5ig3T.constants).DATA_EXIT_CONTAINER] = !0, t));
};



var $cbc8g = parcelRequire("cbc8g");


var $gfIPU = parcelRequire("gfIPU");























var $2Pg7f = parcelRequire("2Pg7f");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $lGgRw = parcelRequire("lGgRw");


var $inPa6 = parcelRequire("inPa6");


var $ep3mz = parcelRequire("ep3mz");


var $lgKMU = parcelRequire("lgKMU");


var $9wGTI = parcelRequire("9wGTI");





var $1eaCJ = parcelRequire("1eaCJ");








var $6S5EB = parcelRequire("6S5EB");






const $dfd0e0bcd5f5e42d$export$ab3d2b3e42e6721 = (participants, isLoggedIn, isGuest, isExternalShareRequest)=>{
    // Check if the user is eligible for suggestions based on their login status, guest status, the number of participants, and if link is external.
    if (!isLoggedIn || isGuest || participants.length >= (0, $6bda54ffb0f4283a$export$dd4b75f1a6268a6b) || isExternalShareRequest) return false;
    if ((0, $6mKj3.expValEquals)('collab_in_team_presence_exp', 'cohort', 'variation')) return true;
    return false;
};

















var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");





var $kM55L = parcelRequire("kM55L");

















var $hArLp = parcelRequire("hArLp");




var $u9agA = parcelRequire("u9agA");





var $ccHMk = parcelRequire("ccHMk");


var $hkzol = parcelRequire("hkzol");

const $b0043606230dc18b$export$e28fc561c2630abb = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { contentId: contentId, contentMode: contentMode, contentType: contentType, pageMode: pageMode, spaceKey: spaceKey, copyLinkButtonLabel: copyLinkButtonLabel, shareButtonLabel: shareButtonLabel, isShareButtonDisabled: isShareButtonDisabled, onShareClick: onShareClick } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== onShareClick) {
        t1 = (_)=>{
            if (onShareClick) onShareClick("noCollaboratorsDialog");
        };
        $[0] = onShareClick;
        $[1] = t1;
    } else t1 = $[1];
    const onShare = t1;
    let t2;
    if ($[2] !== contentMode || $[3] !== contentType || $[4] !== createAnalyticsEvent) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "noCollaboratorsDialogShareOptions",
                    attributes: {
                        contentMode: contentMode,
                        contentType: contentType
                    }
                }
            }).fire();
        };
        $[2] = contentMode;
        $[3] = contentType;
        $[4] = createAnalyticsEvent;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== contentMode || $[7] !== contentType || $[8] !== createAnalyticsEvent || $[9] !== pageMode) {
        t3 = [
            createAnalyticsEvent,
            contentMode,
            contentType,
            pageMode
        ];
        $[6] = contentMode;
        $[7] = contentType;
        $[8] = createAnalyticsEvent;
        $[9] = pageMode;
        $[10] = t3;
    } else t3 = $[10];
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[11] !== contentId || $[12] !== contentType || $[13] !== copyLinkButtonLabel || $[14] !== pageMode || $[15] !== spaceKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hkzol.CopyLinkButton), {
            buttonAppearance: "subtle",
            buttonText: copyLinkButtonLabel,
            contentId: contentId,
            contentType: contentType,
            pageMode: pageMode,
            spaceKey: spaceKey,
            source: "noCollaboratorsDialog"
        });
        $[11] = contentId;
        $[12] = contentType;
        $[13] = copyLinkButtonLabel;
        $[14] = pageMode;
        $[15] = spaceKey;
        $[16] = t4;
    } else t4 = $[16];
    let t5;
    if ($[17] !== isShareButtonDisabled || $[18] !== onShare || $[19] !== shareButtonLabel) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            testId: "open-share-dialog",
            appearance: "default",
            onClick: onShare,
            isDisabled: isShareButtonDisabled
        }, shareButtonLabel);
        $[17] = isShareButtonDisabled;
        $[18] = onShare;
        $[19] = shareButtonLabel;
        $[20] = t5;
    } else t5 = $[20];
    let t6;
    if ($[21] !== t4 || $[22] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            padding: "space.200",
            paddingBlockStart: "space.400"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignInline: "end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, t4, t5)));
        $[21] = t4;
        $[22] = t5;
        $[23] = t6;
    } else t6 = $[23];
    return t6;
} : ({ contentId: contentId, contentMode: contentMode, contentType: contentType, pageMode: pageMode, spaceKey: spaceKey, copyLinkButtonLabel: copyLinkButtonLabel, shareButtonLabel: shareButtonLabel, isShareButtonDisabled: isShareButtonDisabled, onShareClick: onShareClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onShare = (0, $42omo.useCallback)((_)=>{
        if (onShareClick) onShareClick('noCollaboratorsDialog');
    }, [
        onShareClick
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'noCollaboratorsDialogShareOptions',
                attributes: {
                    contentMode: contentMode,
                    contentType: contentType
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentMode,
        contentType,
        pageMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.200",
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hkzol.CopyLinkButton), {
        buttonAppearance: "subtle",
        buttonText: copyLinkButtonLabel,
        contentId: contentId,
        contentType: contentType,
        pageMode: pageMode,
        spaceKey: spaceKey,
        source: "noCollaboratorsDialog"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        testId: "open-share-dialog",
        appearance: "default",
        onClick: onShare,
        isDisabled: isShareButtonDisabled
    }, shareButtonLabel))));
};


const $1fc817270f48d66d$var$i18n = (0, $cgtv4.defineMessages)({
    blogpostViewing: {
        id: "team-presence.menu.empty-state.blogpost.viewing",
        defaultMessage: "You\u2019re the only one viewing this blog post."
    },
    blogpostEditing: {
        id: "team-presence.menu.empty-state.blogpost.editing",
        defaultMessage: "You\u2019re the only one editing this blog post."
    },
    pageViewing: {
        id: "team-presence.menu.empty-state.page.viewing",
        defaultMessage: "You\u2019re the only one viewing this page."
    },
    pageEditing: {
        id: "team-presence.menu.empty-state.page.editing",
        defaultMessage: "You\u2019re the only one editing this page."
    },
    shareItWithOthersText: {
        id: "team-presence.menu.empty-state.share-it-with-others",
        defaultMessage: "Share it with others who might be interested."
    },
    publishToShareItWithOthersText: {
        id: "team-presence.menu.empty-state.publish-to-share-it-with-others",
        defaultMessage: "Publish it to share with others who might be interested."
    },
    copyLinkButtonText: {
        id: "team-presence.menu.empty-state.copy-button",
        defaultMessage: "Copy link"
    },
    sharePageButtonText: {
        id: "team-presence.menu.empty-state.page.share-button",
        defaultMessage: "Share page"
    },
    shareBlogPostButtonText: {
        id: "team-presence.menu.empty-state.blogpost.share-button",
        defaultMessage: "Share blog post"
    },
    sharePageButtonClickedText: {
        id: "team-presence.menu.empty-state.page.share-button.clicked",
        defaultMessage: "Page shared"
    },
    shareBlogPostButtonClickedText: {
        id: "team-presence.menu.empty-state.blogpost.share-button.clicked",
        defaultMessage: "Blog post shared"
    },
    whiteboardModalDescription: {
        id: "team-presence.menu.empty-state.whiteboard",
        defaultMessage: "You\u2019re the only one on this whiteboard."
    },
    shareWhiteboardButtonText: {
        id: "team-presence.menu.empty-state.whiteboard.share-button",
        defaultMessage: "Share whiteboard"
    },
    shareWhiteboardButtonClickedText: {
        id: "team-presence.menu.empty-state.whiteboard.share-button.clicked",
        defaultMessage: "Whiteboard shared"
    },
    databaseModalDescription: {
        id: "team-presence.menu.empty-state.database",
        defaultMessage: "You\u2019re the only one on this database."
    },
    shareDatabaseButtonText: {
        id: "team-presence.menu.empty-state.database.share-button",
        defaultMessage: "Share database"
    },
    shareDatabaseButtonClickedText: {
        id: "team-presence.menu.empty-state.database.share-button.clicked",
        defaultMessage: "Database shared"
    },
    liveDocViewingModalDescription: {
        id: "team-presence.menu.empty-state.live-doc.viewing",
        defaultMessage: "You\u2019re the only one viewing this live doc."
    },
    liveDocEditingModalDescription: {
        id: "team-presence.menu.empty-state.live-doc.editing",
        defaultMessage: "You\u2019re the only one editing this live doc."
    },
    shareLiveDocButtonText: {
        id: "team-presence.menu.empty-state.live-doc.share-button",
        defaultMessage: "Share live doc"
    },
    shareLiveDocButtonClickedText: {
        id: "team-presence.menu.empty-state.live-doc.share-button.clicked",
        defaultMessage: "Live doc shared"
    }
});
const $1fc817270f48d66d$var$contentTypeToTranslationMap = (formatMessage, contentMode, isShareButtonDisabled)=>{
    return {
        blogpost: {
            modalDescriptionLineOne: formatMessage(contentMode === 'edit' ? $1fc817270f48d66d$var$i18n.blogpostEditing : $1fc817270f48d66d$var$i18n.blogpostViewing),
            modalDescriptionLineTwo: formatMessage(isShareButtonDisabled ? $1fc817270f48d66d$var$i18n.publishToShareItWithOthersText : $1fc817270f48d66d$var$i18n.shareItWithOthersText),
            shareButtonText: formatMessage($1fc817270f48d66d$var$i18n.shareBlogPostButtonText),
            shareButtonClickedText: formatMessage($1fc817270f48d66d$var$i18n.shareBlogPostButtonClickedText)
        },
        page: {
            modalDescriptionLineOne: formatMessage(contentMode === 'edit' ? $1fc817270f48d66d$var$i18n.pageEditing : $1fc817270f48d66d$var$i18n.pageViewing),
            modalDescriptionLineTwo: formatMessage(isShareButtonDisabled ? $1fc817270f48d66d$var$i18n.publishToShareItWithOthersText : $1fc817270f48d66d$var$i18n.shareItWithOthersText),
            shareButtonText: formatMessage($1fc817270f48d66d$var$i18n.sharePageButtonText),
            shareButtonClickedText: formatMessage($1fc817270f48d66d$var$i18n.sharePageButtonClickedText)
        },
        whiteboard: {
            modalDescriptionLineOne: formatMessage($1fc817270f48d66d$var$i18n.whiteboardModalDescription),
            modalDescriptionLineTwo: formatMessage($1fc817270f48d66d$var$i18n.shareItWithOthersText),
            shareButtonText: formatMessage($1fc817270f48d66d$var$i18n.shareWhiteboardButtonText),
            shareButtonClickedText: formatMessage($1fc817270f48d66d$var$i18n.shareWhiteboardButtonClickedText)
        },
        database: {
            modalDescriptionLineOne: formatMessage($1fc817270f48d66d$var$i18n.databaseModalDescription),
            modalDescriptionLineTwo: formatMessage($1fc817270f48d66d$var$i18n.shareItWithOthersText),
            shareButtonText: formatMessage($1fc817270f48d66d$var$i18n.shareDatabaseButtonText),
            shareButtonClickedText: formatMessage($1fc817270f48d66d$var$i18n.shareDatabaseButtonClickedText)
        },
        live: {
            modalDescriptionLineOne: formatMessage(contentMode === 'edit' ? $1fc817270f48d66d$var$i18n.liveDocEditingModalDescription : $1fc817270f48d66d$var$i18n.liveDocViewingModalDescription),
            modalDescriptionLineTwo: formatMessage($1fc817270f48d66d$var$i18n.shareItWithOthersText),
            shareButtonText: formatMessage($1fc817270f48d66d$var$i18n.shareLiveDocButtonText),
            shareButtonClickedText: formatMessage($1fc817270f48d66d$var$i18n.shareLiveDocButtonClickedText)
        }
    };
};
const $1fc817270f48d66d$export$3566bbc3d99e9268 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { contentMode: contentMode, onShareClick: onShareClick, contentId: contentId, contentType: contentType, spaceKey: spaceKey, testId: testId } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [t1] = (0, $kM55L.useCollabNetworkStatus)();
    const { isCollabOffline: isCollabOffline } = t1;
    let t2;
    if ($[0] !== isCollabOffline) {
        t2 = isCollabOffline && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false) && !(0, $9wGTI.fg)("platform_editor_offline_editing_wrapper_override");
        $[0] = isCollabOffline;
        $[1] = t2;
    } else t2 = $[1];
    const isNetworkDisabled = t2;
    const [t3] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t3;
    const isInEditMode = contentMode === "edit" || contentMode === "live" && isLiveEditMode;
    const pageMode = isInEditMode ? "edit" : "view";
    let t4;
    if ($[2] !== formatMessage || $[3] !== isNetworkDisabled || $[4] !== pageMode) {
        t4 = $1fc817270f48d66d$var$contentTypeToTranslationMap(formatMessage, pageMode, isNetworkDisabled);
        $[2] = formatMessage;
        $[3] = isNetworkDisabled;
        $[4] = pageMode;
        $[5] = t4;
    } else t4 = $[5];
    const translations = t4[contentType === "page" && contentMode === "live" ? "live" : contentType];
    let t5;
    if ($[6] !== translations.modalDescriptionLineOne || $[7] !== translations.modalDescriptionLineTwo) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingInline: "space.200",
            paddingBlockStart: "space.200"
        }, translations.modalDescriptionLineOne, "\xa0", translations.modalDescriptionLineTwo);
        $[6] = translations.modalDescriptionLineOne;
        $[7] = translations.modalDescriptionLineTwo;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== formatMessage) {
        t6 = formatMessage($1fc817270f48d66d$var$i18n.copyLinkButtonText);
        $[9] = formatMessage;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== contentId || $[12] !== contentMode || $[13] !== contentType || $[14] !== isNetworkDisabled || $[15] !== onShareClick || $[16] !== pageMode || $[17] !== spaceKey || $[18] !== t6 || $[19] !== translations.shareButtonText) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b0043606230dc18b$export$e28fc561c2630abb), {
            contentId: contentId,
            contentMode: contentMode,
            contentType: contentType,
            pageMode: pageMode,
            spaceKey: spaceKey,
            copyLinkButtonLabel: t6,
            shareButtonLabel: translations.shareButtonText,
            isShareButtonDisabled: isNetworkDisabled,
            onShareClick: onShareClick
        });
        $[11] = contentId;
        $[12] = contentMode;
        $[13] = contentType;
        $[14] = isNetworkDisabled;
        $[15] = onShareClick;
        $[16] = pageMode;
        $[17] = spaceKey;
        $[18] = t6;
        $[19] = translations.shareButtonText;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== t5 || $[22] !== t7 || $[23] !== testId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            testId: testId
        }, t5, t7);
        $[21] = t5;
        $[22] = t7;
        $[23] = testId;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ contentMode: contentMode, onShareClick: onShareClick, contentId: contentId, contentType: contentType, spaceKey: spaceKey, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)();
    // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override');
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    // Determine if the user is in edit mode. Live pages supports both edit and view modes, so
    // we need to do an additional check to see if we're in edit mode on a live pages.
    const isInEditMode = contentMode === 'edit' || contentMode === 'live' && isLiveEditMode;
    const pageMode = isInEditMode ? 'edit' : 'view';
    /*
  On edit classic page, there is no Share button (only "Update" button).
  Since there is no Share button on edit classic page with a share dialog, clicking the Share button on this modal doesn't do anything,
  so we are disabling the Share button on edit mode.
  The share button is also disabled if the network is disabled.
  */ const translations = $1fc817270f48d66d$var$contentTypeToTranslationMap(formatMessage, pageMode, isNetworkDisabled)[contentType === 'page' && contentMode === 'live' ? 'live' : contentType];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingInline: "space.200",
        paddingBlockStart: "space.200"
    }, translations.modalDescriptionLineOne, "\xa0", translations.modalDescriptionLineTwo), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b0043606230dc18b$export$e28fc561c2630abb), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        pageMode: pageMode,
        spaceKey: spaceKey,
        copyLinkButtonLabel: formatMessage($1fc817270f48d66d$var$i18n.copyLinkButtonText),
        shareButtonLabel: translations.shareButtonText,
        isShareButtonDisabled: isNetworkDisabled,
        onShareClick: onShareClick
    }));
};























var $g5gZt = parcelRequire("g5gZt");


var $9M4aB = parcelRequire("9M4aB");












var $gBbsI = parcelRequire("gBbsI");

var $7rvPL = parcelRequire("7rvPL");

var $3MKHu = parcelRequire("3MKHu");

var $cQDYl = parcelRequire("cQDYl");


var $3Fgla = parcelRequire("3Fgla");





var $b3j2Y = parcelRequire("b3j2Y");


var $7aRa9 = parcelRequire("7aRa9");

















var $59MXn = parcelRequire("59MXn");











var $dK51B = parcelRequire("dK51B");


var $aBfpe = parcelRequire("aBfpe");

const $44cd4522c8b31e54$export$9ce937d1e3a4cc3d = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { variables: variables, skip: skip } = t0;
    const t1 = `/gateway/api/v3/invitations/capabilities?resource=${variables.resourceARI}`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            "Content-Type": (0, $aBfpe.MediaType).JSON
        };
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== skip || $[2] !== t1 || $[3] !== variables) {
        t3 = {
            url: t1,
            method: "GET",
            credentials: "include",
            headers: t2,
            parseResult: $44cd4522c8b31e54$var$_temp,
            variables: variables,
            skip: skip
        };
        $[1] = skip;
        $[2] = t1;
        $[3] = variables;
        $[4] = t3;
    } else t3 = $[4];
    return (0, $dK51B.useExperimentalQuery)(t3);
} : ({ variables: variables, skip: skip })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: `/gateway/api/v3/invitations/capabilities?resource=${variables.resourceARI}`,
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: (response)=>{
            for (const item of response){
                if (item?.resourceARI?.includes('confluence')) return {
                    experimentalInvitePermissions: {
                        directInviteMode: item?.directInvite?.mode ?? null,
                        invitePendingApprovalMode: item?.invitePendingApproval?.mode ?? null
                    }
                };
            }
            return {
                experimentalInvitePermissions: {
                    directInviteMode: null,
                    invitePendingApprovalMode: null
                }
            };
        },
        variables: variables,
        skip: skip
    });
};
function $44cd4522c8b31e54$var$_temp(response) {
    for (const item of response){
        if (item?.resourceARI?.includes("confluence")) return {
            experimentalInvitePermissions: {
                directInviteMode: item?.directInvite?.mode ?? null,
                invitePendingApprovalMode: item?.invitePendingApproval?.mode ?? null
            }
        };
    }
    return {
        experimentalInvitePermissions: {
            directInviteMode: null,
            invitePendingApprovalMode: null
        }
    };
}

















var $2SlZp = parcelRequire("2SlZp");




var $ihDPC = parcelRequire("ihDPC");

parcelRequire("cVfpT");
var $9WYR7 = parcelRequire("9WYR7");



















var $esRft = parcelRequire("esRft");


var $cvXh8 = parcelRequire("cvXh8");


var $4fdTR = parcelRequire("4fdTR");





var $d77M1 = parcelRequire("d77M1");






var $5dK2X = parcelRequire("5dK2X");






const $05e14509e2c3c348$var$i18n = (0, $cgtv4.defineMessages)({
    shareButtonText: {
        id: "team-presence.menu.empty-state.suggestions-dialog.share-button",
        defaultMessage: "Share"
    },
    shareButtonClickedText: {
        id: "team-presence.menu.empty-state.suggestions-dialog.share-button.clicked",
        defaultMessage: "Sent"
    }
});
const $05e14509e2c3c348$var$FlexTruncateStyles = (0, $ecnYn.xcss)({
    flexGrow: '1',
    minWidth: '0'
});
const $05e14509e2c3c348$export$87462d24e5330023 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { suggestedUser: suggestedUser, onHandleShare: onHandleShare, contentId: contentId, contentType: contentType, contentMode: contentMode } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [hasShared, setHasShared] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== contentId || $[1] !== contentMode || $[2] !== contentType || $[3] !== createAnalyticsEvent || $[4] !== onHandleShare) {
        t1 = ()=>{
            setHasShared(true);
            onHandleShare();
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "sentText",
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        contentMode: contentMode
                    }
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = contentMode;
        $[2] = contentType;
        $[3] = createAnalyticsEvent;
        $[4] = onHandleShare;
        $[5] = t1;
    } else t1 = $[5];
    const handleOnShareClicked = t1;
    let t2;
    if ($[6] !== contentId || $[7] !== contentMode || $[8] !== contentType || $[9] !== formatMessage || $[10] !== handleOnShareClicked || $[11] !== hasShared || $[12] !== suggestedUser.name || $[13] !== suggestedUser.picture) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d77M1.default), {
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    paddingInline: "space.200",
                    paddingBlock: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                    gap: "space.150",
                    alignItems: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
                    size: "small",
                    src: suggestedUser.picture
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $05e14509e2c3c348$var$FlexTruncateStyles
                }, suggestedUser.name), hasShared ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    paddingInline: "space.200",
                    paddingBlock: "space.025"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                    gap: "space.075",
                    alignItems: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                    label: "share-success",
                    color: "var(--ds-icon-success, #6A9A23)"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                    weight: "medium",
                    color: "color.text.subtle"
                }, formatMessage($05e14509e2c3c348$var$i18n.shareButtonClickedText)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                    iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($4fdTR))),
                    testId: "share-with-people",
                    onClick: handleOnShareClicked,
                    spacing: "compact",
                    analyticsContext: {
                        contentId: contentId,
                        contentType: contentType,
                        contentMode: contentMode,
                        source: "shareWithPeopleButton"
                    }
                }, formatMessage($05e14509e2c3c348$var$i18n.shareButtonText))))
        });
        $[6] = contentId;
        $[7] = contentMode;
        $[8] = contentType;
        $[9] = formatMessage;
        $[10] = handleOnShareClicked;
        $[11] = hasShared;
        $[12] = suggestedUser.name;
        $[13] = suggestedUser.picture;
        $[14] = t2;
    } else t2 = $[14];
    return t2;
} : ({ suggestedUser: suggestedUser, onHandleShare: onHandleShare, contentId: contentId, contentType: contentType, contentMode: contentMode })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [hasShared, setHasShared] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleOnShareClicked = ()=>{
        setHasShared(true);
        onHandleShare();
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'sentText',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    contentMode: contentMode
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d77M1.default), {
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                paddingInline: "space.200",
                paddingBlock: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                gap: "space.150",
                alignItems: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
                size: "small",
                src: suggestedUser.picture
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $05e14509e2c3c348$var$FlexTruncateStyles
            }, suggestedUser.name), hasShared ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                paddingInline: "space.200",
                paddingBlock: "space.025"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                gap: "space.075",
                alignItems: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                label: "share-success",
                color: "var(--ds-icon-success, #6A9A23)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                weight: "medium",
                color: "color.text.subtle"
            }, formatMessage($05e14509e2c3c348$var$i18n.shareButtonClickedText)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($4fdTR))),
                testId: "share-with-people",
                onClick: handleOnShareClicked,
                spacing: "compact",
                analyticsContext: {
                    contentId: contentId,
                    contentType: contentType,
                    contentMode: contentMode,
                    source: 'shareWithPeopleButton'
                }
            }, formatMessage($05e14509e2c3c348$var$i18n.shareButtonText))))
    });
};


const $44e7bef026954ee8$var$i18n = (0, $cgtv4.defineMessages)({
    sharedFlag: {
        id: "team-presence.menu.empty-state.shared.flag",
        defaultMessage: "Content shared"
    }
});
const $44e7bef026954ee8$export$60035f816190ea78 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { contentId: contentId, contentType: contentType, contentMode: contentMode, pageMode: pageMode, suggestedUsers: suggestedUsers, flags: flags } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isEditMode = pageMode === "edit";
    const { shareToEntities: shareToEntities } = (0, $ihDPC.useShareToEntities)(contentId, "suggestedCollaboratorsDialog", isEditMode ? (0, $9WYR7.PAGE_MODE).EDIT : (0, $9WYR7.PAGE_MODE).VIEW);
    let t1;
    if ($[0] !== contentId || $[1] !== contentMode || $[2] !== contentType || $[3] !== flags || $[4] !== formatMessage || $[5] !== isEditMode || $[6] !== shareToEntities || $[7] !== suggestedUsers) {
        let t2;
        if ($[9] !== contentId || $[10] !== contentMode || $[11] !== contentType || $[12] !== flags || $[13] !== formatMessage || $[14] !== isEditMode || $[15] !== shareToEntities) {
            t2 = (suggestedUser)=>{
                const handleShareClick = async ()=>{
                    const result = await shareToEntities([
                        {
                            id: suggestedUser.id,
                            type: "user"
                        }
                    ], isEditMode);
                    if (result.success) flags.showSuccessCircleFlag({
                        id: "team-presence-share-completed-flag",
                        title: formatMessage($44e7bef026954ee8$var$i18n.sharedFlag),
                        isAutoDismiss: true
                    });
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $05e14509e2c3c348$export$87462d24e5330023), {
                    key: suggestedUser.id,
                    suggestedUser: suggestedUser,
                    onHandleShare: handleShareClick,
                    contentId: contentId,
                    contentType: contentType,
                    contentMode: contentMode
                });
            };
            $[9] = contentId;
            $[10] = contentMode;
            $[11] = contentType;
            $[12] = flags;
            $[13] = formatMessage;
            $[14] = isEditMode;
            $[15] = shareToEntities;
            $[16] = t2;
        } else t2 = $[16];
        t1 = suggestedUsers.map(t2);
        $[0] = contentId;
        $[1] = contentMode;
        $[2] = contentType;
        $[3] = flags;
        $[4] = formatMessage;
        $[5] = isEditMode;
        $[6] = shareToEntities;
        $[7] = suggestedUsers;
        $[8] = t1;
    } else t1 = $[8];
    let t2;
    if ($[17] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), {
            maxHeight: 232
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
            isScrollable: true
        }, t1));
        $[17] = t1;
        $[18] = t2;
    } else t2 = $[18];
    return t2;
} : ({ contentId: contentId, contentType: contentType, contentMode: contentMode, pageMode: pageMode, suggestedUsers: suggestedUsers, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isEditMode = pageMode === 'edit';
    const { shareToEntities: shareToEntities } = (0, $ihDPC.useShareToEntities)(contentId, 'suggestedCollaboratorsDialog', isEditMode ? (0, $9WYR7.PAGE_MODE).EDIT : (0, $9WYR7.PAGE_MODE).VIEW);
    return(// height for 5 suggested users and 12px of padding from Section component, 6 before and 6 after the list
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), {
        maxHeight: 232
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
        isScrollable: true
    }, suggestedUsers.map((suggestedUser)=>{
        const handleShareClick = async ()=>{
            const result = await shareToEntities([
                {
                    id: suggestedUser.id,
                    type: 'user'
                }
            ], isEditMode);
            if (result.success) flags.showSuccessCircleFlag({
                id: 'team-presence-share-completed-flag',
                title: formatMessage($44e7bef026954ee8$var$i18n.sharedFlag),
                isAutoDismiss: true
            });
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $05e14509e2c3c348$export$87462d24e5330023), {
            key: suggestedUser.id,
            suggestedUser: suggestedUser,
            onHandleShare: handleShareClick,
            contentId: contentId,
            contentType: contentType,
            contentMode: contentMode
        });
    }))));
};
const $44e7bef026954ee8$export$dc33254bc906439c = (0, $7aRa9.withFlags)($44e7bef026954ee8$export$60035f816190ea78);


const $e836e779dfba9248$var$i18n = (0, $cgtv4.defineMessages)({
    // Suggested collaborators strings
    suggestedCollaboratorsDescription: {
        id: "team-presence.menu.empty-state.suggestions-dialog.description",
        defaultMessage: "You often work together"
    },
    copyLinkButtonText: {
        id: "team-presence.menu.empty-state.suggested-collaborators.footer.copy-button",
        defaultMessage: "Copy link"
    },
    moreShareOptionsButtonText: {
        id: "team-presence.menu.empty-state.suggested-collaborators.footer.more-share-options-button",
        defaultMessage: "More share options"
    },
    // Invite dialog strings
    noCollaboratorsCanInviteOnPageDescription: {
        id: "team-presence.menu.empty-state.no-collaborators.with-invite-permissions.on-page.description",
        defaultMessage: "Want to loop in others? Invite teammates to check this page out."
    },
    noCollaboratorsCanInviteOnBlogpostDescription: {
        id: "team-presence.menu.empty-state.no-collaborators.with-invite-permissions.on-blogpost.description",
        defaultMessage: "Want to loop in others? Invite teammates to check this blog post out."
    },
    noCollaboratorsCanInviteOnDatabaseDescription: {
        id: "team-presence.menu.empty-state.no-collaborators.with-invite-permissions.on-database.description",
        defaultMessage: "Want to loop in others? Invite teammates to check this database out."
    },
    noCollaboratorsCanInviteOnWhiteboardDescription: {
        id: "team-presence.menu.empty-state.no-collaborators.with-invite-permissions.on-whiteboard.description",
        defaultMessage: "Want to loop in others? Invite teammates to check this whiteboard out."
    },
    noCollaboratorsCanInviteLiveDocDescription: {
        id: "team-presence.menu.empty-state.no-collaborators.with-invite-permissions.on-live-doc.description",
        defaultMessage: "Want to loop in others? Invite teammates to check this live doc out."
    },
    inviteTeammatesButtonText: {
        id: "team-presence.menu.empty-state.no-collaborators.footer.invite-teammates-button",
        defaultMessage: "Add people to Confluence"
    },
    // Generic share strings
    noCollaboratorsCannotInviteDescription: {
        id: "team-presence.menu.empty-state.no-collaborators.without-invite-permissions.description",
        defaultMessage: "Want to loop in others? Quickly share this with relevant teammates."
    },
    sharePageButtonText: {
        id: "team-presence.menu.empty-state.no-collaborators.footer.share-page-button",
        defaultMessage: "Share page"
    },
    shareBlogpostButtonText: {
        id: "team-presence.menu.empty-state.no-collaborators.footer.share-blogpost-button",
        defaultMessage: "Share blog post"
    },
    shareDatabaseButtonText: {
        id: "team-presence.menu.empty-state.no-collaborators.footer.share-database-button",
        defaultMessage: "Share database"
    },
    shareWhiteboardButtonText: {
        id: "team-presence.menu.empty-state.no-collaborators.footer.share-whiteboard-button",
        defaultMessage: "Share whiteboard"
    },
    shareLiveDocButtonText: {
        id: "team-presence.menu.empty-state.no-collaborators.footer.share-live-doc-button",
        defaultMessage: "Share live doc"
    },
    // Generic strings when share is not available
    noCollaboratorsCannotInviteCannotShareDescription: {
        id: "team-presence.menu.empty-state.no-collaborators.without-invite-permissions.share-not-available.description",
        defaultMessage: "Want to loop in others? Copy the link to share this with relevant teammates."
    }
});
const $e836e779dfba9248$var$CONTEXT_TYPE = 'team-presence:suggested-collaborators-list:suggested-share-users';
const $e836e779dfba9248$export$69a053f3e59d89f9 = 5;
const $e836e779dfba9248$export$1a6c31c631efc63f = 'collabInTeamPresenceExperiment';
const $e836e779dfba9248$var$styles = {
    suggestedUsersDialogHeaderStyles: "_19pkv47k _otyr12x7",
    generalHeaderStyles: "_18zrpxbi _1q51pxbi",
    suggestedUsersDialogFooterStyles: "_1yt4u2gc _x3doia51",
    generalDialogFooterStyles: "_1yt4pxbi"
};
const $e836e779dfba9248$var$contentTypeToTranslationMap = (formatMessage)=>{
    return {
        blogpost: {
            modalDescription: formatMessage($e836e779dfba9248$var$i18n.noCollaboratorsCanInviteOnBlogpostDescription),
            buttonName: formatMessage($e836e779dfba9248$var$i18n.shareBlogpostButtonText)
        },
        page: {
            modalDescription: formatMessage($e836e779dfba9248$var$i18n.noCollaboratorsCanInviteOnPageDescription),
            buttonName: formatMessage($e836e779dfba9248$var$i18n.sharePageButtonText)
        },
        live: {
            modalDescription: formatMessage($e836e779dfba9248$var$i18n.noCollaboratorsCanInviteLiveDocDescription),
            buttonName: formatMessage($e836e779dfba9248$var$i18n.shareLiveDocButtonText)
        },
        whiteboard: {
            modalDescription: formatMessage($e836e779dfba9248$var$i18n.noCollaboratorsCanInviteOnWhiteboardDescription),
            buttonName: formatMessage($e836e779dfba9248$var$i18n.shareWhiteboardButtonText)
        },
        database: {
            modalDescription: formatMessage($e836e779dfba9248$var$i18n.noCollaboratorsCanInviteOnDatabaseDescription),
            buttonName: formatMessage($e836e779dfba9248$var$i18n.shareDatabaseButtonText)
        }
    };
};
const $e836e779dfba9248$var$SuggestedCollaboratorsDialogViewRestrictionsQuery = (0, $eSUdr.default)`query SuggestedCollaboratorsDialogsViewRestrictionsQuery($contentId:ID!){singleContent(id:$contentId){id hasViewRestrictions ancestors{id hasViewRestrictions}}}`;
const $e836e779dfba9248$export$cf7ccee4467197b8 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(79);
    const { contentMode: contentMode, contentId: contentId, contentType: contentType, onShareClick: onShareClick, spaceKey: spaceKey, flags: flags, testId: testId } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [t1] = (0, $kM55L.useCollabNetworkStatus)();
    const { isCollabOffline: isCollabOffline } = t1;
    let t2;
    if ($[0] !== isCollabOffline) {
        t2 = isCollabOffline && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false) && !(0, $9wGTI.fg)("platform_editor_offline_editing_wrapper_override");
        $[0] = isCollabOffline;
        $[1] = t2;
    } else t2 = $[1];
    const isNetworkDisabled = t2;
    const [t3] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t3;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const t4 = userId ?? "";
    let t5;
    if ($[2] !== t4) {
        t5 = [
            t4
        ];
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    const currentPickedPrincipalIds = t5;
    let t6;
    if ($[4] !== cloudId || $[5] !== currentPickedPrincipalIds || $[6] !== orgId) {
        t6 = {
            currentPickedPrincipalIds: currentPickedPrincipalIds,
            maxDisplayResults: 10,
            shouldFetchMoreResults: false,
            contextType: $e836e779dfba9248$var$CONTEXT_TYPE,
            siteId: cloudId,
            orgId: orgId,
            source: $e836e779dfba9248$export$1a6c31c631efc63f
        };
        $[4] = cloudId;
        $[5] = currentPickedPrincipalIds;
        $[6] = orgId;
        $[7] = t6;
    } else t6 = $[7];
    const { suggestedUsers: suggestedUsers, loading: loading, error: error } = (0, $59MXn.useUserSuggestions)(t6);
    let t7;
    if ($[8] !== contentId) {
        t7 = {
            variables: {
                contentId: contentId
            }
        };
        $[8] = contentId;
        $[9] = t7;
    } else t7 = $[9];
    const { data: restrictionsData, error: restrictionsError, loading: restrictionsLoading } = (0, $jMyy4.useQueryInterop)($e836e779dfba9248$var$SuggestedCollaboratorsDialogViewRestrictionsQuery, t7);
    let t8;
    if ($[10] !== restrictionsData?.singleContent?.ancestors || $[11] !== restrictionsData?.singleContent?.hasViewRestrictions) {
        t8 = restrictionsData?.singleContent?.hasViewRestrictions || restrictionsData?.singleContent?.ancestors?.some($e836e779dfba9248$var$_temp);
        $[10] = restrictionsData?.singleContent?.ancestors;
        $[11] = restrictionsData?.singleContent?.hasViewRestrictions;
        $[12] = t8;
    } else t8 = $[12];
    const hasViewRestrictions = !!t8;
    const skipInviteQuery = Boolean(suggestedUsers?.length) && !isNetworkDisabled || hasViewRestrictions;
    const t9 = `ari:cloud:platform::site/${cloudId}`;
    let t10;
    if ($[13] !== t9) {
        t10 = {
            resourceARI: t9
        };
        $[13] = t9;
        $[14] = t10;
    } else t10 = $[14];
    let t11;
    if ($[15] !== skipInviteQuery || $[16] !== t10) {
        t11 = {
            variables: t10,
            skip: skipInviteQuery
        };
        $[15] = skipInviteQuery;
        $[16] = t10;
        $[17] = t11;
    } else t11 = $[17];
    const { data: inviteData, error: inviteError, loading: inviteLoading } = (0, $44cd4522c8b31e54$export$9ce937d1e3a4cc3d)(t11);
    let t12;
    if ($[18] !== suggestedUsers) {
        const userRecommendations = (suggestedUsers || []).map($e836e779dfba9248$var$_temp2);
        t12 = userRecommendations.filter($e836e779dfba9248$var$_temp3);
        $[18] = suggestedUsers;
        $[19] = t12;
    } else t12 = $[19];
    const suggestedUsersList = t12;
    const isInEditMode = contentMode === "edit" || contentMode === "live" && isLiveEditMode;
    const pageMode = isInEditMode ? "edit" : "view";
    const translations = $e836e779dfba9248$var$contentTypeToTranslationMap(formatMessage)[contentType === "page" && contentMode === "live" ? "live" : contentType];
    const showSuggestedUsersDialog = !isNetworkDisabled && !!suggestedUsersList?.length && !hasViewRestrictions;
    const buttonAppearance = showSuggestedUsersDialog ? "subtle" : "default";
    const showInviteButton = !inviteError && inviteData?.experimentalInvitePermissions?.directInviteMode === "ANYONE";
    let t13;
    if ($[20] !== isNetworkDisabled || $[21] !== showInviteButton || $[22] !== showSuggestedUsersDialog) {
        t13 = ()=>{
            if (showSuggestedUsersDialog) return "suggestedCollaboratorsDialog";
            else {
                if (showInviteButton) return "noCollaboratorsInviteDialog";
                else {
                    if (!isNetworkDisabled) return "noCollaboratorsShareDialog";
                }
            }
            return "noCollaboratorsDefaultDialog";
        };
        $[20] = isNetworkDisabled;
        $[21] = showInviteButton;
        $[22] = showSuggestedUsersDialog;
        $[23] = t13;
    } else t13 = $[23];
    const getCurrentDialog = t13;
    const currentDialog = getCurrentDialog();
    let t14;
    if ($[24] !== contentId || $[25] !== contentMode || $[26] !== contentType || $[27] !== createAnalyticsEvent || $[28] !== currentDialog || $[29] !== onShareClick) {
        t14 = (_)=>{
            if (onShareClick) {
                onShareClick("suggestedCollaboratorsDialog");
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "shareWithCollaboratorsButton",
                        source: currentDialog,
                        attributes: {
                            contentId: contentId,
                            contentType: contentType,
                            contentMode: contentMode
                        }
                    }
                }).fire();
            }
        };
        $[24] = contentId;
        $[25] = contentMode;
        $[26] = contentType;
        $[27] = createAnalyticsEvent;
        $[28] = currentDialog;
        $[29] = onShareClick;
        $[30] = t14;
    } else t14 = $[30];
    const onShare = t14;
    const headerText = ()=>{
        if (showSuggestedUsersDialog) return formatMessage($e836e779dfba9248$var$i18n.suggestedCollaboratorsDescription);
        else {
            if (showInviteButton) return translations.modalDescription;
            else {
                if (!isNetworkDisabled) return formatMessage($e836e779dfba9248$var$i18n.noCollaboratorsCannotInviteDescription);
                else return formatMessage($e836e779dfba9248$var$i18n.noCollaboratorsCannotInviteCannotShareDescription);
            }
        }
    };
    let t15;
    if ($[31] !== contentId || $[32] !== contentMode || $[33] !== contentType || $[34] !== createAnalyticsEvent || $[35] !== currentDialog || $[36] !== inviteLoading || $[37] !== loading || $[38] !== restrictionsLoading || $[39] !== suggestedUsersList?.length) {
        t15 = ()=>{
            if (!loading && !inviteLoading && !restrictionsLoading) createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: currentDialog,
                    attributes: {
                        contentMode: contentMode,
                        contentType: contentType,
                        contentId: contentId,
                        suggestedUsersCount: suggestedUsersList?.length
                    }
                }
            }).fire();
        };
        $[31] = contentId;
        $[32] = contentMode;
        $[33] = contentType;
        $[34] = createAnalyticsEvent;
        $[35] = currentDialog;
        $[36] = inviteLoading;
        $[37] = loading;
        $[38] = restrictionsLoading;
        $[39] = suggestedUsersList?.length;
        $[40] = t15;
    } else t15 = $[40];
    let t16;
    if ($[41] !== contentId || $[42] !== contentMode || $[43] !== contentType || $[44] !== createAnalyticsEvent || $[45] !== currentDialog || $[46] !== inviteLoading || $[47] !== loading || $[48] !== restrictionsLoading || $[49] !== suggestedUsersList) {
        t16 = [
            loading,
            inviteLoading,
            restrictionsLoading,
            contentMode,
            contentType,
            contentId,
            suggestedUsersList,
            createAnalyticsEvent,
            currentDialog
        ];
        $[41] = contentId;
        $[42] = contentMode;
        $[43] = contentType;
        $[44] = createAnalyticsEvent;
        $[45] = currentDialog;
        $[46] = inviteLoading;
        $[47] = loading;
        $[48] = restrictionsLoading;
        $[49] = suggestedUsersList;
        $[50] = t16;
    } else t16 = $[50];
    (0, $42omo.useEffect)(t15, t16);
    if (loading || inviteLoading || restrictionsLoading) {
        let t17;
        if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
            t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3MKHu.default), {
                isShimmering: true
            }), Array.from({
                length: $e836e779dfba9248$export$69a053f3e59d89f9
            }).map($e836e779dfba9248$var$_temp4));
            $[51] = t17;
        } else t17 = $[51];
        return t17;
    }
    const queryError = error || inviteError || restrictionsError;
    if (inviteError) createAnalyticsEvent({
        type: "sendOperationalEvent",
        data: {
            source: $e836e779dfba9248$export$1a6c31c631efc63f,
            action: "errored",
            actionSubject: "suggestedCollaboratorsDialogInviteQuery",
            attributes: {
                contentId: contentId,
                contentMode: contentMode,
                contentType: contentType,
                error: inviteError,
                message: inviteError?.message
            }
        }
    }).fire();
    const T0 = (0, $eyWa4.default);
    const t17 = "dialog";
    const t18 = "suggested-collaborators-dialog";
    const t19 = "suggested-collaborators-modal-description";
    let t20;
    if ($[52] !== queryError) {
        t20 = queryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: queryError
        });
        $[52] = queryError;
        $[53] = t20;
    } else t20 = $[53];
    const t21 = showSuggestedUsersDialog ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e836e779dfba9248$var$styles.suggestedUsersDialogHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gBbsI.default), null, headerText())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $44e7bef026954ee8$export$dc33254bc906439c), {
        contentId: contentId,
        contentType: contentType,
        contentMode: pageMode,
        pageMode: pageMode,
        suggestedUsers: suggestedUsersList
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e836e779dfba9248$var$styles.generalHeaderStyles,
        id: "suggested-collaborators-modal-description"
    }, headerText());
    const t22 = showSuggestedUsersDialog ? $e836e779dfba9248$var$styles.suggestedUsersDialogFooterStyles : $e836e779dfba9248$var$styles.generalDialogFooterStyles;
    const t23 = showSuggestedUsersDialog ? "start" : "end";
    let t24;
    if ($[54] !== buttonAppearance || $[55] !== contentId || $[56] !== contentMode || $[57] !== contentType || $[58] !== currentDialog || $[59] !== flags || $[60] !== formatMessage || $[61] !== isNetworkDisabled || $[62] !== onShare || $[63] !== pageMode || $[64] !== showInviteButton || $[65] !== showSuggestedUsersDialog || $[66] !== spaceKey || $[67] !== translations) {
        t24 = showSuggestedUsersDialog || !showInviteButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hkzol.CopyLinkButton), {
            buttonAppearance: buttonAppearance,
            buttonText: formatMessage($e836e779dfba9248$var$i18n.copyLinkButtonText),
            contentId: contentId,
            contentType: contentType,
            pageMode: pageMode,
            spaceKey: spaceKey,
            source: "suggestedCollaboratorsDialog",
            onClickAttributes: {
                contentId: contentId,
                contentMode: contentMode,
                contentType: contentType,
                dialogSelected: currentDialog
            }
        }), !isNetworkDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($9M4aB))),
            testId: "open-share-dialog",
            onClick: onShare,
            appearance: buttonAppearance
        }, showSuggestedUsersDialog ? formatMessage($e836e779dfba9248$var$i18n.moreShareOptionsButtonText) : translations.buttonName)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Fgla.GlobalInviteWithLazyLoadedRelayProvider), {
            product: "confluence",
            showFlag: flags.showFlag
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.075",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
            label: "invite-button-icon"
        }), formatMessage($e836e779dfba9248$var$i18n.inviteTeammatesButtonText)));
        $[54] = buttonAppearance;
        $[55] = contentId;
        $[56] = contentMode;
        $[57] = contentType;
        $[58] = currentDialog;
        $[59] = flags;
        $[60] = formatMessage;
        $[61] = isNetworkDisabled;
        $[62] = onShare;
        $[63] = pageMode;
        $[64] = showInviteButton;
        $[65] = showSuggestedUsersDialog;
        $[66] = spaceKey;
        $[67] = translations;
        $[68] = t24;
    } else t24 = $[68];
    let t25;
    if ($[69] !== t22 || $[70] !== t23 || $[71] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            xcss: t22,
            alignInline: t23
        }, t24);
        $[69] = t22;
        $[70] = t23;
        $[71] = t24;
        $[72] = t25;
    } else t25 = $[72];
    let t26;
    if ($[73] !== T0 || $[74] !== t20 || $[75] !== t21 || $[76] !== t25 || $[77] !== testId) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            role: t17,
            "aria-label": t18,
            "aria-describedby": t19,
            testId: testId
        }, t20, t21, t25);
        $[73] = T0;
        $[74] = t20;
        $[75] = t21;
        $[76] = t25;
        $[77] = testId;
        $[78] = t26;
    } else t26 = $[78];
    return t26;
} : ({ contentMode: contentMode, contentId: contentId, contentType: contentType, onShareClick: onShareClick, spaceKey: spaceKey, flags: flags, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)(); // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override');
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const currentPickedPrincipalIds = (0, $42omo.useMemo)(()=>[
            userId ?? ''
        ], [
        userId
    ]);
    const { suggestedUsers: suggestedUsers, loading: loading, error: error } = (0, $59MXn.useUserSuggestions)({
        currentPickedPrincipalIds: currentPickedPrincipalIds,
        maxDisplayResults: 10,
        shouldFetchMoreResults: false,
        contextType: $e836e779dfba9248$var$CONTEXT_TYPE,
        siteId: cloudId,
        orgId: orgId,
        source: $e836e779dfba9248$export$1a6c31c631efc63f
    });
    const { data: restrictionsData, error: restrictionsError, loading: restrictionsLoading } = (0, $jMyy4.useQueryInterop)($e836e779dfba9248$var$SuggestedCollaboratorsDialogViewRestrictionsQuery, {
        variables: {
            contentId: contentId
        }
    }); // Check if the content has view restrictions or the parent content has view restrictions
    const hasViewRestrictions = !!(restrictionsData?.singleContent?.hasViewRestrictions || restrictionsData?.singleContent?.ancestors?.some((ancestor)=>{
        return ancestor?.hasViewRestrictions === true;
    })); // Skip invite query if there are suggested users and share button is enabled or has view restrictions
    const skipInviteQuery = Boolean(suggestedUsers?.length) && !isNetworkDisabled || hasViewRestrictions;
    const { data: inviteData, error: inviteError, loading: inviteLoading } = (0, $44cd4522c8b31e54$export$9ce937d1e3a4cc3d)({
        variables: {
            resourceARI: `ari:cloud:platform::site/${cloudId}`
        },
        skip: skipInviteQuery
    });
    const userRecommendations = (suggestedUsers || []).map((suggestion)=>{
        if (suggestion !== null) return {
            id: suggestion.id,
            name: suggestion.name,
            status: suggestion.type || '',
            picture: suggestion.avatarUrl || ''
        };
        return;
    });
    const suggestedUsersList = userRecommendations.filter((user)=>user !== undefined); // Determine if the user is in edit mode. Live pages supports both edit and view modes, so
    // we need to do an additional check to see if we're in edit mode on a live pages.
    const isInEditMode = contentMode === 'edit' || contentMode === 'live' && isLiveEditMode;
    const pageMode = isInEditMode ? 'edit' : 'view';
    const translations = $e836e779dfba9248$var$contentTypeToTranslationMap(formatMessage)[contentType === 'page' && contentMode === 'live' ? 'live' : contentType]; // Show suggested collaborator dialog if share button enabled, there are suggested collaborators, and the content has no view restrictions
    const showSuggestedUsersDialog = !isNetworkDisabled && !!suggestedUsersList?.length && !hasViewRestrictions;
    const buttonAppearance = showSuggestedUsersDialog ? 'subtle' : 'default';
    const showInviteButton = !inviteError && inviteData?.experimentalInvitePermissions?.directInviteMode === 'ANYONE';
    const getCurrentDialog = ()=>{
        if (showSuggestedUsersDialog) return 'suggestedCollaboratorsDialog';
        else if (showInviteButton) return 'noCollaboratorsInviteDialog';
        else if (!isNetworkDisabled) return 'noCollaboratorsShareDialog';
        return 'noCollaboratorsDefaultDialog';
    };
    const currentDialog = getCurrentDialog();
    const onShare = (0, $42omo.useCallback)((_)=>{
        if (onShareClick) {
            onShareClick('suggestedCollaboratorsDialog');
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'shareWithCollaboratorsButton',
                    source: currentDialog,
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        contentMode: contentMode
                    }
                }
            }).fire();
        }
    }, [
        onShareClick,
        contentId,
        contentType,
        contentMode,
        createAnalyticsEvent,
        currentDialog
    ]);
    const headerText = ()=>{
        if (showSuggestedUsersDialog) return formatMessage($e836e779dfba9248$var$i18n.suggestedCollaboratorsDescription);
        else if (showInviteButton) return translations.modalDescription;
        else if (!isNetworkDisabled) return formatMessage($e836e779dfba9248$var$i18n.noCollaboratorsCannotInviteDescription);
        else return formatMessage($e836e779dfba9248$var$i18n.noCollaboratorsCannotInviteCannotShareDescription);
    };
    (0, $42omo.useEffect)(()=>{
        if (!loading && !inviteLoading && !restrictionsLoading) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: currentDialog,
                attributes: {
                    contentMode: contentMode,
                    contentType: contentType,
                    contentId: contentId,
                    suggestedUsersCount: suggestedUsersList?.length
                }
            }
        }).fire();
    }, [
        loading,
        inviteLoading,
        restrictionsLoading,
        contentMode,
        contentType,
        contentId,
        suggestedUsersList,
        createAnalyticsEvent,
        currentDialog
    ]);
    if (loading || inviteLoading || restrictionsLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3MKHu.default), {
        isShimmering: true
    }), Array.from({
        length: $e836e779dfba9248$export$69a053f3e59d89f9
    }).map((__0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cQDYl.default), {
            key: `skeleton-item-${index}`,
            testId: `skeleton-item-${index}`,
            hasAvatar: true,
            isShimmering: true
        })));
    const queryError = error || inviteError || restrictionsError; // Only firing event for inviteError as we don't have an easy way to track these errors and attribute them to our experiment yet
    if (inviteError) createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            source: $e836e779dfba9248$export$1a6c31c631efc63f,
            action: 'errored',
            actionSubject: 'suggestedCollaboratorsDialogInviteQuery',
            attributes: {
                contentId: contentId,
                contentMode: contentMode,
                contentType: contentType,
                error: inviteError,
                message: inviteError?.message
            }
        }
    }).fire();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        role: "dialog",
        // eslint-disable-next-line no-restricted-syntax
        "aria-label": "suggested-collaborators-dialog",
        "aria-describedby": "suggested-collaborators-modal-description",
        testId: testId
    }, queryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: queryError
    }), showSuggestedUsersDialog ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e836e779dfba9248$var$styles.suggestedUsersDialogHeaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gBbsI.default), null, headerText())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $44e7bef026954ee8$export$dc33254bc906439c), {
        contentId: contentId,
        contentType: contentType,
        contentMode: pageMode,
        pageMode: pageMode,
        suggestedUsers: suggestedUsersList
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e836e779dfba9248$var$styles.generalHeaderStyles,
        id: "suggested-collaborators-modal-description"
    }, headerText()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        xcss: showSuggestedUsersDialog ? $e836e779dfba9248$var$styles.suggestedUsersDialogFooterStyles : $e836e779dfba9248$var$styles.generalDialogFooterStyles,
        alignInline: showSuggestedUsersDialog ? 'start' : 'end'
    }, showSuggestedUsersDialog || !showInviteButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hkzol.CopyLinkButton), {
        buttonAppearance: buttonAppearance,
        buttonText: formatMessage($e836e779dfba9248$var$i18n.copyLinkButtonText),
        contentId: contentId,
        contentType: contentType,
        pageMode: pageMode,
        spaceKey: spaceKey,
        source: "suggestedCollaboratorsDialog",
        onClickAttributes: {
            contentId: contentId,
            contentMode: contentMode,
            contentType: contentType,
            dialogSelected: currentDialog
        }
    }), !isNetworkDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($9M4aB))),
        testId: "open-share-dialog",
        onClick: onShare,
        appearance: buttonAppearance
    }, showSuggestedUsersDialog ? formatMessage($e836e779dfba9248$var$i18n.moreShareOptionsButtonText) : translations.buttonName)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Fgla.GlobalInviteWithLazyLoadedRelayProvider), {
        product: "confluence",
        showFlag: flags.showFlag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.075",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
        label: "invite-button-icon"
    }), formatMessage($e836e779dfba9248$var$i18n.inviteTeammatesButtonText)))));
};
const $e836e779dfba9248$export$77e0ff796ca95372 = (0, $7aRa9.withFlags)($e836e779dfba9248$export$cf7ccee4467197b8);
function $e836e779dfba9248$var$_temp(ancestor) {
    return ancestor?.hasViewRestrictions === true;
}
function $e836e779dfba9248$var$_temp2(suggestion) {
    if (suggestion !== null) return {
        id: suggestion.id,
        name: suggestion.name,
        status: suggestion.type || "",
        picture: suggestion.avatarUrl || ""
    };
}
function $e836e779dfba9248$var$_temp3(user) {
    return user !== undefined;
}
function $e836e779dfba9248$var$_temp4(__0, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cQDYl.default), {
        key: `skeleton-item-${index}`,
        testId: `skeleton-item-${index}`,
        hasAvatar: true,
        isShimmering: true
    });
}

























var $h3X17 = parcelRequire("h3X17");


var $kDhla = parcelRequire("kDhla");


var $e4o8D = parcelRequire("e4o8D");








const $99b335d011a83318$var$getTelepointerEl = (sessionId)=>{
    return document.querySelector(`[${(0, $h3X17.TELEPOINTER_DATA_SESSION_ID_ATTR)}="${sessionId}"]`);
};
const $99b335d011a83318$export$3e8e4ca69eec4635 = ({ contentType: contentType, contentMode: contentMode, participant: participant })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(true);
    const [{ fullPageEditorPresetAPI: fullPageEditorPresetAPI }] = (0, $kDhla.useFullPageEditorApi)();
    // TODO: https://product-fabric.atlassian.net/browse/MDS-1320
    const participantSessions = participant?.sessions ?? {};
    const [activeTelepointer] = (0, $2960af57d9597263$export$f1a08937c1f9340b)(participantSessions);
    const activeTelepointerPos = activeTelepointer?.selection.head;
    const activeSessionId = activeTelepointer?.sessionId;
    const sessionData = participantSessions[activeSessionId];
    const telepointerEl = isServerPlaceholder ? null : $99b335d011a83318$var$getTelepointerEl(activeSessionId);
    // Keep the optional chaning until we have a stricter "PresenceSessionData"
    const activity = sessionData?.activity;
    const isScrollToFeatureEnabled = // This feature is only available for live docs (for "editing" users), and pages and blogposts in edit mode
    ((contentType === 'page' || contentType === 'blogpost') && contentMode === 'edit' || contentMode === 'live' && activity !== 'viewer') && // Current user won't have the onClick handler for scroll
    !participant?.isCurrentUser;
    const isEligibleToScroll = isScrollToFeatureEnabled && // This is to filter out cases like where we have a user but no telepointer data; e.g. no focus on the doc
    activeTelepointerPos !== undefined && activeSessionId !== undefined && // Even if we have telepointer data, that doesn't guarantee the telepointer will be in the DOM.
    // e.g. platform_editor_no_telecursor_on_live_doc_init,
    telepointerEl !== null;
    const observerRef = (0, $42omo.useRef)(null);
    const timeoutRef = (0, $42omo.useRef)(null);
    const killObserver = ()=>{
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // Abort ongoing experience in case it's stuck in an unexpected state
            const expState = experienceTracker.getExperienceState((0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE));
            if (expState?.attributes?.sessionId === activeSessionId && !expState?.hasStopped) experienceTracker.abort({
                name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
                reason: 'useScrollToTelepointer unmounted'
            });
        };
    }, [
        activeSessionId,
        experienceTracker
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            killObserver();
        };
    }, []);
    const scrollToTelepointer = (0, $42omo.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
            attributes: {
                contentType: contentType,
                contentMode: contentMode,
                sessionId: activeSessionId,
                activity: activity
            }
        });
        try {
            killObserver();
            const scrollToPos = fullPageEditorPresetAPI?.core.actions.scrollToPos;
            const nudgeTelepointer = fullPageEditorPresetAPI?.collabEdit?.commands.nudgeTelepointer;
            if (!isEligibleToScroll || !scrollToPos) {
                experienceTracker.fail({
                    name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
                    error: new Error('Eligibility checks failed'),
                    attributes: {
                        isEligibleToScroll: isEligibleToScroll,
                        isScrollToPosDefined: scrollToPos !== undefined
                    }
                });
                return false;
            }
            const isScrollSuccessful = scrollToPos(Number(activeTelepointerPos), {
                behavior: 'smooth',
                block: 'center'
            });
            if (isScrollSuccessful && nudgeTelepointer && telepointerEl !== null) {
                // We don't run this callback in SSR, so no need to escape it with an isSSR check
                // eslint-disable-next-line no-restricted-syntax
                observerRef.current = new IntersectionObserver(([entry])=>{
                    if (entry.isIntersecting) {
                        fullPageEditorPresetAPI?.core.actions.execute(nudgeTelepointer(activeSessionId));
                        killObserver();
                    }
                });
                observerRef.current.observe(telepointerEl);
                // Edge case: Set a timeout to disconnect the observer if intersection doesn't happen
                // 5000ms is an arbitrary time and can be reduced.
                timeoutRef.current = setTimeout(()=>{
                    killObserver();
                }, 5000);
            }
            if (!isScrollSuccessful) experienceTracker.fail({
                name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
                error: new Error('Scroll is not successful'),
                attributes: {
                    isNudgeTelepointerDefined: nudgeTelepointer !== undefined,
                    hasValidTelepointerElement: telepointerEl !== null
                }
            });
            else experienceTracker.succeed({
                name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE)
            });
            return isScrollSuccessful;
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
                error: error
            });
            return false;
        }
    }, [
        activeSessionId,
        activeTelepointerPos,
        activity,
        contentMode,
        contentType,
        fullPageEditorPresetAPI,
        experienceTracker,
        isEligibleToScroll,
        telepointerEl
    ]);
    return {
        isScrollToFeatureEnabled: isScrollToFeatureEnabled,
        isEligibleToScroll: isEligibleToScroll,
        scrollToTelepointer: scrollToTelepointer
    };
};














var $gtD4K = parcelRequire("gtD4K");







var $3gadb = parcelRequire("3gadb");









const $09acd215ab95c7d5$var$i18n = (0, $cgtv4.defineMessages)({
    editing: {
        id: "team-presence.menu.editing",
        defaultMessage: "Editing"
    },
    viewing: {
        id: "team-presence.menu.viewing",
        defaultMessage: "Viewing"
    },
    clickToFind: {
        id: "team-presence.menu.click-to-find",
        defaultMessage: "Click to find"
    },
    clickToFindNotAvailable: {
        id: "team-presence.menu.click-to-find-not-available",
        defaultMessage: "Inactive"
    },
    clickToFollow: {
        id: "team-presence.menu.click-to-follow",
        defaultMessage: "Click to follow"
    }
});
const $09acd215ab95c7d5$var$containerStyles = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $09acd215ab95c7d5$var$avatarBadgeStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    bottom: '-2px',
    right: '-2px',
    height: '12px',
    width: '12px',
    borderRadius: 'radius.small',
    color: 'color.text.inverse',
    // TODO: This will need to be swapped for the foregroundColor, based on sessionId
    boxShadow: 'elevation.shadow.overflow',
    fontWeight: 'font.weight.semibold',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '10px',
    zIndex: 'card',
    userSelect: 'none'
});
const $09acd215ab95c7d5$var$tooltipTextStyles = (0, $ecnYn.xcss)({
    textAlign: 'center'
});
const $09acd215ab95c7d5$var$EditorAvatarBadge = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { borderColor: backgroundColor, badgeTextColor: badgeTextColor, name: name } = t0;
    let t1;
    if ($[0] !== name) {
        t1 = name?.substring(0, 1);
        $[0] = name;
        $[1] = t1;
    } else t1 = $[1];
    const firstInitial = t1;
    const t2 = backgroundColor;
    const t3 = badgeTextColor;
    let t4;
    if ($[2] !== t2 || $[3] !== t3) {
        t4 = (0, $ecnYn.xcss)({
            backgroundColor: t2,
            color: t3
        });
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t4) {
        t5 = [
            $09acd215ab95c7d5$var$avatarBadgeStyles,
            t4
        ];
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== firstInitial) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "editor-avatar-badge-initial",
            as: "span"
        }, firstInitial);
        $[7] = firstInitial;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== t5 || $[10] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            testId: "editor-avatar-badge",
            alignItems: "center",
            justifyContent: "center",
            xcss: t5
        }, t6);
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : ({ borderColor: backgroundColor, badgeTextColor: badgeTextColor, name: name })=>{
    const firstInitial = name?.substring(0, 1);
    /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/design-system/consistent-css-prop-usage,@atlaskit/ui-styling-standard/no-unsafe-values */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        testId: "editor-avatar-badge",
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            $09acd215ab95c7d5$var$avatarBadgeStyles,
            (0, $ecnYn.xcss)({
                backgroundColor: backgroundColor,
                color: badgeTextColor
            })
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "editor-avatar-badge-initial",
        as: "span"
    }, firstInitial));
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/design-system/consistent-css-prop-usage,@atlaskit/ui-styling-standard/no-unsafe-values */ };
const $09acd215ab95c7d5$var$TooltipText = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $09acd215ab95c7d5$var$tooltipTextStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $09acd215ab95c7d5$var$tooltipTextStyles
    }, children);
const $09acd215ab95c7d5$export$9b9667d767e90372 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(44);
    let avatarProps;
    let contentType;
    let isEligibleToScroll;
    let isScrollToFeatureEnabled;
    let participant;
    if ($[0] !== t0) {
        const { contentMode: contentMode, contentId: contentId, contentType: t1, isEligibleToScroll: t2, isScrollToFeatureEnabled: t3, participant: t4, ...t5 } = t0;
        contentType = t1;
        isEligibleToScroll = t2;
        isScrollToFeatureEnabled = t3;
        participant = t4;
        avatarProps = t5;
        $[0] = t0;
        $[1] = avatarProps;
        $[2] = contentType;
        $[3] = isEligibleToScroll;
        $[4] = isScrollToFeatureEnabled;
        $[5] = participant;
    } else {
        avatarProps = $[1];
        contentType = $[2];
        isEligibleToScroll = $[3];
        isScrollToFeatureEnabled = $[4];
        participant = $[5];
    }
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { activity: activity, color: participantColor, isCurrentUser: isCurrentUser, name: name, src: src } = participant;
    let t1;
    if ($[6] !== activity || $[7] !== formatMessage) {
        t1 = activity === "editor" ? formatMessage($09acd215ab95c7d5$var$i18n.editing) : formatMessage($09acd215ab95c7d5$var$i18n.viewing);
        $[6] = activity;
        $[7] = formatMessage;
        $[8] = t1;
    } else t1 = $[8];
    const activityText = t1;
    let t2;
    if ($[9] !== activityText || $[10] !== contentType || $[11] !== name) {
        t2 = (0, $6bda54ffb0f4283a$export$ea7ca1acbbc07168)(contentType) ? name : `${name} (${activityText})`;
        $[9] = activityText;
        $[10] = contentType;
        $[11] = name;
        $[12] = t2;
    } else t2 = $[12];
    const label = t2;
    let t3;
    if ($[13] !== isCurrentUser || $[14] !== participant.id) {
        t3 = isCurrentUser ? (0, $6bda54ffb0f4283a$export$fecb54e21647ae4f)() : (0, $6bda54ffb0f4283a$export$2fbd87a2176aa7cf)(participant.id);
        $[13] = isCurrentUser;
        $[14] = participant.id;
        $[15] = t3;
    } else t3 = $[15];
    const colors = t3;
    const borderColor = participantColor ?? colors.backgroundColor;
    const shouldShowClickToFollow = !isCurrentUser && contentType === "whiteboard" && participant.followCursor;
    const shouldShowClickToFind = Boolean(isScrollToFeatureEnabled) && participant.activity !== "viewer";
    let t4;
    if ($[16] !== label) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09acd215ab95c7d5$var$TooltipText, null, label);
        $[16] = label;
        $[17] = t4;
    } else t4 = $[17];
    let t5;
    if ($[18] !== shouldShowClickToFollow) {
        t5 = shouldShowClickToFollow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09acd215ab95c7d5$var$TooltipText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $09acd215ab95c7d5$var$i18n.clickToFollow));
        $[18] = shouldShowClickToFollow;
        $[19] = t5;
    } else t5 = $[19];
    let t6;
    if ($[20] !== isEligibleToScroll || $[21] !== shouldShowClickToFind) {
        t6 = shouldShowClickToFind && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            justifyContent: "center"
        }, Boolean(isEligibleToScroll) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $09acd215ab95c7d5$var$i18n.clickToFind) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $09acd215ab95c7d5$var$i18n.clickToFindNotAvailable));
        $[20] = isEligibleToScroll;
        $[21] = shouldShowClickToFind;
        $[22] = t6;
    } else t6 = $[22];
    let t7;
    if ($[23] !== t4 || $[24] !== t5 || $[25] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t4, t5, t6);
        $[23] = t4;
        $[24] = t5;
        $[25] = t6;
        $[26] = t7;
    } else t7 = $[26];
    let t8;
    if ($[27] !== avatarProps || $[28] !== borderColor || $[29] !== label || $[30] !== name || $[31] !== src) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            ...avatarProps,
            appearance: "circle",
            borderColor: borderColor,
            label: label,
            name: name,
            size: "small",
            src: src
        });
        $[27] = avatarProps;
        $[28] = borderColor;
        $[29] = label;
        $[30] = name;
        $[31] = src;
        $[32] = t8;
    } else t8 = $[32];
    let t9;
    if ($[33] !== activity || $[34] !== borderColor || $[35] !== colors || $[36] !== name) {
        t9 = activity === "editor" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09acd215ab95c7d5$var$EditorAvatarBadge, {
            borderColor: borderColor,
            badgeTextColor: colors.textColor,
            name: name
        });
        $[33] = activity;
        $[34] = borderColor;
        $[35] = colors;
        $[36] = name;
        $[37] = t9;
    } else t9 = $[37];
    let t10;
    if ($[38] !== t8 || $[39] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            direction: "column",
            alignItems: "center",
            gap: "space.0",
            xcss: $09acd215ab95c7d5$var$containerStyles
        }, t8, t9);
        $[38] = t8;
        $[39] = t9;
        $[40] = t10;
    } else t10 = $[40];
    let t11;
    if ($[41] !== t10 || $[42] !== t7) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t7
        }, t10);
        $[41] = t10;
        $[42] = t7;
        $[43] = t11;
    } else t11 = $[43];
    return t11;
} : ({ contentMode: contentMode, contentId: contentId, contentType: contentType, isEligibleToScroll: isEligibleToScroll, isScrollToFeatureEnabled: isScrollToFeatureEnabled, participant: participant, ...avatarProps })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { activity: activity, color: participantColor, isCurrentUser: isCurrentUser, name: name, src: src } = participant;
    const activityText = activity === 'editor' ? formatMessage($09acd215ab95c7d5$var$i18n.editing) : formatMessage($09acd215ab95c7d5$var$i18n.viewing);
    const label = (0, $6bda54ffb0f4283a$export$ea7ca1acbbc07168)(contentType) ? name : `${name} (${activityText})`;
    const colors = isCurrentUser ? (0, $6bda54ffb0f4283a$export$fecb54e21647ae4f)() : (0, $6bda54ffb0f4283a$export$2fbd87a2176aa7cf)(participant.id);
    const borderColor = participantColor ?? colors.backgroundColor;
    const shouldShowClickToFollow = !isCurrentUser && contentType === 'whiteboard' && participant.followCursor;
    const shouldShowClickToFind = Boolean(isScrollToFeatureEnabled) && participant.activity !== 'viewer';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09acd215ab95c7d5$var$TooltipText, null, label), shouldShowClickToFollow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09acd215ab95c7d5$var$TooltipText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $09acd215ab95c7d5$var$i18n.clickToFollow)), shouldShowClickToFind && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            justifyContent: "center"
        }, Boolean(isEligibleToScroll) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $09acd215ab95c7d5$var$i18n.clickToFind) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $09acd215ab95c7d5$var$i18n.clickToFindNotAvailable)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "column",
        alignItems: "center",
        gap: "space.0",
        xcss: $09acd215ab95c7d5$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        ...avatarProps,
        appearance: "circle",
        borderColor: borderColor,
        label: label,
        name: name,
        size: "small",
        src: src
    }), activity === 'editor' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($09acd215ab95c7d5$var$EditorAvatarBadge, {
        borderColor: borderColor,
        badgeTextColor: colors.textColor,
        name: name
    })));
};


const $f0ec2e1e638ea1ae$export$5baa88db8a182af5 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(34);
    const { index: index, participant: participant, contentMode: contentMode, contentType: contentType, contentId: contentId, isSingleParticipant: isSingleParticipant, isEligibleForEmptyPresenceDialog: isEligibleForEmptyPresenceDialog, toggleEmptyPresenceDialog: toggleEmptyPresenceDialog, avatarProps: avatarProps, analyticSource: analyticSource } = t0;
    const { id: id } = participant;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const t1 = participant;
    let t2;
    if ($[0] !== contentMode || $[1] !== contentType || $[2] !== t1) {
        t2 = {
            contentType: contentType,
            contentMode: contentMode,
            participant: t1
        };
        $[0] = contentMode;
        $[1] = contentType;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const { isScrollToFeatureEnabled: isScrollToFeatureEnabled, isEligibleToScroll: isEligibleToScroll, scrollToTelepointer: scrollToTelepointer } = (0, $99b335d011a83318$export$3e8e4ca69eec4635)(t2);
    let t3;
    if ($[4] !== analyticSource || $[5] !== contentId || $[6] !== contentMode || $[7] !== contentType || $[8] !== createAnalyticsEvent || $[9] !== isEligibleForEmptyPresenceDialog || $[10] !== isEligibleToScroll || $[11] !== isScrollToFeatureEnabled || $[12] !== isSingleParticipant || $[13] !== participant.onClick || $[14] !== scrollToTelepointer || $[15] !== toggleEmptyPresenceDialog) {
        t3 = ()=>{
            if (isSingleParticipant) return isEligibleForEmptyPresenceDialog ? toggleEmptyPresenceDialog : undefined;
            if (isEligibleToScroll) return ()=>{
                const isScrollSuccessful = scrollToTelepointer();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        source: analyticSource,
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "presenceAvatarButton",
                        product: "confluence",
                        attributes: {
                            contentId: contentId,
                            contentType: contentType,
                            contentMode: contentMode,
                            isScrollToFeatureEnabled: isScrollToFeatureEnabled,
                            isEligibleToScroll: isEligibleToScroll,
                            isScrollSuccessful: isScrollSuccessful
                        }
                    }
                }).fire();
            };
            return participant?.onClick;
        };
        $[4] = analyticSource;
        $[5] = contentId;
        $[6] = contentMode;
        $[7] = contentType;
        $[8] = createAnalyticsEvent;
        $[9] = isEligibleForEmptyPresenceDialog;
        $[10] = isEligibleToScroll;
        $[11] = isScrollToFeatureEnabled;
        $[12] = isSingleParticipant;
        $[13] = participant.onClick;
        $[14] = scrollToTelepointer;
        $[15] = toggleEmptyPresenceDialog;
        $[16] = t3;
    } else t3 = $[16];
    const getAvatarButtonOnClickHandler = t3;
    const t4 = `box-${id}`;
    const t5 = `avatar-${id}`;
    const t6 = (0, $6bda54ffb0f4283a$export$dd4b75f1a6268a6b) - index;
    const t7 = `team-presence-avatar-${index}`;
    let t8;
    if ($[17] !== getAvatarButtonOnClickHandler) {
        t8 = getAvatarButtonOnClickHandler();
        $[17] = getAvatarButtonOnClickHandler;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== avatarProps || $[20] !== contentId || $[21] !== contentMode || $[22] !== contentType || $[23] !== isEligibleToScroll || $[24] !== isScrollToFeatureEnabled || $[25] !== participant || $[26] !== t5 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $09acd215ab95c7d5$export$9b9667d767e90372), {
            ...avatarProps,
            participant: participant,
            contentId: contentId,
            contentMode: contentMode,
            contentType: contentType,
            key: t5,
            stackIndex: t6,
            testId: t7,
            onClick: t8,
            isEligibleToScroll: isEligibleToScroll,
            isScrollToFeatureEnabled: isScrollToFeatureEnabled
        });
        $[19] = avatarProps;
        $[20] = contentId;
        $[21] = contentMode;
        $[22] = contentType;
        $[23] = isEligibleToScroll;
        $[24] = isScrollToFeatureEnabled;
        $[25] = participant;
        $[26] = t5;
        $[27] = t6;
        $[28] = t7;
        $[29] = t8;
        $[30] = t9;
    } else t9 = $[30];
    let t10;
    if ($[31] !== t4 || $[32] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            padding: (0, $9wGTI.fg)("platform-avatar-group-spacing-fix") ? "space.0" : "space.025",
            key: t4,
            "data-vc": "presence-avatar"
        }, t9);
        $[31] = t4;
        $[32] = t9;
        $[33] = t10;
    } else t10 = $[33];
    return t10;
} : ({ index: index, participant: participant, contentMode: contentMode, contentType: contentType, contentId: contentId, isSingleParticipant: isSingleParticipant, isEligibleForEmptyPresenceDialog: isEligibleForEmptyPresenceDialog, toggleEmptyPresenceDialog: toggleEmptyPresenceDialog, avatarProps: avatarProps, analyticSource: analyticSource })=>{
    const { id: id } = participant;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isScrollToFeatureEnabled: isScrollToFeatureEnabled, isEligibleToScroll: isEligibleToScroll, scrollToTelepointer: scrollToTelepointer } = (0, $99b335d011a83318$export$3e8e4ca69eec4635)({
        contentType: contentType,
        contentMode: contentMode,
        // TODO: https://product-fabric.atlassian.net/browse/MDS-1320
        participant: participant
    });
    const getAvatarButtonOnClickHandler = ()=>{
        if (isSingleParticipant) return isEligibleForEmptyPresenceDialog ? toggleEmptyPresenceDialog : undefined;
        if (isEligibleToScroll) return ()=>{
            const isScrollSuccessful = scrollToTelepointer();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: analyticSource,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'presenceAvatarButton',
                    product: 'confluence',
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        contentMode: contentMode,
                        isScrollToFeatureEnabled: isScrollToFeatureEnabled,
                        isEligibleToScroll: isEligibleToScroll,
                        isScrollSuccessful: isScrollSuccessful
                    }
                }
            }).fire();
        };
        return participant?.onClick;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: (0, $9wGTI.fg)('platform-avatar-group-spacing-fix') ? 'space.0' : 'space.025',
        key: `box-${id}`,
        "data-vc": "presence-avatar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $09acd215ab95c7d5$export$9b9667d767e90372), {
        ...avatarProps,
        participant: participant,
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        key: `avatar-${id}`,
        stackIndex: (0, $6bda54ffb0f4283a$export$dd4b75f1a6268a6b) - index,
        testId: `team-presence-avatar-${index}`,
        onClick: getAvatarButtonOnClickHandler(),
        isEligibleToScroll: isEligibleToScroll,
        isScrollToFeatureEnabled: isScrollToFeatureEnabled
    }));
};














var $56M4r = parcelRequire("56M4r");






















var $gMc0m = parcelRequire("gMc0m");













var $5nBzc = parcelRequire("5nBzc");












var $9fywD = parcelRequire("9fywD");




const $3483060680d51265$var$i18n = (0, $cgtv4.defineMessages)({
    editing: {
        id: "team-presence.menu.editing",
        defaultMessage: "Editing"
    },
    viewing: {
        id: "team-presence.menu.viewing",
        defaultMessage: "Viewing"
    },
    you: {
        id: "team-presence.menu.current-user.marker",
        defaultMessage: "You"
    },
    clickToFind: {
        id: "team-presence.menu-item.click-to-find",
        defaultMessage: "Click to find"
    },
    clickToFindNotAvailable: {
        id: "team-presence.menu-item.click-to-find-not-available",
        defaultMessage: "Inactive"
    },
    clickToFollow: {
        id: "team-presence.menu-item.click-to-follow",
        defaultMessage: "Click to follow"
    }
});
const $3483060680d51265$var$DESCRIPTION_SEPARATOR = ' - ';
const $3483060680d51265$var$hiddenStyle = (0, $ecnYn.xcss)({
    visibility: 'hidden'
});
const $3483060680d51265$var$visibleStyle = (0, $ecnYn.xcss)({
    visibility: 'visible'
}); // so we don't shift on hover https://www.loom.com/share/badb59b0bdcc44dea5215671c280e751
const $3483060680d51265$var$buttonItemStyle = null;
const $3483060680d51265$export$e2b8ad06fb5a352f = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(59);
    const { participant: participant, contentMode: contentMode, contentId: contentId, contentType: contentType, isCurrentUser: isCurrentUser } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const t1 = participant;
    let t2;
    if ($[0] !== contentMode || $[1] !== contentType || $[2] !== t1) {
        t2 = {
            contentType: contentType,
            contentMode: contentMode,
            participant: t1
        };
        $[0] = contentMode;
        $[1] = contentType;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const { isScrollToFeatureEnabled: isScrollToFeatureEnabled, isEligibleToScroll: isEligibleToScroll, scrollToTelepointer: scrollToTelepointer } = (0, $99b335d011a83318$export$3e8e4ca69eec4635)(t2);
    const isAnonymous = participant.userId === "unidentified";
    const hasOnClickEvent = isEligibleToScroll || Boolean(participant.onClick);
    const [isHovered, setHover] = (0, $42omo.useState)(false);
    const shouldShowClickToFind = isScrollToFeatureEnabled && participant.activity !== "viewer";
    const shouldShowClickToFollow = contentType === "whiteboard" && participant.followCursor && isHovered;
    let t3;
    if ($[4] !== contentId || $[5] !== contentMode || $[6] !== contentType || $[7] !== createAnalyticsEvent || $[8] !== hasOnClickEvent || $[9] !== isEligibleToScroll || $[10] !== isScrollToFeatureEnabled || $[11] !== participant || $[12] !== scrollToTelepointer) {
        t3 = ()=>{
            let isScrollSuccessful = false;
            if (isEligibleToScroll) isScrollSuccessful = scrollToTelepointer();
            if (participant.onClick) participant.onClick();
            if (hasOnClickEvent) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    product: "confluence",
                    source: "presenceMenu",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "presenceMenuItem",
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        contentMode: contentMode,
                        isScrollToFeatureEnabled: isScrollToFeatureEnabled,
                        isEligibleToScroll: isEligibleToScroll,
                        isScrollSuccessful: isScrollSuccessful
                    }
                }
            }).fire();
        };
        $[4] = contentId;
        $[5] = contentMode;
        $[6] = contentType;
        $[7] = createAnalyticsEvent;
        $[8] = hasOnClickEvent;
        $[9] = isEligibleToScroll;
        $[10] = isScrollToFeatureEnabled;
        $[11] = participant;
        $[12] = scrollToTelepointer;
        $[13] = t3;
    } else t3 = $[13];
    const handleClick = t3;
    let t4;
    if ($[14] !== contentType || $[15] !== isScrollToFeatureEnabled) {
        t4 = ()=>{
            if (isScrollToFeatureEnabled || contentType === "whiteboard") setHover(true);
        };
        $[14] = contentType;
        $[15] = isScrollToFeatureEnabled;
        $[16] = t4;
    } else t4 = $[16];
    const handleFocus = t4;
    let t5;
    if ($[17] !== contentType || $[18] !== isScrollToFeatureEnabled) {
        t5 = ()=>{
            if (isScrollToFeatureEnabled || contentType === "whiteboard") setHover(false);
        };
        $[17] = contentType;
        $[18] = isScrollToFeatureEnabled;
        $[19] = t5;
    } else t5 = $[19];
    const handleBlur = t5;
    let t6;
    if ($[20] !== contentId || $[21] !== contentMode || $[22] !== contentType || $[23] !== isEligibleToScroll || $[24] !== participant) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $09acd215ab95c7d5$export$9b9667d767e90372), {
            testId: "team-presence-menu-item-avatar",
            participant: participant,
            contentMode: contentMode,
            contentId: contentId,
            contentType: contentType,
            isEligibleToScroll: isEligibleToScroll
        });
        $[20] = contentId;
        $[21] = contentMode;
        $[22] = contentType;
        $[23] = isEligibleToScroll;
        $[24] = participant;
        $[25] = t6;
    } else t6 = $[25];
    let t7;
    if ($[26] !== contentType || $[27] !== participant.activity) {
        t7 = !(0, $6bda54ffb0f4283a$export$ea7ca1acbbc07168)(contentType) && (participant.activity === "editor" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3483060680d51265$var$i18n.editing) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3483060680d51265$var$i18n.viewing));
        $[26] = contentType;
        $[27] = participant.activity;
        $[28] = t7;
    } else t7 = $[28];
    let t8;
    if ($[29] !== shouldShowClickToFollow) {
        t8 = shouldShowClickToFollow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3483060680d51265$var$i18n.clickToFollow));
        $[29] = shouldShowClickToFollow;
        $[30] = t8;
    } else t8 = $[30];
    let t9;
    if ($[31] !== isEligibleToScroll || $[32] !== isHovered || $[33] !== shouldShowClickToFind) {
        t9 = shouldShowClickToFind && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            as: "span",
            xcss: isHovered ? $3483060680d51265$var$visibleStyle : $3483060680d51265$var$hiddenStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "aria-hidden": "true"
        }, $3483060680d51265$var$DESCRIPTION_SEPARATOR), isEligibleToScroll ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3483060680d51265$var$i18n.clickToFind) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3483060680d51265$var$i18n.clickToFindNotAvailable));
        $[31] = isEligibleToScroll;
        $[32] = isHovered;
        $[33] = shouldShowClickToFind;
        $[34] = t9;
    } else t9 = $[34];
    let t10;
    if ($[35] !== t7 || $[36] !== t8 || $[37] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t7, t8, t9);
        $[35] = t7;
        $[36] = t8;
        $[37] = t9;
        $[38] = t10;
    } else t10 = $[38];
    let t11;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $gMc0m.default)([
            "_4t3i1ex1"
        ]);
        $[39] = t11;
    } else t11 = $[39];
    let t12;
    if ($[40] !== participant.isGuest) {
        t12 = participant.isGuest && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9fywD.ExternalUserLozenge), null);
        $[40] = participant.isGuest;
        $[41] = t12;
    } else t12 = $[41];
    let t13;
    if ($[42] !== contentType || $[43] !== isAnonymous || $[44] !== isCurrentUser) {
        t13 = isCurrentUser && isAnonymous && contentType !== "whiteboard" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "inprogress"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3483060680d51265$var$i18n.you));
        $[42] = contentType;
        $[43] = isAnonymous;
        $[44] = isCurrentUser;
        $[45] = t13;
    } else t13 = $[45];
    let t14;
    if ($[46] !== participant.name || $[47] !== t12 || $[48] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "baseline",
            gap: "space.050",
            direction: "row"
        }, participant.name, t12, t13);
        $[46] = participant.name;
        $[47] = t12;
        $[48] = t13;
        $[49] = t14;
    } else t14 = $[49];
    let t15;
    if ($[50] !== handleClick || $[51] !== t10 || $[52] !== t14 || $[53] !== t6) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
            onClick: handleClick,
            testId: "team-presence-menu-item",
            "data-vc": "team-presence-menu-item",
            iconBefore: t6,
            description: t10,
            className: t11
        }, t14);
        $[50] = handleClick;
        $[51] = t10;
        $[52] = t14;
        $[53] = t6;
        $[54] = t15;
    } else t15 = $[54];
    let t16;
    if ($[55] !== handleBlur || $[56] !== handleFocus || $[57] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            onMouseEnter: handleFocus,
            onFocus: handleFocus,
            onMouseLeave: handleBlur,
            onBlur: handleBlur
        }, t15);
        $[55] = handleBlur;
        $[56] = handleFocus;
        $[57] = t15;
        $[58] = t16;
    } else t16 = $[58];
    return t16;
} : ({ participant: participant, contentMode: contentMode, contentId: contentId, contentType: contentType, isCurrentUser: isCurrentUser })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isScrollToFeatureEnabled: isScrollToFeatureEnabled, isEligibleToScroll: isEligibleToScroll, scrollToTelepointer: scrollToTelepointer } = (0, $99b335d011a83318$export$3e8e4ca69eec4635)({
        contentType: contentType,
        contentMode: contentMode,
        // TODO: https://product-fabric.atlassian.net/browse/MDS-1320
        participant: participant
    });
    const isAnonymous = participant.userId === 'unidentified';
    const hasOnClickEvent = isEligibleToScroll || Boolean(participant.onClick); // A JS-based hover interaction is usually not preferred over pure CSS,
    // but since nested CSS selectors are discouraged (see the "no-nested-selectors" linting rule),
    // and we don’t have control over "ButtonItem", this seems to be the fastest valid solution for now.
    const [isHovered, setHover] = (0, $42omo.useState)(false);
    const shouldShowClickToFind = isScrollToFeatureEnabled && participant.activity !== 'viewer';
    const shouldShowClickToFollow = contentType === 'whiteboard' && participant.followCursor && isHovered;
    const handleClick = (0, $42omo.useCallback)(()=>{
        let isScrollSuccessful = false;
        if (isEligibleToScroll) isScrollSuccessful = scrollToTelepointer();
        if (participant.onClick) participant.onClick();
        if (hasOnClickEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: 'confluence',
                source: 'presenceMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'presenceMenuItem',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    contentMode: contentMode,
                    isScrollToFeatureEnabled: isScrollToFeatureEnabled,
                    isEligibleToScroll: isEligibleToScroll,
                    isScrollSuccessful: isScrollSuccessful
                }
            }
        }).fire();
    }, [
        participant,
        contentId,
        contentType,
        contentMode,
        isScrollToFeatureEnabled,
        isEligibleToScroll,
        hasOnClickEvent,
        scrollToTelepointer,
        createAnalyticsEvent
    ]);
    const handleFocus = ()=>{
        if (isScrollToFeatureEnabled || contentType === 'whiteboard') setHover(true);
    };
    const handleBlur = ()=>{
        if (isScrollToFeatureEnabled || contentType === 'whiteboard') setHover(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        onMouseEnter: handleFocus,
        onFocus: handleFocus,
        onMouseLeave: handleBlur,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
        onClick: handleClick,
        testId: "team-presence-menu-item",
        "data-vc": "team-presence-menu-item",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $09acd215ab95c7d5$export$9b9667d767e90372), {
            testId: "team-presence-menu-item-avatar",
            participant: participant,
            contentMode: contentMode,
            contentId: contentId,
            contentType: contentType,
            isEligibleToScroll: isEligibleToScroll
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !(0, $6bda54ffb0f4283a$export$ea7ca1acbbc07168)(contentType) && (participant.activity === 'editor' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3483060680d51265$var$i18n.editing) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3483060680d51265$var$i18n.viewing)), shouldShowClickToFollow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3483060680d51265$var$i18n.clickToFollow)), shouldShowClickToFind && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            as: "span",
            xcss: isHovered ? $3483060680d51265$var$visibleStyle : $3483060680d51265$var$hiddenStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "aria-hidden": "true"
        }, $3483060680d51265$var$DESCRIPTION_SEPARATOR), isEligibleToScroll ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3483060680d51265$var$i18n.clickToFind) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3483060680d51265$var$i18n.clickToFindNotAvailable))),
        className: (0, $gMc0m.default)([
            "_4t3i1ex1"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "baseline",
        gap: "space.050",
        direction: "row"
    }, participant.name, participant.isGuest && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9fywD.ExternalUserLozenge), null), isCurrentUser && isAnonymous && contentType !== 'whiteboard' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: "inprogress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3483060680d51265$var$i18n.you)))));
};


/** @graphql cc **/ 



var $hp2SH = parcelRequire("hp2SH");

/**
 * @generated SignedSource<<1572ce0446a2e9cccf843d977e760152>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $5122d2966a58efb2$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});


const $b8784dbce5e76a45$export$d67f835257d86b58 = (accountIds)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $eSUdr.default)`query fetchPresenceUsersGuestStatusQuery($accountIds:[String]){confluenceUsers(accountIds:$accountIds){nodes{...on KnownUser{accountId}...on UnknownUser{accountId}permissionType}}}`,
        variables: {
            accountIds: accountIds
        }
    }).then(({ data: data })=>{
        return data?.confluenceUsers?.nodes?.filter((user)=>user?.accountId).map((user)=>({
                userId: user?.accountId ?? '',
                // @ts-expect-error - TS2869 Typescript 5.9.2 upgrade
                isGuest: (user?.permissionType === (0, $5122d2966a58efb2$export$8995abb8169b2cb8).EXTERNAL) ?? undefined
            })) ?? [];
    });
};


'use no memo';
const $9f1d85818b4620e9$var$DEFAULT_PARTICIPANTS_TO_DISPLAY = 10;
const $9f1d85818b4620e9$var$DEFAULT_PARTICIPANTS_TO_REVEAL = 25;
const $9f1d85818b4620e9$var$i18n = (0, $cgtv4.defineMessages)({
    activeNowTitle: {
        id: "team-presence.presence-menu.active.title",
        defaultMessage: "{count, plural, =0 {Active now ({count})} one {Active now ({count})} other {Active now ({count})}}"
    },
    viewingNowTitle: {
        id: "team-presence.presence-menu.viewing.title",
        defaultMessage: "{count, plural, =0 {Viewing now ({count})} one {Viewing now ({count})} other {Viewing now ({count})}}"
    },
    editingNowTitle: {
        id: "team-presence.presence-menu.editing.title",
        defaultMessage: "{count, plural, =0 {Editing now ({count})} one {Editing now ({count})} other {Editing now ({count})}}"
    },
    loadMore: {
        id: "team-presence.presence-menu.load-more",
        defaultMessage: "Load More"
    }
});
const $9f1d85818b4620e9$var$SkeletonItems = ({ max: max, next: next })=>{
    const items = Array.from({
        length: Math.min(max, next)
    });
    return items.map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cQDYl.default), {
            key: `skeleton-item-${index}`,
            testId: "skeleton-item",
            hasAvatar: true,
            isShimmering: true
        }));
};
const $9f1d85818b4620e9$export$c5f53e9ee1a93ef8 = ({ contentId: contentId, contentMode: contentMode, contentType: contentType, participants: participants, totalParticipants: totalParticipants })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const [isInitial, setIsInitial] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(true);
    const [isLoadMoreClicked, setIsLoadMoreClicked] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const [isLoadingMore, setIsLoadingMore] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const guestStatus = (0, $42omo.useRef)(new Map());
    const participantsWithGuestStatus = participants.filter((it)=>guestStatus.current.has(it.id));
    const participantsWithoutGuestStatus = participants.filter((it_0)=>!guestStatus.current.has(it_0.id));
    const hasParticipantsWithoutGuestStatus = participantsWithoutGuestStatus.length > 0;
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'presenceMenu',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    contentMode: contentMode
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType,
        contentMode
    ]);
    (0, $42omo.useEffect)(()=>{
        const fetchGuestStatus = async ({ next: next })=>{
            setIsLoadingMore(true);
            const userIds = [];
            const anonymousIds = [];
            participantsWithoutGuestStatus.slice(0, next).forEach((participant)=>{
                if (!guestStatus.current.has(participant.id)) {
                    if (participant.userId === 'unidentified') anonymousIds.push(participant.id);
                    else userIds.push(// When the userId is in the format ari:cloud:identity::user/{userId}
                    // we need to extract the userId part
                    participant.userId.replace('ari:cloud:identity::user/', ''));
                }
            });
            if (userIds.length > 0) {
                if (!isLoggedIn || !isLicensed || isGuest) // If the user is not logged in, not licensed, or is a guest ... we don't show their guest status
                // so we just set the guest status to false for these participants.
                userIds.forEach((userId)=>{
                    const userARI = `ari:cloud:identity::user/${userId}`;
                    participants.filter((p)=>p.userId === userId || p.userId === userARI).forEach((p_0)=>guestStatus.current.set(p_0.id, false));
                });
                else {
                    // Whiteboards does not deduplicate users, we might want to force a
                    // unique on the list of participants to query
                    const users = await (0, $b8784dbce5e76a45$export$d67f835257d86b58)(userIds);
                    users.forEach((user)=>{
                        const userId_0 = user.userId;
                        const userARI_0 = `ari:cloud:identity::user/${userId_0}`;
                        participants.filter((p_1)=>p_1.userId === userId_0 || p_1.userId === userARI_0).forEach((p_2)=>guestStatus.current.set(p_2.id, user.isGuest));
                    });
                }
            }
            // If the participant is unidentified, we set their guest status to false
            // as anonymous users can't be guests
            anonymousIds.forEach((id)=>guestStatus.current.set(id, false));
            setIsLoadingMore(false);
            setIsInitial(false);
        };
        if ((isInitial || isLoadMoreClicked) && !isLoadingMore) {
            setIsLoadMoreClicked(false);
            fetchGuestStatus({
                next: isInitial ? $9f1d85818b4620e9$var$DEFAULT_PARTICIPANTS_TO_DISPLAY : $9f1d85818b4620e9$var$DEFAULT_PARTICIPANTS_TO_REVEAL
            });
        }
    }, [
        isGuest,
        isInitial,
        isLicensed,
        isLoadMoreClicked,
        isLoadingMore,
        isLoggedIn,
        participants,
        participantsWithoutGuestStatus
    ]);
    const handleOnLoadMoreClicked = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'presenceMenuWithGuestLoadMore',
                source: 'presenceMenuWithGuest',
                attributes: {
                    shown: participantsWithGuestStatus.length,
                    total: totalParticipants
                }
            }
        }).fire();
        setIsLoadMoreClicked(true);
    }, [
        createAnalyticsEvent,
        participantsWithGuestStatus,
        totalParticipants
    ]);
    const getHeaderTitle = (0, $42omo.useCallback)((count)=>{
        if (contentMode === 'edit' && (contentType === 'page' || contentType === 'blogpost')) return formatMessage($9f1d85818b4620e9$var$i18n.editingNowTitle, {
            count: count
        });
        else if (contentMode === 'view' && (contentType === 'page' || contentType === 'blogpost')) return formatMessage($9f1d85818b4620e9$var$i18n.viewingNowTitle, {
            count: count
        });
        else return formatMessage($9f1d85818b4620e9$var$i18n.activeNowTitle, {
            count: count
        });
    }, [
        contentMode,
        contentType,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), {
        maxHeight: 480,
        minWidth: 360,
        maxWidth: 360,
        testId: "presence-menu-group"
    }, participantsWithGuestStatus.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
        isScrollable: true,
        title: getHeaderTitle(totalParticipants),
        testId: "presence-menu-group-guest"
    }, participantsWithGuestStatus.map((participant_0, index)=>{
        const transformedParticipant = {
            ...participant_0,
            isGuest: guestStatus.current.get(participant_0.id) ?? false
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3483060680d51265$export$e2b8ad06fb5a352f), {
            contentId: contentId,
            contentType: contentType,
            contentMode: contentMode,
            key: `menu-item-${transformedParticipant.id.slice(6)}`,
            participant: transformedParticipant,
            isCurrentUser: transformedParticipant.isCurrentUser || index === 0
        });
    }), hasParticipantsWithoutGuestStatus && !isLoadingMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
        onClick: handleOnLoadMoreClicked
    }, formatMessage($9f1d85818b4620e9$var$i18n.loadMore)), hasParticipantsWithoutGuestStatus && isLoadingMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9f1d85818b4620e9$var$SkeletonItems, {
        max: $9f1d85818b4620e9$var$DEFAULT_PARTICIPANTS_TO_REVEAL,
        next: participantsWithoutGuestStatus.length
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3MKHu.default), {
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9f1d85818b4620e9$var$SkeletonItems, {
        max: $9f1d85818b4620e9$var$DEFAULT_PARTICIPANTS_TO_DISPLAY,
        next: participantsWithoutGuestStatus.length
    })));
};

























var $cDMVr = parcelRequire("cDMVr");










const $23b78b5e22057a83$var$i18n = (0, $cgtv4.defineMessages)({
    addPeopleLabel: {
        id: "team-presence.avatar-button.add-people-label",
        defaultMessage: "Add people to this {contentType}"
    },
    contentTypeLabel: {
        id: "team-presence.avatar-button.content-type-label",
        defaultMessage: "{contentType, select, page {page} blogpost {blog post} whiteboard {whiteboard} livepage {live doc} database {database} other {content}}"
    }
});
const $23b78b5e22057a83$var$iconButtonStyles = (0, $ecnYn.xcss)({
    marginInlineEnd: 'space.0',
    marginInlineStart: 'space.negative.050'
});
const $23b78b5e22057a83$var$iconButtonLegacyMarginStyles = (0, $ecnYn.xcss)({
    marginInlineEnd: 'space.025',
    marginInlineStart: 'space.negative.075'
});
const $23b78b5e22057a83$var$dialogSelectedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $23b78b5e22057a83$var$pressableStyles = (0, $ecnYn.xcss)({
    height: '28px',
    width: '28px',
    borderRadius: 'radius.full',
    color: 'color.text.subtle',
    fontWeight: 'font.weight.medium',
    backgroundColor: 'color.background.accent.gray.subtlest',
    padding: 'space.050',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ':hover': {
        textDecoration: 'underline',
        backgroundColor: 'color.background.accent.gray.subtlest.hovered'
    },
    ':active': {
        color: 'color.link.pressed',
        backgroundColor: 'color.background.accent.gray.subtlest.pressed'
    }
});
const $23b78b5e22057a83$export$fba1c3a5227f2b60 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { contentType: contentType, contentMode: contentMode, contentId: contentId, analyticsTriggerSource: t1, toggleEmptyPresenceDialog: toggleEmptyPresenceDialog, isPopupOpen: isPopupOpen } = t0;
    const analyticsTriggerSource = t1 === undefined ? "PresenceAvatarGroup" : t1;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t2;
    if ($[0] !== analyticsTriggerSource || $[1] !== contentId || $[2] !== contentMode || $[3] !== contentType || $[4] !== createAnalyticsEvent || $[5] !== toggleEmptyPresenceDialog) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: analyticsTriggerSource,
                    product: "confluence",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "addCollaboratorsButton",
                    attributes: {
                        contentId: contentId,
                        contentMode: contentMode,
                        contentType: contentType
                    }
                }
            }).fire();
            return toggleEmptyPresenceDialog();
        };
        $[0] = analyticsTriggerSource;
        $[1] = contentId;
        $[2] = contentMode;
        $[3] = contentType;
        $[4] = createAnalyticsEvent;
        $[5] = toggleEmptyPresenceDialog;
        $[6] = t2;
    } else t2 = $[6];
    const getPersonAddButtonOnClickHandler = t2;
    let t3;
    if ($[7] !== contentMode || $[8] !== contentType || $[9] !== formatMessage) {
        const contentTypeLabel = formatMessage($23b78b5e22057a83$var$i18n.contentTypeLabel, {
            contentType: contentType === "page" && contentMode === "live" ? "livepage" : contentType
        });
        t3 = formatMessage($23b78b5e22057a83$var$i18n.addPeopleLabel, {
            contentType: contentTypeLabel
        });
        $[7] = contentMode;
        $[8] = contentType;
        $[9] = formatMessage;
        $[10] = t3;
    } else t3 = $[10];
    const addPeopleButtonLabel = t3;
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [
            $23b78b5e22057a83$var$iconButtonStyles,
            !(0, $9wGTI.fg)("platform-avatar-group-spacing-fix") && $23b78b5e22057a83$var$iconButtonLegacyMarginStyles
        ];
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== addPeopleButtonLabel || $[13] !== getPersonAddButtonOnClickHandler || $[14] !== isPopupOpen) {
        t5 = (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                ...tooltipProps,
                xcss: [
                    $23b78b5e22057a83$var$pressableStyles,
                    isPopupOpen && $23b78b5e22057a83$var$dialogSelectedStyles
                ],
                "aria-label": addPeopleButtonLabel,
                testId: "team-presence-avatar-add-people-button",
                onClick: getPersonAddButtonOnClickHandler
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cDMVr))), {
                label: "",
                testId: "team-presence-avatar-add-people-icon",
                color: isPopupOpen ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)"
            }));
        $[12] = addPeopleButtonLabel;
        $[13] = getPersonAddButtonOnClickHandler;
        $[14] = isPopupOpen;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== addPeopleButtonLabel || $[17] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t4
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: addPeopleButtonLabel
        }, t5));
        $[16] = addPeopleButtonLabel;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : ({ contentType: contentType, contentMode: contentMode, contentId: contentId, analyticsTriggerSource: analyticsTriggerSource = 'PresenceAvatarGroup', toggleEmptyPresenceDialog: toggleEmptyPresenceDialog, isPopupOpen: isPopupOpen })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const getPersonAddButtonOnClickHandler = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsTriggerSource,
                product: 'confluence',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'addCollaboratorsButton',
                attributes: {
                    contentId: contentId,
                    contentMode: contentMode,
                    contentType: contentType
                }
            }
        }).fire();
        return toggleEmptyPresenceDialog();
    };
    const contentTypeLabel = formatMessage($23b78b5e22057a83$var$i18n.contentTypeLabel, {
        contentType: contentType === 'page' && contentMode === 'live' ? 'livepage' : contentType
    });
    const addPeopleButtonLabel = formatMessage($23b78b5e22057a83$var$i18n.addPeopleLabel, {
        contentType: contentTypeLabel
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $23b78b5e22057a83$var$iconButtonStyles,
            !(0, $9wGTI.fg)('platform-avatar-group-spacing-fix') && $23b78b5e22057a83$var$iconButtonLegacyMarginStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: addPeopleButtonLabel
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            ...tooltipProps,
            xcss: [
                $23b78b5e22057a83$var$pressableStyles,
                isPopupOpen && $23b78b5e22057a83$var$dialogSelectedStyles
            ],
            "aria-label": addPeopleButtonLabel,
            testId: "team-presence-avatar-add-people-button",
            onClick: getPersonAddButtonOnClickHandler
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cDMVr))), {
            label: "",
            testId: "team-presence-avatar-add-people-icon",
            color: isPopupOpen ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)"
        }))));
};



















const $99e59da2f66101cd$var$wrapperStyles = null;
const $99e59da2f66101cd$var$animations = {
    slideInFromTop: (element, duration = 300)=>{
        element.style.transform = 'translateY(-20px)';
        element.style.opacity = '0';
        return element.animate([
            {
                transform: 'translateY(-20px)',
                opacity: 0
            },
            {
                transform: 'translateY(0)',
                opacity: 1
            }
        ], {
            duration: duration,
            easing: 'cubic-bezier(.2, 0, 0, 1)',
            fill: 'forwards'
        });
    },
    slideOutToBottom: (element, duration = 250)=>{
        return element.animate([
            {
                transform: 'translateY(0)',
                opacity: 1
            },
            {
                transform: 'translateY(20px)',
                opacity: 0
            }
        ], {
            duration: duration,
            easing: 'ease-in'
        });
    }
};
const $99e59da2f66101cd$export$92d15d8a950a903e = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { children: children, flipId: flipId, index: index } = t0;
    let t1;
    if ($[0] !== index) {
        t1 = (element)=>{
            const delay = (index ?? 0) * 50;
            const animation = $99e59da2f66101cd$var$animations.slideInFromTop(element, 400);
            const onFinish = ()=>{
                element.style.transform = "";
                element.style.opacity = "";
                animation.removeEventListener("finish", onFinish);
            };
            animation.addEventListener("finish", onFinish);
            if (delay > 0) {
                animation.pause();
                setTimeout(()=>{
                    animation.play();
                }, delay);
            }
        };
        $[0] = index;
        $[1] = t1;
    } else t1 = $[1];
    const onTileAppear = t1;
    const onTileExit = $99e59da2f66101cd$var$_temp;
    if ((0, $6mKj3.expValEquals)("cc-motion-survey-experiment", "cohort", "experiment")) {
        const zIndex = (0, $6bda54ffb0f4283a$export$dd4b75f1a6268a6b) - (index ?? (0, $6bda54ffb0f4283a$export$dd4b75f1a6268a6b));
        let t2;
        if ($[2] !== zIndex) {
            t2 = {
                zIndex: zIndex
            };
            $[2] = zIndex;
            $[3] = t2;
        } else t2 = $[3];
        let t3;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (0, $gMc0m.default)([
                "_kqswh2mm"
            ]);
            $[4] = t3;
        } else t3 = $[4];
        let t4;
        if ($[5] !== children || $[6] !== t2) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                style: t2,
                className: t3
            }, children);
            $[5] = children;
            $[6] = t2;
            $[7] = t4;
        } else t4 = $[7];
        let t5;
        if ($[8] !== flipId || $[9] !== onTileAppear || $[10] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ac008d3f6652bd26$export$c3816ea9cb166de0), {
                flipId: flipId,
                onAppear: onTileAppear,
                onExit: onTileExit
            }, t4);
            $[8] = flipId;
            $[9] = onTileAppear;
            $[10] = t4;
            $[11] = t5;
        } else t5 = $[11];
        return t5;
    }
    let t2;
    if ($[12] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[12] = children;
        $[13] = t2;
    } else t2 = $[13];
    return t2;
} : ({ children: children, flipId: flipId, index: index })=>{
    const onTileAppear = (element)=>{
        // Add stagger delay based on index so each avatar animates separately
        const delay = (index ?? 0) * 50;
        const animation = $99e59da2f66101cd$var$animations.slideInFromTop(element, 400);
        const onFinish = ()=>{
            element.style.transform = '';
            element.style.opacity = '';
            animation.removeEventListener('finish', onFinish);
        };
        animation.addEventListener('finish', onFinish); // Apply delay by pausing animation and starting after delay
        if (delay > 0) {
            animation.pause();
            setTimeout(()=>{
                animation.play();
            }, delay);
        }
    };
    const onTileExit = (element_0, _, removeElement)=>{
        $99e59da2f66101cd$var$animations.slideOutToBottom(element_0).addEventListener('finish', removeElement);
    };
    if ((0, $6mKj3.expValEquals)('cc-motion-survey-experiment', 'cohort', 'experiment')) {
        const zIndex = (0, $6bda54ffb0f4283a$export$dd4b75f1a6268a6b) - (index ?? (0, $6bda54ffb0f4283a$export$dd4b75f1a6268a6b));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ac008d3f6652bd26$export$c3816ea9cb166de0), {
            flipId: flipId,
            onAppear: onTileAppear,
            onExit: onTileExit
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, $gMc0m.default)([
                "_kqswh2mm"
            ])
        }, children));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
function $99e59da2f66101cd$var$_temp(element_0, _, removeElement) {
    $99e59da2f66101cd$var$animations.slideOutToBottom(element_0).addEventListener("finish", removeElement);
}


const $012cae68941ce2ca$var$i18n = (0, $cgtv4.defineMessages)({
    overflowLabel: {
        id: "team-presence.avatar-group.overflow-label",
        defaultMessage: "Overflow menu"
    },
    blogpostLandmark: {
        id: "team-presence.avatar-group.blogpost-landmark",
        defaultMessage: "Active people on blog post"
    },
    pageLandmark: {
        id: "team-presence.avatar-group.page-landmark",
        defaultMessage: "Active people on page"
    }
});
const $012cae68941ce2ca$var$popupContainerStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'radius.small',
    position: 'relative',
    width: '360px'
});
const $012cae68941ce2ca$var$editObjectHeaderStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.0'
});
const $012cae68941ce2ca$var$overflowMoreStyles = (0, $ecnYn.xcss)({
    padding: 'space.075',
    backgroundColor: 'color.background.accent.gray.subtler',
    borderRadius: 'radius.full',
    color: 'color.text.subtle',
    font: 'font.heading.xxsmall',
    ':hover': {
        backgroundColor: 'color.background.accent.gray.subtler.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.accent.gray.subtler.pressed'
    }
});
const $012cae68941ce2ca$var$moreActiveStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.selected.pressed'
    }
});
// Base styles for indicator - margin will be conditionally applied based on feature gate
const $012cae68941ce2ca$var$indicatorBaseStyles = (0, $ecnYn.xcss)({
    minWidth: '28px',
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0',
    borderRadius: 'radius.small',
    ':focus-visible': {
        outlineColor: 'color.border.focused',
        outlineStyle: 'solid',
        outlineWidth: 'border.width.focused',
        outlineOffset: 'space.050'
    }
});
// Legacy margin styles (used when platform spacing fix is disabled)
const $012cae68941ce2ca$var$indicatorLegacyMarginStyles = (0, $ecnYn.xcss)({
    margin: 'space.025'
});
const $012cae68941ce2ca$var$indicatorOverflowStyles = (0, $ecnYn.xcss)({
    minWidth: '35px',
    maxWidth: '35px'
});
const $012cae68941ce2ca$export$fc163eae181faed4 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(106);
    const { contentId: contentId, contentMode: contentMode, contentType: contentType, analyticSource: analyticSource, popupOpen: popupOpen, participants: participants, totalParticipants: totalParticipants } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $6S5EB.isExternalShareRequest)();
        $[0] = t1;
    } else t1 = $[0];
    const isExternal = t1;
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(popupOpen || false);
    const [isShareDialogOpen, setIsShareDialogOpen] = (0, $42omo.useState)(false);
    const isCollabExperimentEnabled = (0, $dfd0e0bcd5f5e42d$export$ab3d2b3e42e6721)(participants, isLoggedIn, isGuest, isExternal);
    let t2;
    if ($[1] !== isCollabExperimentEnabled || $[2] !== isGuest || $[3] !== isLoggedIn || $[4] !== participants.length) {
        t2 = ()=>participants.length === 1 && isLoggedIn && !isGuest && !isExternal && !isCollabExperimentEnabled;
        $[1] = isCollabExperimentEnabled;
        $[2] = isGuest;
        $[3] = isLoggedIn;
        $[4] = participants.length;
        $[5] = t2;
    } else t2 = $[5];
    const isEligibleForEmptyPresenceDialog = t2;
    let t3;
    if ($[6] !== isCollabExperimentEnabled || $[7] !== isPopupOpen || $[8] !== participants.length) {
        t3 = ()=>{
            if (isPopupOpen && participants.length > 1 && participants.length <= (0, $6bda54ffb0f4283a$export$dd4b75f1a6268a6b) && !isCollabExperimentEnabled) setIsPopupOpen(false);
        };
        $[6] = isCollabExperimentEnabled;
        $[7] = isPopupOpen;
        $[8] = participants.length;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== isCollabExperimentEnabled || $[11] !== isPopupOpen || $[12] !== participants) {
        t4 = [
            isPopupOpen,
            participants,
            isCollabExperimentEnabled
        ];
        $[10] = isCollabExperimentEnabled;
        $[11] = isPopupOpen;
        $[12] = participants;
        $[13] = t4;
    } else t4 = $[13];
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[14] !== contentId || $[15] !== contentMode || $[16] !== contentType || $[17] !== createAnalyticsEvent) {
        t5 = (analyticsTriggerSource)=>{
            setIsPopupOpen(false);
            setIsShareDialogOpen(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: analyticsTriggerSource,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "presenceShare",
                    attributes: {
                        contentId: contentId,
                        contentMode: contentMode,
                        contentType: contentType,
                        shareDialog: "v2"
                    }
                }
            }).fire();
        };
        $[14] = contentId;
        $[15] = contentMode;
        $[16] = contentType;
        $[17] = createAnalyticsEvent;
        $[18] = t5;
    } else t5 = $[18];
    const handleShareClick = t5;
    let t6;
    if ($[19] !== analyticSource || $[20] !== contentId || $[21] !== contentMode || $[22] !== contentType || $[23] !== createAnalyticsEvent || $[24] !== isPopupOpen) {
        t6 = ()=>{
            setIsPopupOpen($012cae68941ce2ca$var$_temp);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: analyticSource,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "singlePresenceAvatarGroup",
                    product: "confluence",
                    attributes: {
                        contentId: contentId,
                        contentMode: contentMode,
                        contentType: contentType,
                        toggle: isPopupOpen ? "close" : "open"
                    }
                }
            }).fire();
        };
        $[19] = analyticSource;
        $[20] = contentId;
        $[21] = contentMode;
        $[22] = contentType;
        $[23] = createAnalyticsEvent;
        $[24] = isPopupOpen;
        $[25] = t6;
    } else t6 = $[25];
    const toggleEmptyPresenceDialog = t6;
    const isSingleParticipant = Boolean(participants && totalParticipants === 1);
    let t7;
    if ($[26] !== analyticSource || $[27] !== contentId || $[28] !== contentMode || $[29] !== contentType || $[30] !== createAnalyticsEvent) {
        t7 = (e, number)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: analyticSource,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "presenceAvatarGroupMoreButton",
                    product: "confluence",
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        contentMode: contentMode,
                        number: number
                    }
                }
            }).fire();
            setIsPopupOpen($012cae68941ce2ca$var$_temp2);
            e.stopPropagation();
        };
        $[26] = analyticSource;
        $[27] = contentId;
        $[28] = contentMode;
        $[29] = contentType;
        $[30] = createAnalyticsEvent;
        $[31] = t7;
    } else t7 = $[31];
    const onMoreClick = t7;
    let t8;
    if ($[32] !== isCollabExperimentEnabled || $[33] !== isSingleParticipant) {
        t8 = ()=>{
            if (isCollabExperimentEnabled) return "suggested-collaborators-dialog";
            return isSingleParticipant ? "no-collaborators-dialog" : "presence-menu";
        };
        $[32] = isCollabExperimentEnabled;
        $[33] = isSingleParticipant;
        $[34] = t8;
    } else t8 = $[34];
    const getTriggerId = t8;
    const triggerId = getTriggerId();
    let t9;
    if ($[35] !== contentId || $[36] !== contentMode || $[37] !== contentType || $[38] !== handleShareClick || $[39] !== spaceKey || $[40] !== triggerId) {
        t9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e836e779dfba9248$export$77e0ff796ca95372), {
                contentMode: contentMode,
                contentId: contentId,
                contentType: contentType,
                onShareClick: handleShareClick,
                spaceKey: spaceKey || "",
                testId: triggerId
            });
        $[35] = contentId;
        $[36] = contentMode;
        $[37] = contentType;
        $[38] = handleShareClick;
        $[39] = spaceKey;
        $[40] = triggerId;
        $[41] = t9;
    } else t9 = $[41];
    const renderSuggestedCollaboratorsDialog = t9;
    let t10;
    if ($[42] !== contentId || $[43] !== contentMode || $[44] !== contentType || $[45] !== handleShareClick || $[46] !== spaceKey || $[47] !== triggerId) {
        t10 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1fc817270f48d66d$export$3566bbc3d99e9268), {
                contentId: contentId,
                contentMode: contentMode,
                contentType: contentType,
                spaceKey: spaceKey || "",
                onShareClick: handleShareClick,
                testId: triggerId
            });
        $[42] = contentId;
        $[43] = contentMode;
        $[44] = contentType;
        $[45] = handleShareClick;
        $[46] = spaceKey;
        $[47] = triggerId;
        $[48] = t10;
    } else t10 = $[48];
    const renderNoCollaboratorsDialog = t10;
    let t11;
    if ($[49] !== contentId || $[50] !== contentMode || $[51] !== contentType || $[52] !== participants || $[53] !== totalParticipants) {
        t11 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9f1d85818b4620e9$export$c5f53e9ee1a93ef8), {
                contentId: contentId,
                contentType: contentType,
                contentMode: contentMode,
                participants: participants,
                totalParticipants: totalParticipants
            });
        $[49] = contentId;
        $[50] = contentMode;
        $[51] = contentType;
        $[52] = participants;
        $[53] = totalParticipants;
        $[54] = t11;
    } else t11 = $[54];
    const renderPresenceMenu = t11;
    let t12;
    if ($[55] !== isCollabExperimentEnabled || $[56] !== isSingleParticipant || $[57] !== renderNoCollaboratorsDialog || $[58] !== renderPresenceMenu || $[59] !== renderSuggestedCollaboratorsDialog) {
        const getPopUpContent = ()=>{
            if (isCollabExperimentEnabled) return renderSuggestedCollaboratorsDialog();
            return isSingleParticipant ? renderNoCollaboratorsDialog() : renderPresenceMenu();
        };
        t12 = getPopUpContent();
        $[55] = isCollabExperimentEnabled;
        $[56] = isSingleParticipant;
        $[57] = renderNoCollaboratorsDialog;
        $[58] = renderPresenceMenu;
        $[59] = renderSuggestedCollaboratorsDialog;
        $[60] = t12;
    } else t12 = $[60];
    const PopupContent = t12;
    const overflowParticipantCount = totalParticipants - (0, $6bda54ffb0f4283a$export$dd4b75f1a6268a6b) + 1;
    const shouldRenderAddPersonButton = isCollabExperimentEnabled && overflowParticipantCount <= 0;
    let t13;
    let t14;
    if ($[61] !== contentId || $[62] !== contentMode || $[63] !== contentType || $[64] !== createAnalyticsEvent || $[65] !== shouldRenderAddPersonButton) {
        t13 = ()=>{
            if (shouldRenderAddPersonButton) createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "addCollaboratorsButton",
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        contentMode: contentMode
                    }
                }
            }).fire();
        };
        t14 = [
            shouldRenderAddPersonButton,
            contentId,
            contentType,
            contentMode,
            createAnalyticsEvent
        ];
        $[61] = contentId;
        $[62] = contentMode;
        $[63] = contentType;
        $[64] = createAnalyticsEvent;
        $[65] = shouldRenderAddPersonButton;
        $[66] = t13;
        $[67] = t14;
    } else {
        t13 = $[66];
        t14 = $[67];
    }
    (0, $42omo.useEffect)(t13, t14);
    let t15;
    if ($[68] !== contentType || $[69] !== formatMessage) {
        t15 = contentType === "blogpost" ? formatMessage($012cae68941ce2ca$var$i18n.blogpostLandmark) : formatMessage($012cae68941ce2ca$var$i18n.pageLandmark);
        $[68] = contentType;
        $[69] = formatMessage;
        $[70] = t15;
    } else t15 = $[70];
    const landmarkRegionLabel = t15;
    let t16;
    if ($[71] !== contentMode) {
        t16 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && (contentMode === "edit" || contentMode === "live");
        $[71] = contentMode;
        $[72] = t16;
    } else t16 = $[72];
    const isEditObjectHeader = t16;
    let t17;
    if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE)
        });
        $[73] = t17;
    } else t17 = $[73];
    let t18;
    if ($[74] !== contentId || $[75] !== contentType || $[76] !== isShareDialogOpen || $[77] !== participants.length || $[78] !== shouldRenderAddPersonButton) {
        t18 = (participants.length === 1 || shouldRenderAddPersonButton) && isShareDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lgKMU.ShareAndRestrictDialogController), {
            contentId: contentId,
            contentType: contentType,
            allowRestrictions: true,
            pageModes: "view",
            refetchButtonData: $012cae68941ce2ca$var$_temp3,
            onClose: ()=>{
                setIsShareDialogOpen(false);
            },
            isUnpublishedDraft: false
        });
        $[74] = contentId;
        $[75] = contentType;
        $[76] = isShareDialogOpen;
        $[77] = participants.length;
        $[78] = shouldRenderAddPersonButton;
        $[79] = t18;
    } else t18 = $[79];
    let t19;
    if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = ()=>setIsPopupOpen(false);
        $[80] = t19;
    } else t19 = $[80];
    let t20;
    if ($[81] !== PopupContent) {
        t20 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $012cae68941ce2ca$var$popupContainerStyles
            }, PopupContent);
        $[81] = PopupContent;
        $[82] = t20;
    } else t20 = $[82];
    let t21;
    if ($[83] !== analyticSource || $[84] !== contentId || $[85] !== contentMode || $[86] !== contentType || $[87] !== formatMessage || $[88] !== isEditObjectHeader || $[89] !== isEligibleForEmptyPresenceDialog || $[90] !== isPopupOpen || $[91] !== isSingleParticipant || $[92] !== landmarkRegionLabel || $[93] !== onMoreClick || $[94] !== overflowParticipantCount || $[95] !== participants || $[96] !== shouldRenderAddPersonButton || $[97] !== toggleEmptyPresenceDialog) {
        t21 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                ...triggerProps,
                paddingInline: "space.050",
                paddingBlock: "space.025",
                "aria-label": landmarkRegionLabel,
                role: "region",
                xcss: isEditObjectHeader && $012cae68941ce2ca$var$editObjectHeaderStyles,
                "data-vc": "presence-avatar-group"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
                appearance: "stack",
                size: "small",
                maxCount: (0, $6bda54ffb0f4283a$export$dd4b75f1a6268a6b),
                data: participants,
                testId: "presence-avatar-group",
                label: landmarkRegionLabel,
                borderColor: "var(--ds-background-neutral, #0515240F)",
                onMoreClick: (e_0)=>onMoreClick(e_0, overflowParticipantCount),
                shouldPopupRenderToParent: false,
                isTooltipDisabled: true,
                overrides: {
                    Avatar: {
                        render: (_, props, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99e59da2f66101cd$export$92d15d8a950a903e), {
                                flipId: `PresenceAvatarButton-${index}`,
                                index: index
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                                alignItems: "center"
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f0ec2e1e638ea1ae$export$5baa88db8a182af5), {
                                key: `PresenceAvatarButton-${index}`,
                                index: index,
                                participant: participants[index],
                                contentMode: contentMode,
                                contentType: contentType,
                                contentId: contentId,
                                isSingleParticipant: isSingleParticipant,
                                isEligibleForEmptyPresenceDialog: isEligibleForEmptyPresenceDialog(),
                                toggleEmptyPresenceDialog: toggleEmptyPresenceDialog,
                                avatarProps: props,
                                analyticSource: analyticSource
                            }), shouldRenderAddPersonButton && index === participants.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $23b78b5e22057a83$export$fba1c3a5227f2b60), {
                                contentType: contentType,
                                contentMode: contentMode,
                                contentId: contentId,
                                toggleEmptyPresenceDialog: toggleEmptyPresenceDialog,
                                isPopupOpen: isPopupOpen,
                                analyticsTriggerSource: analyticSource
                            })))
                    },
                    MoreIndicator: {
                        render: (__0, t22)=>{
                            const { buttonProps: buttonProps, isActive: __, borderColor: ___, ...rest } = t22;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99e59da2f66101cd$export$92d15d8a950a903e), {
                                flipId: "more-indicator"
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                                type: "submit",
                                ...buttonProps,
                                ...rest,
                                padding: (0, $9wGTI.fg)("platform-avatar-group-spacing-fix") ? "space.0" : "space.025",
                                onClick: rest.onClick,
                                xcss: [
                                    $012cae68941ce2ca$var$indicatorBaseStyles,
                                    !(0, $9wGTI.fg)("platform-avatar-group-spacing-fix") && $012cae68941ce2ca$var$indicatorLegacyMarginStyles,
                                    overflowParticipantCount > 100 && $012cae68941ce2ca$var$indicatorOverflowStyles
                                ],
                                testId: rest.testId,
                                "data-vc": "presence-overflow",
                                "aria-label": formatMessage($012cae68941ce2ca$var$i18n.overflowLabel)
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                                xcss: [
                                    $012cae68941ce2ca$var$overflowMoreStyles,
                                    isPopupOpen && $012cae68941ce2ca$var$moreActiveStyles
                                ]
                            }, overflowParticipantCount)));
                        }
                    }
                }
            }));
        $[83] = analyticSource;
        $[84] = contentId;
        $[85] = contentMode;
        $[86] = contentType;
        $[87] = formatMessage;
        $[88] = isEditObjectHeader;
        $[89] = isEligibleForEmptyPresenceDialog;
        $[90] = isPopupOpen;
        $[91] = isSingleParticipant;
        $[92] = landmarkRegionLabel;
        $[93] = onMoreClick;
        $[94] = overflowParticipantCount;
        $[95] = participants;
        $[96] = shouldRenderAddPersonButton;
        $[97] = toggleEmptyPresenceDialog;
        $[98] = t21;
    } else t21 = $[98];
    let t22;
    if ($[99] !== isPopupOpen || $[100] !== t20 || $[101] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isPopupOpen,
            onClose: t19,
            placement: "bottom-end",
            content: t20,
            trigger: t21
        });
        $[99] = isPopupOpen;
        $[100] = t20;
        $[101] = t21;
        $[102] = t22;
    } else t22 = $[102];
    let t23;
    if ($[103] !== t18 || $[104] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t17, t18, t22);
        $[103] = t18;
        $[104] = t22;
        $[105] = t23;
    } else t23 = $[105];
    return t23;
} : ({ contentId: contentId, contentMode: contentMode, contentType: contentType, analyticSource: analyticSource, popupOpen: popupOpen, participants: participants, totalParticipants: totalParticipants })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const isExternal = (0, $6S5EB.isExternalShareRequest)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(popupOpen || false);
    const [isShareDialogOpen, setIsShareDialogOpen] = (0, $42omo.useState)(false);
    const isCollabExperimentEnabled = (0, $dfd0e0bcd5f5e42d$export$ab3d2b3e42e6721)(participants, isLoggedIn, isGuest, isExternal);
    const isEligibleForEmptyPresenceDialog = (0, $42omo.useCallback)(()=>{
        // only 1 user, not anonymous and not guest user, and the collab experiment is not enabled
        return participants.length === 1 && isLoggedIn && !isGuest && !isExternal && !isCollabExperimentEnabled;
    }, [
        participants,
        isLoggedIn,
        isGuest,
        isExternal,
        isCollabExperimentEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isPopupOpen && participants.length > 1 && participants.length <= (0, $6bda54ffb0f4283a$export$dd4b75f1a6268a6b) && !isCollabExperimentEnabled) setIsPopupOpen(false);
    }, [
        isPopupOpen,
        participants,
        isCollabExperimentEnabled
    ]);
    const handleShareClick = (0, $42omo.useCallback)((analyticsTriggerSource)=>{
        setIsPopupOpen(false);
        const shareDialogType = 'v2';
        setIsShareDialogOpen(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsTriggerSource,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'presenceShare',
                attributes: {
                    contentId: contentId,
                    contentMode: contentMode,
                    contentType: contentType,
                    shareDialog: shareDialogType
                }
            }
        }).fire();
    }, [
        contentId,
        contentMode,
        contentType,
        createAnalyticsEvent
    ]);
    const toggleEmptyPresenceDialog = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen((isPopupOpenState)=>!isPopupOpenState);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticSource,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'singlePresenceAvatarGroup',
                product: 'confluence',
                attributes: {
                    contentId: contentId,
                    contentMode: contentMode,
                    contentType: contentType,
                    toggle: isPopupOpen ? 'close' : 'open'
                }
            }
        }).fire();
    }, [
        contentId,
        contentMode,
        contentType,
        analyticSource,
        createAnalyticsEvent,
        isPopupOpen
    ]);
    const isSingleParticipant = Boolean(participants && totalParticipants === 1);
    const onMoreClick = (0, $42omo.useCallback)((e, number)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticSource,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'presenceAvatarGroupMoreButton',
                product: 'confluence',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    contentMode: contentMode,
                    number: number
                }
            }
        }).fire();
        setIsPopupOpen((isPopupOpenState_0)=>!isPopupOpenState_0);
        // platform-design-system-popup-ref causes the popup to close when the user clicks on the more button,
        // revisit what other types of changes we can put in place to not have to call stopPropagation
        e.stopPropagation();
    }, [
        contentId,
        contentType,
        contentMode,
        analyticSource,
        createAnalyticsEvent
    ]);
    const getTriggerId = ()=>{
        if (isCollabExperimentEnabled) return 'suggested-collaborators-dialog';
        return isSingleParticipant ? 'no-collaborators-dialog' : 'presence-menu';
    };
    const triggerId = getTriggerId();
    const renderSuggestedCollaboratorsDialog = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e836e779dfba9248$export$77e0ff796ca95372), {
            contentMode: contentMode,
            contentId: contentId,
            contentType: contentType,
            onShareClick: handleShareClick,
            spaceKey: spaceKey || '',
            testId: triggerId
        });
    const renderNoCollaboratorsDialog = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1fc817270f48d66d$export$3566bbc3d99e9268), {
            contentId: contentId,
            contentMode: contentMode,
            contentType: contentType,
            spaceKey: spaceKey || '',
            onShareClick: handleShareClick,
            testId: triggerId
        });
    const renderPresenceMenu = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9f1d85818b4620e9$export$c5f53e9ee1a93ef8), {
            contentId: contentId,
            contentType: contentType,
            contentMode: contentMode,
            participants: participants,
            totalParticipants: totalParticipants
        });
    const getPopUpContent = ()=>{
        if (isCollabExperimentEnabled) return renderSuggestedCollaboratorsDialog();
        return isSingleParticipant ? renderNoCollaboratorsDialog() : renderPresenceMenu();
    };
    const PopupContent = getPopUpContent();
    const overflowParticipantCount = totalParticipants - (0, $6bda54ffb0f4283a$export$dd4b75f1a6268a6b) + 1;
    const shouldRenderAddPersonButton = isCollabExperimentEnabled && overflowParticipantCount <= 0;
    (0, $42omo.useEffect)(()=>{
        if (shouldRenderAddPersonButton) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'addCollaboratorsButton',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    contentMode: contentMode
                }
            }
        }).fire();
    }, [
        shouldRenderAddPersonButton,
        contentId,
        contentType,
        contentMode,
        createAnalyticsEvent
    ]);
    const landmarkRegionLabel = contentType === 'blogpost' ? formatMessage($012cae68941ce2ca$var$i18n.blogpostLandmark) : formatMessage($012cae68941ce2ca$var$i18n.pageLandmark);
    const isEditObjectHeader = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && (contentMode === 'edit' || contentMode === 'live');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE)
    }), (participants.length === 1 || shouldRenderAddPersonButton) && isShareDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lgKMU.ShareAndRestrictDialogController), {
        contentId: contentId,
        contentType: contentType,
        allowRestrictions: true,
        pageModes: "view",
        refetchButtonData: ()=>{},
        onClose: ()=>{
            setIsShareDialogOpen(false);
        },
        isUnpublishedDraft: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isPopupOpen,
        onClose: ()=>setIsPopupOpen(false),
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $012cae68941ce2ca$var$popupContainerStyles
            }, PopupContent),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                ...triggerProps,
                paddingInline: "space.050",
                paddingBlock: "space.025",
                "aria-label": landmarkRegionLabel,
                role: "region",
                xcss: isEditObjectHeader && $012cae68941ce2ca$var$editObjectHeaderStyles,
                "data-vc": "presence-avatar-group"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
                appearance: "stack",
                size: "small",
                maxCount: (0, $6bda54ffb0f4283a$export$dd4b75f1a6268a6b),
                data: participants,
                testId: "presence-avatar-group",
                label: landmarkRegionLabel,
                borderColor: "var(--ds-background-neutral, #0515240F)",
                onMoreClick: (e_0)=>onMoreClick(e_0, overflowParticipantCount),
                shouldPopupRenderToParent: false,
                isTooltipDisabled: true,
                overrides: {
                    Avatar: {
                        render: (_, props, index)=>{
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99e59da2f66101cd$export$92d15d8a950a903e), {
                                flipId: `PresenceAvatarButton-${index}`,
                                index: index
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                                alignItems: "center"
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f0ec2e1e638ea1ae$export$5baa88db8a182af5), {
                                key: `PresenceAvatarButton-${index}`,
                                index: index,
                                participant: participants[index],
                                contentMode: contentMode,
                                contentType: contentType,
                                contentId: contentId,
                                isSingleParticipant: isSingleParticipant,
                                isEligibleForEmptyPresenceDialog: isEligibleForEmptyPresenceDialog(),
                                toggleEmptyPresenceDialog: toggleEmptyPresenceDialog,
                                avatarProps: props,
                                analyticSource: analyticSource
                            }), shouldRenderAddPersonButton && index === participants.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $23b78b5e22057a83$export$fba1c3a5227f2b60), {
                                contentType: contentType,
                                contentMode: contentMode,
                                contentId: contentId,
                                toggleEmptyPresenceDialog: toggleEmptyPresenceDialog,
                                isPopupOpen: isPopupOpen,
                                analyticsTriggerSource: analyticSource
                            })));
                        }
                    },
                    MoreIndicator: {
                        render: (__0, { buttonProps: buttonProps, isActive: __, borderColor: ___, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99e59da2f66101cd$export$92d15d8a950a903e), {
                                flipId: `more-indicator`
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                                type: "submit",
                                ...buttonProps,
                                ...rest,
                                padding: (0, $9wGTI.fg)('platform-avatar-group-spacing-fix') ? 'space.0' : 'space.025',
                                onClick: rest.onClick,
                                xcss: [
                                    $012cae68941ce2ca$var$indicatorBaseStyles,
                                    !(0, $9wGTI.fg)('platform-avatar-group-spacing-fix') && $012cae68941ce2ca$var$indicatorLegacyMarginStyles,
                                    // TODO: This is a bug, anything above 1000 will break...
                                    overflowParticipantCount > 100 && $012cae68941ce2ca$var$indicatorOverflowStyles
                                ],
                                testId: rest.testId,
                                "data-vc": "presence-overflow",
                                "aria-label": formatMessage($012cae68941ce2ca$var$i18n.overflowLabel)
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                                xcss: [
                                    $012cae68941ce2ca$var$overflowMoreStyles,
                                    isPopupOpen && $012cae68941ce2ca$var$moreActiveStyles
                                ]
                            }, overflowParticipantCount)))
                    }
                }
            }))
    }));
};
function $012cae68941ce2ca$var$_temp(isPopupOpenState) {
    return !isPopupOpenState;
}
function $012cae68941ce2ca$var$_temp2(isPopupOpenState_0) {
    return !isPopupOpenState_0;
}
function $012cae68941ce2ca$var$_temp3() {}






var $hvdlr = parcelRequire("hvdlr");





var $hYoU4 = parcelRequire("hYoU4");


var $8KbKw = parcelRequire("8KbKw");



























//TODO dynamic configs https://product-fabric.atlassian.net/browse/MDS-1207
const $e412362ca5524ae7$var$SESSION_LIMIT = 50;
const $e412362ca5524ae7$var$TOTAL_SESSION_LIMIT = 1000;
const $e412362ca5524ae7$export$ca2b752d32a4ba83 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { contentId: contentId, contentMode: contentMode, contentType: contentType, participants: participants, provider: provider } = t0;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== participants || $[1] !== userId) {
        t1 = ()=>participants.get(userId ?? "unidentified");
        $[0] = participants;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    const getCurrentUser = t1;
    let t2;
    if ($[3] !== provider) {
        t2 = ()=>provider?.getParticipants().length ?? 0;
        $[3] = provider;
        $[4] = t2;
    } else t2 = $[4];
    const getTotalSessions = t2;
    let t3;
    if ($[5] !== contentMode || $[6] !== contentType) {
        t3 = ()=>[
                "blogpost",
                "page"
            ].includes(contentType) && contentMode === "view";
        $[5] = contentMode;
        $[6] = contentType;
        $[7] = t3;
    } else t3 = $[7];
    const isViewContentType = t3;
    let t4;
    if ($[8] !== contentId || $[9] !== contentType || $[10] !== createAnalyticsEvent || $[11] !== provider) {
        t4 = (currentUser, totalSessions)=>{
            const currentUserHasReachedSessionLimit = currentUser && Object.keys(currentUser.sessions).length > $e412362ca5524ae7$var$SESSION_LIMIT;
            if (currentUserHasReachedSessionLimit || totalSessions > $e412362ca5524ae7$var$TOTAL_SESSION_LIMIT) {
                provider?.destroy();
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        source: "presenceAvatarGroup",
                        action: "destroyConnection",
                        actionSubject: "presenceAvatarGroupConnection",
                        attributes: {
                            sessionLimitType: currentUserHasReachedSessionLimit ? "currentUser" : "totalSessions",
                            contentId: contentId,
                            contentType: contentType
                        }
                    }
                }).fire();
            }
        };
        $[8] = contentId;
        $[9] = contentType;
        $[10] = createAnalyticsEvent;
        $[11] = provider;
        $[12] = t4;
    } else t4 = $[12];
    const checkSessionLimit = t4;
    let t5;
    let t6;
    if ($[13] !== checkSessionLimit || $[14] !== getCurrentUser || $[15] !== getTotalSessions || $[16] !== isViewContentType) {
        t5 = ()=>{
            if (!isViewContentType()) return;
            checkSessionLimit(getCurrentUser(), getTotalSessions());
        };
        t6 = [
            checkSessionLimit,
            getCurrentUser,
            getTotalSessions,
            isViewContentType
        ];
        $[13] = checkSessionLimit;
        $[14] = getCurrentUser;
        $[15] = getTotalSessions;
        $[16] = isViewContentType;
        $[17] = t5;
        $[18] = t6;
    } else {
        t5 = $[17];
        t6 = $[18];
    }
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {};
        $[19] = t7;
    } else t7 = $[19];
    return t7;
} : ({ contentId: contentId, contentMode: contentMode, contentType: contentType, participants: participants, provider: provider })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const getCurrentUser = (0, $42omo.useCallback)(()=>{
        return participants.get(userId ?? 'unidentified');
    }, [
        participants,
        userId
    ]);
    const getTotalSessions = (0, $42omo.useCallback)(()=>{
        return provider?.getParticipants().length ?? 0;
    }, [
        provider
    ]);
    const isViewContentType = (0, $42omo.useCallback)(()=>{
        return [
            'blogpost',
            'page'
        ].includes(contentType) && contentMode === 'view';
    }, [
        contentType,
        contentMode
    ]);
    const checkSessionLimit = (0, $42omo.useCallback)((currentUser, totalSessions)=>{
        const currentUserHasReachedSessionLimit = currentUser && Object.keys(currentUser.sessions).length > $e412362ca5524ae7$var$SESSION_LIMIT;
        if (currentUserHasReachedSessionLimit || totalSessions > $e412362ca5524ae7$var$TOTAL_SESSION_LIMIT) {
            provider?.destroy();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'presenceAvatarGroup',
                    action: 'destroyConnection',
                    actionSubject: 'presenceAvatarGroupConnection',
                    attributes: {
                        sessionLimitType: currentUserHasReachedSessionLimit ? 'currentUser' : 'totalSessions',
                        contentId: contentId,
                        contentType: contentType
                    }
                }
            }).fire();
        }
    }, [
        contentId,
        contentType,
        createAnalyticsEvent,
        provider
    ]);
    (0, $42omo.useEffect)(()=>{
        // We only want to apply the limiter for blogs and pages, and only when in view mode.
        if (!isViewContentType()) return;
        checkSessionLimit(getCurrentUser(), getTotalSessions());
    }, [
        checkSessionLimit,
        getCurrentUser,
        getTotalSessions,
        isViewContentType
    ]);
    return {};
};


/** @graphql agg **/ 



var $gKr8t = parcelRequire("gKr8t");

const $aed2f5bf61ddaaa1$export$9db34321b84dd37a = (accountIds)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $gKr8t.getAGGClient)().query({
        query: (0, $eSUdr.default)`query fetchPresenceAGGUsersQuery($accountIds:[ID!]!){users(accountIds:$accountIds){accountId name picture}}`,
        variables: {
            accountIds: accountIds
        }
    }).then(({ data: data })=>{
        return data?.users?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user.picture ?? '',
                email: '',
                name: user.name ?? '',
                userId: user.accountId || ''
            })) ?? [];
    });
};


/** @graphql cc **/ 





const $9cba87adb0d6c766$export$bf12d28b3016b36b = (accountIds)=>{
    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $eSUdr.default)`query fetchPresenceConfluenceUsersQuery($accountIds:[String]){confluenceUsers(accountIds:$accountIds){nodes{profilePicture{isDefault path(type:RELATIVE)}...on KnownUser{accountId}...on UnknownUser{accountId}displayName}}}`,
        variables: {
            accountIds: accountIds
        }
    }).then(({ data: data })=>{
        return data?.confluenceUsers?.nodes?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user?.profilePicture?.path ?? '',
                email: '',
                isGuest: undefined,
                name: user?.displayName ?? '',
                userId: user?.accountId ?? ''
            })) ?? [];
    });
};















var $83Vfg = parcelRequire("83Vfg");


const $fd1de2fc32fd6664$export$ed360de126596689 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    const fetchAnonymousAsset = $fd1de2fc32fd6664$var$_temp;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            fetchAnonymousAsset: fetchAnonymousAsset
        };
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    const fetchAnonymousAsset = (0, $42omo.useCallback)((presenceId)=>{
        const hashCode = presenceId ? (0, $jyw2s.getHashCode)(presenceId) : 0;
        const primaryIndex = hashCode;
        const svgBackgroundColor = (0, $6bda54ffb0f4283a$export$2fbd87a2176aa7cf)(presenceId).svgBackgroundColor;
        return (0, $83Vfg.getAnonymousAvatarWithStyling)({
            styleProperties: {
                'background-color': svgBackgroundColor
            },
            index: primaryIndex
        });
    }, []);
    return {
        fetchAnonymousAsset: fetchAnonymousAsset
    };
};
function $fd1de2fc32fd6664$var$_temp(presenceId) {
    const hashCode = presenceId ? (0, $jyw2s.getHashCode)(presenceId) : 0;
    const primaryIndex = hashCode;
    const svgBackgroundColor = (0, $6bda54ffb0f4283a$export$2fbd87a2176aa7cf)(presenceId).svgBackgroundColor;
    return (0, $83Vfg.getAnonymousAvatarWithStyling)({
        styleProperties: {
            "background-color": svgBackgroundColor
        },
        index: primaryIndex
    });
}


const $5748c7d61e5bba21$var$MAX_FETCH_SIZE = 25;
const $5748c7d61e5bba21$export$457bc606c36b9a3f = (contentId, contentType, contentMode, activity)=>{
    const shouldCreatePresenceConnection = contentMode === 'view';
    const [{ collabEditInitialized: collabEditInitialized, collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    // presenceId is pulled from the native collab state to ensure that we have a consistent presenceId for a given contentId
    // across the collab providers that drive editor as well as presence components (telepointer and avatar colors).
    const [{ presenceId: presenceId }] = (0, $2VZOl.useNativeCollabPresenceState)();
    const { add: add, remove: remove, addTelepointerData: addTelepointerData } = (0, $2960af57d9597263$export$afdb9ee4b69111fa)();
    const participants = (0, $2960af57d9597263$export$23e4fe06e7659b53)();
    const { cloudId: cloudId, activationId: activationId, userId: userId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const { fetchAnonymousAsset: fetchAnonymousAsset } = (0, $fd1de2fc32fd6664$export$ed360de126596689)();
    const sessions = (0, $42omo.useRef)(new Set());
    const providerRef = (0, $42omo.useRef)(collabEditProvider);
    const presenceIdRef = (0, $42omo.useRef)(presenceId);
    // really for testing purposes
    const [isInitialized, setIsInitialized] = (0, $42omo.useState)(false);
    const [networkError, setNetworkError] = (0, $42omo.useState)(undefined);
    (0, $e412362ca5524ae7$export$ca2b752d32a4ba83)({
        contentId: contentId,
        contentType: contentType,
        contentMode: contentMode,
        participants: participants,
        provider: providerRef.current
    });
    const getUsers = (0, $42omo.useCallback)((userIds)=>{
        return isGuest || !isLoggedIn || !isLicensed ? (0, $aed2f5bf61ddaaa1$export$9db34321b84dd37a)(userIds) : (0, $9cba87adb0d6c766$export$bf12d28b3016b36b)(userIds);
    }, [
        isGuest,
        isLoggedIn,
        isLicensed
    ]);
    const fetchAnonymousAssetCallback = (0, $42omo.useCallback)(async (id)=>{
        try {
            return await fetchAnonymousAsset(id);
        } catch (error) {
            handleOnFetchError(error);
        }
        return undefined;
    }, [
        fetchAnonymousAsset
    ]);
    const getTotalParticipants = ()=>{
        const uniqueSet = new Set();
        // really just needed for current user id before socket connects, but keeping it simple and just iterate though all participants
        participants.forEach((p)=>uniqueSet.add(p.presenceId));
        // participants from connection
        providerRef.current?.getParticipants().forEach((p_0)=>uniqueSet.add(p_0.presenceId));
        return uniqueSet.size;
    };
    const handleOnFetchError = (error_0)=>{
        // want to prevent an infinite spam of api calls being made
        setNetworkError(error_0);
        (0, $7Sm4c.markErrorAsHandled)(error_0);
    };
    const handleOnPresence = (0, $42omo.useCallback)(()=>{
        const people = providerRef.current?.getParticipants().filter((p_1)=>p_1.isHydrated);
        people?.forEach((participant)=>{
            sessions.current.add(participant.sessionId);
            add(participant);
        });
        const participantSessions = people?.map((p_2)=>p_2.sessionId) ?? [];
        // getParticipants returns all active users, so need to determine which ones to remove
        sessions.current.forEach((sessionId)=>{
            if (!participantSessions.includes(sessionId)) {
                remove(sessionId);
                sessions.current.delete(sessionId);
            }
        });
    }, // don't let this depend on anything with frequent state changes to avoid unnecessary subscriptions and un-subscriptions of the event handling
    [
        add,
        remove
    ]);
    const initializeProvider = (0, $42omo.useCallback)(()=>{
        const permissionTokenRefresh = (0, $8KbKw.fetchCollabPermissionToken)(contentId, undefined);
        const documentAri = `ari:cloud:confluence:${cloudId}:${contentType}/${contentId}`;
        // In order to support deduplication of the collaborator, presenceId will be set to the userId if it exists.
        // This means that anonymous users will still rely on presenceId and not get deduplicated.
        const collaboratorPresenceId = userId ?? presenceIdRef.current;
        const provider = (0, $hvdlr.createSocketIOCollabProvider)({
            url: (0, $6bda54ffb0f4283a$export$cd367e77e21c7f3d)(),
            path: (0, $6bda54ffb0f4283a$export$324e5039614a122a)(cloudId, activationId),
            documentAri: documentAri,
            permissionTokenRefresh: permissionTokenRefresh,
            need404: true,
            isPresenceOnly: true,
            productInfo: {
                product: 'confluence',
                subProduct: 'team-presence'
            },
            batchProps: {
                batchSize: $5748c7d61e5bba21$var$MAX_FETCH_SIZE,
                participantsLimit: undefined,
                getUsers: getUsers,
                onError: handleOnFetchError
            },
            fetchAnonymousAsset: fetchAnonymousAssetCallback,
            presenceId: collaboratorPresenceId,
            presenceActivity: 'viewer'
        });
        // Since we moved to only creating a presence connection on view pages, we should always be a viewer
        provider.setupForPresenceOnly((0, $6bda54ffb0f4283a$export$73e42e5abf6898ab)());
        providerRef.current = provider;
        setIsInitialized(true);
    }, [
        cloudId,
        activationId,
        contentId,
        contentType,
        fetchAnonymousAssetCallback,
        getUsers,
        userId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (shouldCreatePresenceConnection) initializeProvider();
        else setIsInitialized(true);
        // When we don't have a provider and we are not creating a presence connection,
        // we should use the existing collabEditProvider, there was an edge case where this provider wasn't
        // available on the first render.
        if (!providerRef.current && collabEditProvider) providerRef.current = collabEditProvider;
        providerRef.current?.on('presence', handleOnPresence);
        providerRef.current?.on('presence:changed', handleOnPresence);
        providerRef.current?.on('telepointer', addTelepointerData);
        return ()=>{
            providerRef.current?.off('presence', handleOnPresence);
            providerRef.current?.off('presence:changed', handleOnPresence);
            providerRef.current?.off('telepointer', addTelepointerData);
            // we do not want to destroy the live connection, since we didn't create it
            if (shouldCreatePresenceConnection) providerRef.current?.destroy();
        };
    }, [
        addTelepointerData,
        collabEditProvider,
        shouldCreatePresenceConnection,
        initializeProvider,
        handleOnPresence
    ]);
    (0, $42omo.useEffect)(()=>{
        if (shouldCreatePresenceConnection || !collabEditInitialized) return;
        providerRef.current?.sendMessage({
            type: 'participant:activity',
            activity: activity
        });
    }, [
        activity,
        collabEditInitialized,
        shouldCreatePresenceConnection
    ]);
    (0, $42omo.useEffect)(()=>{
        presenceIdRef.current = presenceId;
    }, [
        presenceId
    ]);
    return {
        isInitialized: // used only for testing
        isInitialized,
        // used only for testing
        provider: providerRef.current,
        presenceId: presenceId,
        // want to return DUMMY as a default to preserve activity lookup if provider isn't available yet
        sessionId: providerRef.current?.getSessionId() ?? (0, $6bda54ffb0f4283a$export$a9b806721f7a3927),
        networkError: networkError,
        totalParticipants: getTotalParticipants()
    };
};


const $509bcff20a36ae58$var$i18n = (0, $cgtv4.defineMessages)({
    anonymousUser: {
        id: "team-presence.avatar-group.anonymous-user",
        defaultMessage: "Anonymous Person"
    }
});
const $509bcff20a36ae58$export$7723f8df67e0bef7 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { contentId: contentId, contentMode: contentMode, contentType: contentType, activity: activity, analyticSource: analyticSource } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { sessionId: sessionId, networkError: networkError, totalParticipants: totalParticipants } = (0, $5748c7d61e5bba21$export$457bc606c36b9a3f)(contentId, contentType, contentMode, activity);
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($509bcff20a36ae58$var$i18n.anonymousUser);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== activity || $[3] !== sessionId || $[4] !== t1) {
        t2 = {
            activity: activity,
            sessionId: sessionId,
            anonymousName: t1
        };
        $[2] = activity;
        $[3] = sessionId;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const participants = (0, $2960af57d9597263$export$5a5a291828ecb5e4)(t2);
    if (networkError) {
        let t3;
        if ($[6] !== networkError) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
                name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
                error: networkError
            });
            $[6] = networkError;
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    let t3;
    if ($[8] !== participants) {
        t3 = participants.some($509bcff20a36ae58$var$_temp);
        $[8] = participants;
        $[9] = t3;
    } else t3 = $[9];
    const nonGuestShowsDefaultProfile = t3;
    let t4;
    if ($[10] !== participants) {
        t4 = participants.some($509bcff20a36ae58$var$_temp2);
        $[10] = participants;
        $[11] = t4;
    } else t4 = $[11];
    const showsDefaultProfile = t4;
    let t5;
    if ($[12] !== nonGuestShowsDefaultProfile || $[13] !== showsDefaultProfile) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbc8g.default), {
            data: {
                nonGuestShowsDefaultProfile: nonGuestShowsDefaultProfile,
                showsDefaultProfile: showsDefaultProfile
            }
        });
        $[12] = nonGuestShowsDefaultProfile;
        $[13] = showsDefaultProfile;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== analyticSource || $[16] !== contentId || $[17] !== contentMode || $[18] !== contentType || $[19] !== participants || $[20] !== totalParticipants) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $012cae68941ce2ca$export$fc163eae181faed4), {
            contentId: contentId,
            contentMode: contentMode,
            contentType: contentType,
            analyticSource: analyticSource,
            participants: participants,
            totalParticipants: totalParticipants
        });
        $[15] = analyticSource;
        $[16] = contentId;
        $[17] = contentMode;
        $[18] = contentType;
        $[19] = participants;
        $[20] = totalParticipants;
        $[21] = t6;
    } else t6 = $[21];
    let t7;
    if ($[22] !== t6 || $[23] !== totalParticipants) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($509bcff20a36ae58$var$FlipperAnimationsWrapper, {
            flipKey: totalParticipants
        }, t6);
        $[22] = t6;
        $[23] = totalParticipants;
        $[24] = t7;
    } else t7 = $[24];
    let t8;
    if ($[25] !== t5 || $[26] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t5, t7);
        $[25] = t5;
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    return t8;
} : ({ contentId: contentId, contentMode: contentMode, contentType: contentType, activity: activity, analyticSource: analyticSource })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { sessionId: sessionId, networkError: networkError, totalParticipants: totalParticipants } = (0, $5748c7d61e5bba21$export$457bc606c36b9a3f)(contentId, contentType, contentMode, activity);
    const participants = (0, $2960af57d9597263$export$5a5a291828ecb5e4)({
        activity: activity,
        sessionId: sessionId,
        anonymousName: formatMessage($509bcff20a36ae58$var$i18n.anonymousUser)
    });
    if (networkError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
        error: networkError
    });
    const nonGuestShowsDefaultProfile = participants.some((participant)=>participant.src === '' && !participant.isGuest);
    const showsDefaultProfile = participants.some((participant_0)=>participant_0.src === '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbc8g.default), {
        data: {
            nonGuestShowsDefaultProfile: nonGuestShowsDefaultProfile,
            showsDefaultProfile: showsDefaultProfile
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($509bcff20a36ae58$var$FlipperAnimationsWrapper, {
        flipKey: totalParticipants
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $012cae68941ce2ca$export$fc163eae181faed4), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        analyticSource: analyticSource,
        participants: participants,
        totalParticipants: totalParticipants
    })));
};
const $509bcff20a36ae58$var$FlipperAnimationsWrapper = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { children: children, flipKey: flipKey } = t0;
    if ((0, $6mKj3.expValEquals)("cc-motion-survey-experiment", "cohort", "experiment")) {
        let t1;
        let t2;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {
                stiffness: 200,
                damping: 28
            };
            t2 = {
                default: {
                    speed: 0.3
                }
            };
            $[0] = t1;
            $[1] = t2;
        } else {
            t1 = $[0];
            t2 = $[1];
        }
        let t3;
        if ($[2] !== children || $[3] !== flipKey) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ac008d3f6652bd26$export$3e759dc50fe56038), {
                flipKey: flipKey,
                spring: t1,
                staggerConfig: t2
            }, children);
            $[2] = children;
            $[3] = flipKey;
            $[4] = t3;
        } else t3 = $[4];
        return t3;
    }
    let t1;
    if ($[5] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[5] = children;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ children: children, flipKey: flipKey })=>{
    if ((0, $6mKj3.expValEquals)('cc-motion-survey-experiment', 'cohort', 'experiment')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ac008d3f6652bd26$export$3e759dc50fe56038), {
        flipKey: flipKey,
        spring: {
            stiffness: 200,
            damping: 28
        },
        staggerConfig: {
            default: {
                speed: 0.3
            }
        }
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
function $509bcff20a36ae58$var$_temp(participant) {
    return participant.src === "" && !participant.isGuest;
}
function $509bcff20a36ae58$var$_temp2(participant_0) {
    return participant_0.src === "";
}























// don't have activity for canvas, just default to viewer
const $09642762dd72a71c$var$ACTIVITY = 'viewer';
const $09642762dd72a71c$var$CONTENT_MODE = 'view';
const $09642762dd72a71c$export$4232d0c4c5b2a438 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { collaborators: collaborators, contentId: contentId, contentType: contentType, analyticSource: analyticSource } = t0;
    const initialParticipants = (0, $2960af57d9597263$export$23e4fe06e7659b53)();
    const [t1] = (0, $2VZOl.useNativeCollabPresenceState)();
    const { presenceId: presenceId } = t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $6S5EB.isExternalShareRequest)();
        $[0] = t2;
    } else t2 = $[0];
    const isExternal = t2;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const shouldUsePreloadedCurrentUser = contentType === "database" && !isExternal;
    const createOnClickHandler = $09642762dd72a71c$var$_temp;
    let t3;
    if ($[1] !== initialParticipants || $[2] !== presenceId || $[3] !== shouldUsePreloadedCurrentUser || $[4] !== userId) {
        t3 = (collaborators_0)=>{
            if (!shouldUsePreloadedCurrentUser && collaborators_0?.me) {
                const { me: me } = collaborators_0;
                return {
                    activity: $09642762dd72a71c$var$ACTIVITY,
                    color: me.color,
                    followCursor: me.followCursor,
                    id: me.userId,
                    isCurrentUser: true,
                    name: me.name,
                    onClick: createOnClickHandler(me),
                    src: me.avatar.src ?? "",
                    userId: me.userId
                };
            } else if (shouldUsePreloadedCurrentUser) {
                const currentParticipantId = userId ?? presenceId;
                const currentParticipant = currentParticipantId ? initialParticipants.get(currentParticipantId) : undefined;
                if (currentParticipant) return {
                    activity: $09642762dd72a71c$var$ACTIVITY,
                    id: currentParticipant.id,
                    isCurrentUser: true,
                    isGuest: currentParticipant.isGuest,
                    name: currentParticipant.name,
                    src: currentParticipant.src,
                    userId: currentParticipant.userId
                };
            }
        };
        $[1] = initialParticipants;
        $[2] = presenceId;
        $[3] = shouldUsePreloadedCurrentUser;
        $[4] = userId;
        $[5] = t3;
    } else t3 = $[5];
    const getCurrentUser = t3;
    let result;
    if ($[6] !== collaborators || $[7] !== getCurrentUser) {
        result = [];
        const currentUser = getCurrentUser(collaborators);
        if (currentUser) result.push(currentUser);
        collaborators?.collaborators?.forEach((collaborator_0)=>{
            const id = collaborator_0.userId;
            result.push({
                id: id,
                userId: id,
                name: collaborator_0.name,
                color: collaborator_0.color,
                src: collaborator_0.avatar.src ?? "",
                activity: $09642762dd72a71c$var$ACTIVITY,
                onClick: createOnClickHandler(collaborator_0),
                followCursor: collaborator_0.followCursor
            });
        });
        $[6] = collaborators;
        $[7] = getCurrentUser;
        $[8] = result;
    } else result = $[8];
    const participants = result;
    let t4;
    if ($[9] !== analyticSource || $[10] !== contentId || $[11] !== contentType || $[12] !== participants) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $012cae68941ce2ca$export$fc163eae181faed4), {
            contentId: contentId,
            contentMode: $09642762dd72a71c$var$CONTENT_MODE,
            contentType: contentType,
            analyticSource: analyticSource,
            participants: participants,
            totalParticipants: participants.length
        });
        $[9] = analyticSource;
        $[10] = contentId;
        $[11] = contentType;
        $[12] = participants;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ collaborators: collaborators, contentId: contentId, contentType: contentType, analyticSource: analyticSource })=>{
    const initialParticipants = (0, $2960af57d9597263$export$23e4fe06e7659b53)();
    const [{ presenceId: presenceId }] = (0, $2VZOl.useNativeCollabPresenceState)();
    const isExternal = (0, $6S5EB.isExternalShareRequest)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    // we never want to use the preloaded current user for whiteboards since we depend on the color, since it matches the sticky notes
    const shouldUsePreloadedCurrentUser = contentType === 'database' && !isExternal;
    const createOnClickHandler = (collaborator)=>{
        return collaborator.followCursor === true ? ()=>{
            collaborator.onClick?.();
        } : collaborator.onClick;
    };
    /**
   * If we're not on an external route, get the current cached user; otherwise, wait for current user to come from canvas websocket
   * Here's a more in-depth explanation
   *
   * isExternal = on a public link
   * At this time external routes aren’t SSRd so we can’t preload. As a result, our user won't be cached
   *
   * The possible solutions are
   * - Get external pages to be SSRd (which was too heavy of a lift at this time of implementation)
   * - Add photos to the existing user call in SessionDataQuery or SiteInformationQuery
   * - Just wait for collaborators to come in from websocket connection (which is the current implementation)
   * right now, we have issues until we can preload users on external routes so don't worry about showing current user before socket connection establishes
   * we could ad a preloader for external routes; however, external pages don't appeared to be SSRd.
   *
   * @param isExternal true if we're on an /external route, otherwise false
   * @param collaborators list that comes from canvas websocket connection
   * @returns current user from cache or canvas. Otherwise return undefined
   */ const getCurrentUser = (0, $42omo.useCallback)((collaborators_0)=>{
        if (!shouldUsePreloadedCurrentUser && collaborators_0?.me) {
            const { me: me } = collaborators_0;
            //userId from canvas will already be unidentified if user is anonymous and can't be null
            return {
                activity: $09642762dd72a71c$var$ACTIVITY,
                color: me.color,
                followCursor: me.followCursor,
                id: me.userId,
                isCurrentUser: true,
                name: me.name,
                onClick: createOnClickHandler(me),
                src: me.avatar.src ?? '',
                userId: me.userId
            };
        } else if (shouldUsePreloadedCurrentUser) {
            const currentParticipantId = userId ?? presenceId;
            const currentParticipant = currentParticipantId ? initialParticipants.get(currentParticipantId) : undefined;
            // always want to use the currentParticipant instead of waiting for "me" from collaborators for better performance
            if (currentParticipant) return {
                activity: $09642762dd72a71c$var$ACTIVITY,
                id: currentParticipant.id,
                isCurrentUser: true,
                isGuest: currentParticipant.isGuest,
                name: currentParticipant.name,
                src: currentParticipant.src,
                userId: currentParticipant.userId
            };
        }
        return undefined;
    }, [
        initialParticipants,
        presenceId,
        shouldUsePreloadedCurrentUser,
        userId
    ]);
    const participants = (0, $42omo.useMemo)(()=>{
        const result = [];
        const currentUser = getCurrentUser(collaborators);
        if (currentUser) result.push(currentUser);
        collaborators?.collaborators?.forEach((collaborator_0)=>{
            const id = collaborator_0.userId;
            result.push({
                id: id,
                userId: id,
                name: collaborator_0.name,
                color: collaborator_0.color,
                src: collaborator_0.avatar.src ?? '',
                // we don't have activities on canvas, right now we need to default to viewer as downstream components depend on activity being present
                activity: $09642762dd72a71c$var$ACTIVITY,
                onClick: createOnClickHandler(collaborator_0),
                followCursor: collaborator_0.followCursor
            });
        });
        return result;
    }, [
        collaborators,
        getCurrentUser
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $012cae68941ce2ca$export$fc163eae181faed4), {
        contentId: contentId,
        contentMode: $09642762dd72a71c$var$CONTENT_MODE,
        contentType: contentType,
        analyticSource: analyticSource,
        participants: participants,
        totalParticipants: participants.length
    });
};
function $09642762dd72a71c$var$_temp(collaborator) {
    return collaborator.followCursor === true ? ()=>{
        collaborator.onClick?.();
    } : collaborator.onClick;
}


const $1e82291b1be231ce$var$ContentHeaderPresenceContentSettingsQuery = (0, $axutP.default);
const $1e82291b1be231ce$var$createDefaultParticipant = ({ presenceId: presenceId, activity: activity, user: user, isGuest: isGuest })=>{
    if (!user) return undefined;
    const sessions = {
        [(0, $6bda54ffb0f4283a$export$a9b806721f7a3927)]: {
            activity: activity
        }
    };
    const usablePresenceId = user?.id ?? presenceId;
    return {
        id: usablePresenceId,
        userId: user?.id ?? 'unidentified',
        presenceId: usablePresenceId,
        name: user?.displayName ?? '',
        src: user?.photos?.[0]?.value ?? '',
        isCurrentUser: true,
        isGuest: isGuest,
        sessions: sessions
    };
};
const $1e82291b1be231ce$var$UFO_SEGMENT_NAME = 'content-header-presence';
const $1e82291b1be231ce$export$a8d99186a74b60f6 = ({ collaborators: collaborators, contentId: contentId, contentType: contentType, isViewMode: isViewMode, analyticSource: analyticSource })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const isEditPage = (0, $de2j9.useIsEditorPage)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const { fetchAnonymousAsset: fetchAnonymousAsset } = (0, $fd1de2fc32fd6664$export$ed360de126596689)();
    const isCanvasType = contentType === 'whiteboard' || contentType === 'database';
    const { data: userData, error: userQueryError } = (0, $diswb.useQuery)((0, $eSUdr.default)`query ContentHeaderPresenceUserQuery{user:confluence_atlassianUser(current:true){id displayName photos{value isPrimary}}}`);
    // presenceId is pulled from the native collab state to ensure that we have a consistent presenceId for a given contentId
    // across the collab providers that drive editor as well as presence components (telepointer and avatar colors).
    const [{ presenceId: presenceId }] = (0, $2VZOl.useNativeCollabPresenceState)();
    const presenceIdRef = (0, $42omo.useRef)(presenceId);
    let contentMode = 'view';
    if (isLivePage) contentMode = 'live';
    else if (isEditPage) contentMode = 'edit';
    const activity = contentMode === 'edit' || contentMode === 'live' && (isLiveEditMode || !isViewMode) ? 'editor' : 'viewer';
    const { data: settingData, error: settingsQueryError } = (0, $jMyy4.useQueryInterop)($1e82291b1be231ce$var$ContentHeaderPresenceContentSettingsQuery, {
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey ?? ''
        },
        skip: isCanvasType || contentMode !== 'view'
    });
    const error = userQueryError || settingsQueryError;
    const isSettingEnabledOnView = (0, $42omo.useCallback)(()=>{
        return isCanvasType || settingData?.confluence_teamPresenceContentSetting?.isEnabledOnContentView === true;
    }, [
        isCanvasType,
        settingData
    ]);
    const handleError = (err)=>{
        experienceTracker.fail({
            name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
            error: err
        });
        (0, $7Sm4c.markErrorAsHandled)(err);
        return null;
    };
    if (!contentType) return null;
    if (error) handleError(error);
    if (contentMode === 'view' && !isSettingEnabledOnView()) {
        experienceTracker.abort({
            name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
            reason: `Real-time visibility is disabled on view mode`
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2960af57d9597263$export$f642eede20cf74c0), {
        participant: $1e82291b1be231ce$var$createDefaultParticipant({
            presenceId: presenceIdRef.current,
            activity: activity,
            user: userData?.user,
            isGuest: isGuest
        }),
        fetchAnonymousAsset: fetchAnonymousAsset,
        onError: handleError
    }, isCanvasType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $09642762dd72a71c$export$4232d0c4c5b2a438), {
        collaborators: collaborators,
        contentId: contentId,
        contentType: contentType,
        analyticSource: analyticSource
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $509bcff20a36ae58$export$7723f8df67e0bef7), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        activity: activity,
        analyticSource: analyticSource
    }));
};
const $1e82291b1be231ce$export$52baa28b583c9835 = (0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(6);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1e82291b1be231ce$export$a8d99186a74b60f6, props);
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== props.contentId || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).COLLABORATION_PRESENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: $1e82291b1be231ce$var$UFO_SEGMENT_NAME
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
            scope: props.contentId
        }, t0, t1)));
        $[3] = props.contentId;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION_PRESENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: $1e82291b1be231ce$var$UFO_SEGMENT_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
        scope: props.contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1e82291b1be231ce$export$a8d99186a74b60f6, props))));
};
module.exports["ContentHeaderPresenceComponent"] = $1e82291b1be231ce$export$a8d99186a74b60f6;
module.exports["ContentHeaderPresence"] = $1e82291b1be231ce$export$52baa28b583c9835;

});

parcelRegister("axutP", function(module, exports) {
/**
 * @generated SignedSource<<0c9440ce87b304c8d3a2ca3a70175e28>>
 * @relayHash fa5b50f9c89692d4dd86caf1df42c2d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a
const $972689412971ec2f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceTeamPresence",
            "kind": "LinkedField",
            "name": "confluence_teamPresenceContentSetting",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEnabledOnContentView"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fa5b50f9c89692d4dd86caf1df42c2d1",
            "id": "60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a",
            "metadata": {},
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "operationKind": "query",
            "text": "query ContentHeaderPresenceContentSettingsQuery($cloudId:ID!,$spaceKey:String!){confluence_teamPresenceContentSetting(cloudId:$cloudId,spaceKey:$spaceKey){isEnabledOnContentView}}"
        }
    };
}();
$972689412971ec2f$var$node.hash = "d0f958354cdf65029012c243a64d4874";
var $972689412971ec2f$export$2e2bcd8739ae039 = $972689412971ec2f$var$node;
module.exports["default"] = $972689412971ec2f$export$2e2bcd8739ae039;

});

parcelRegister("2VZOl", function(module, exports) {

var $FOT9i = parcelRequire("FOT9i");

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $9HkI0 = parcelRequire("9HkI0");

const $a3221c0e46c131d6$export$cd763072e62a98fa = (0, $FOT9i.createContainer)();
const $a3221c0e46c131d6$var$Store = (0, $1P1Tu.createStore)({
    containedBy: $a3221c0e46c131d6$export$cd763072e62a98fa,
    initialState: {
        presenceId: ''
    },
    actions: {},
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    presenceId: (0, $9HkI0.v4)()
                });
            }
    }
});
const $a3221c0e46c131d6$export$f529db6cceb299f5 = (0, $9zUhf.createHook)($a3221c0e46c131d6$var$Store);
module.exports["NativeCollabPresenceStateContainer"] = $a3221c0e46c131d6$export$cd763072e62a98fa;
module.exports["useNativeCollabPresenceState"] = $a3221c0e46c131d6$export$f529db6cceb299f5;

});

parcelRegister("de2j9", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
} : ()=>(0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("jyw2s", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");

function $514d44140915e951$export$c14f61804029af13(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = (hash & hash) >>> 0;
    /* eslint-enable no-bitwise */ }
    return hash;
}
function $514d44140915e951$export$60ba61eca4eb64f2(str) {
    const index = $514d44140915e951$export$c14f61804029af13(str) % (0, $aFUXX.participantColors).length;
    return {
        index: index,
        color: (0, $aFUXX.participantColors)[index]
    };
}
module.exports["getHashCode"] = $514d44140915e951$export$c14f61804029af13;
module.exports["getParticipantColor"] = $514d44140915e951$export$60ba61eca4eb64f2;

});

parcelRegister("5ig3T", function(module, exports) {
/*! @license Rematrix v0.2.2

	Copyright 2018 Fisssion LLC.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
*/ /**
 * @module Rematrix
 */ /**
 * Transformation matrices in the browser come in two flavors:
 *
 *  - `matrix` using 6 values (short)
 *  - `matrix3d` using 16 values (long)
 *
 * This utility follows this [conversion guide](https://goo.gl/EJlUQ1)
 * to expand short form matrices to their equivalent long form.
 *
 * @param  {array} source - Accepts both short and long form matrices.
 * @return {array}
 */ function $2484436ba15d114c$export$d9468344d3651243(source) {
    if (source.constructor !== Array) throw new TypeError('Expected array.');
    if (source.length === 16) return source;
    if (source.length === 6) {
        var matrix = $2484436ba15d114c$export$f0954fd7d5368655();
        matrix[0] = source[0];
        matrix[1] = source[1];
        matrix[4] = source[2];
        matrix[5] = source[3];
        matrix[12] = source[4];
        matrix[13] = source[5];
        return matrix;
    }
    throw new RangeError('Expected array with either 6 or 16 values.');
}
/**
 * Returns a matrix representing no transformation. The product of any matrix
 * multiplied by the identity matrix will be the original matrix.
 *
 * > **Tip:** Similar to how `5 * 1 === 5`, where `1` is the identity.
 *
 * @return {array}
 */ function $2484436ba15d114c$export$f0954fd7d5368655() {
    var matrix = [];
    for(var i = 0; i < 16; i++)i % 5 == 0 ? matrix.push(1) : matrix.push(0);
    return matrix;
}
/**
 * Returns a matrix describing the inverse transformation of the source
 * matrix. The product of any matrix multiplied by its inverse will be the
 * identity matrix.
 *
 * > **Tip:** Similar to how `5 * (1/5) === 1`, where `1/5` is the inverse.
 *
 * @param  {array} source - Accepts both short and long form matrices.
 * @return {array}
 */ function $2484436ba15d114c$export$70ae2c07e401031b(source) {
    var m = $2484436ba15d114c$export$d9468344d3651243(source);
    var s0 = m[0] * m[5] - m[4] * m[1];
    var s1 = m[0] * m[6] - m[4] * m[2];
    var s2 = m[0] * m[7] - m[4] * m[3];
    var s3 = m[1] * m[6] - m[5] * m[2];
    var s4 = m[1] * m[7] - m[5] * m[3];
    var s5 = m[2] * m[7] - m[6] * m[3];
    var c5 = m[10] * m[15] - m[14] * m[11];
    var c4 = m[9] * m[15] - m[13] * m[11];
    var c3 = m[9] * m[14] - m[13] * m[10];
    var c2 = m[8] * m[15] - m[12] * m[11];
    var c1 = m[8] * m[14] - m[12] * m[10];
    var c0 = m[8] * m[13] - m[12] * m[9];
    var determinant = 1 / (s0 * c5 - s1 * c4 + s2 * c3 + s3 * c2 - s4 * c1 + s5 * c0);
    if (isNaN(determinant) || determinant === Infinity) throw new Error('Inverse determinant attempted to divide by zero.');
    return [
        (m[5] * c5 - m[6] * c4 + m[7] * c3) * determinant,
        (-m[1] * c5 + m[2] * c4 - m[3] * c3) * determinant,
        (m[13] * s5 - m[14] * s4 + m[15] * s3) * determinant,
        (-m[9] * s5 + m[10] * s4 - m[11] * s3) * determinant,
        (-m[4] * c5 + m[6] * c2 - m[7] * c1) * determinant,
        (m[0] * c5 - m[2] * c2 + m[3] * c1) * determinant,
        (-m[12] * s5 + m[14] * s2 - m[15] * s1) * determinant,
        (m[8] * s5 - m[10] * s2 + m[11] * s1) * determinant,
        (m[4] * c4 - m[5] * c2 + m[7] * c0) * determinant,
        (-m[0] * c4 + m[1] * c2 - m[3] * c0) * determinant,
        (m[12] * s4 - m[13] * s2 + m[15] * s0) * determinant,
        (-m[8] * s4 + m[9] * s2 - m[11] * s0) * determinant,
        (-m[4] * c3 + m[5] * c1 - m[6] * c0) * determinant,
        (m[0] * c3 - m[1] * c1 + m[2] * c0) * determinant,
        (-m[12] * s3 + m[13] * s1 - m[14] * s0) * determinant,
        (m[8] * s3 - m[9] * s1 + m[10] * s0) * determinant
    ];
}
/**
 * Returns a 4x4 matrix describing the combined transformations
 * of both arguments.
 *
 * > **Note:** Order is very important. For example, rotating 45°
 * along the Z-axis, followed by translating 500 pixels along the
 * Y-axis... is not the same as translating 500 pixels along the
 * Y-axis, followed by rotating 45° along on the Z-axis.
 *
 * @param  {array} m - Accepts both short and long form matrices.
 * @param  {array} x - Accepts both short and long form matrices.
 * @return {array}
 */ function $2484436ba15d114c$export$2060d2db72cce88f(m, x) {
    var fm = $2484436ba15d114c$export$d9468344d3651243(m);
    var fx = $2484436ba15d114c$export$d9468344d3651243(x);
    var product = [];
    for(var i = 0; i < 4; i++){
        var row = [
            fm[i],
            fm[i + 4],
            fm[i + 8],
            fm[i + 12]
        ];
        for(var j = 0; j < 4; j++){
            var k = j * 4;
            var col = [
                fx[k],
                fx[k + 1],
                fx[k + 2],
                fx[k + 3]
            ];
            var result = row[0] * col[0] + row[1] * col[1] + row[2] * col[2] + row[3] * col[3];
            product[i + k] = result;
        }
    }
    return product;
}
/**
 * Attempts to return a 4x4 matrix describing the CSS transform
 * matrix passed in, but will return the identity matrix as a
 * fallback.
 *
 * **Tip:** In virtually all cases, this method is used to convert
 * a CSS matrix (retrieved as a `string` from computed styles) to
 * its equivalent array format.
 *
 * @param  {string} source - String containing a valid CSS `matrix` or `matrix3d` property.
 * @return {array}
 */ function $2484436ba15d114c$export$98e6a39c04603d36(source) {
    if (typeof source === 'string') {
        var match = source.match(/matrix(3d)?\(([^)]+)\)/);
        if (match) {
            var raw = match[2].split(', ').map(parseFloat);
            return $2484436ba15d114c$export$d9468344d3651243(raw);
        }
    }
    return $2484436ba15d114c$export$f0954fd7d5368655();
}
/**
 * Returns a 4x4 matrix describing Z-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $2484436ba15d114c$export$bb628a54ab399bc9(angle) {
    return $2484436ba15d114c$export$ea6eae3365de5b9c(angle);
}
/**
 * Returns a 4x4 matrix describing X-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $2484436ba15d114c$export$a59c8716592e09af(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $2484436ba15d114c$export$f0954fd7d5368655();
    matrix[5] = matrix[10] = Math.cos(theta);
    matrix[6] = matrix[9] = Math.sin(theta);
    matrix[9] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $2484436ba15d114c$export$cf71e4d4ca4d1cfd(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $2484436ba15d114c$export$f0954fd7d5368655();
    matrix[0] = matrix[10] = Math.cos(theta);
    matrix[2] = matrix[8] = Math.sin(theta);
    matrix[2] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $2484436ba15d114c$export$ea6eae3365de5b9c(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $2484436ba15d114c$export$f0954fd7d5368655();
    matrix[0] = matrix[5] = Math.cos(theta);
    matrix[1] = matrix[4] = Math.sin(theta);
    matrix[4] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing 2D scaling. The first argument
 * is used for both X and Y-axis scaling, unless an optional
 * second argument is provided to explicitly define Y-axis scaling.
 *
 * @param  {number} scalar    - Decimal multiplier.
 * @param  {number} [scalarY] - Decimal multiplier.
 * @return {array}
 */ function $2484436ba15d114c$export$dcdf75081b88279d(scalar, scalarY) {
    var matrix = $2484436ba15d114c$export$f0954fd7d5368655();
    matrix[0] = scalar;
    matrix[5] = typeof scalarY === 'number' ? scalarY : scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $2484436ba15d114c$export$55295ade51f88202(scalar) {
    var matrix = $2484436ba15d114c$export$f0954fd7d5368655();
    matrix[0] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $2484436ba15d114c$export$2092e2a44ac13bb2(scalar) {
    var matrix = $2484436ba15d114c$export$f0954fd7d5368655();
    matrix[5] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $2484436ba15d114c$export$13034b1ece9569d5(scalar) {
    var matrix = $2484436ba15d114c$export$f0954fd7d5368655();
    matrix[10] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing shear. The first argument
 * defines X-axis shearing, and an optional second argument
 * defines Y-axis shearing.
 *
 * @param  {number} angleX   - Measured in degrees.
 * @param  {number} [angleY] - Measured in degrees.
 * @return {array}
 */ function $2484436ba15d114c$export$dd2d5a892675faf1(angleX, angleY) {
    var thetaX = Math.PI / 180 * angleX;
    var matrix = $2484436ba15d114c$export$f0954fd7d5368655();
    matrix[4] = Math.tan(thetaX);
    if (angleY) {
        var thetaY = Math.PI / 180 * angleY;
        matrix[1] = Math.tan(thetaY);
    }
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis shear.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $2484436ba15d114c$export$e446fc4c2803fd1b(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $2484436ba15d114c$export$f0954fd7d5368655();
    matrix[4] = Math.tan(theta);
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis shear.
 *
 * @param  {number} angle - Measured in degrees
 * @return {array}
 */ function $2484436ba15d114c$export$1649e48e73861f36(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $2484436ba15d114c$export$f0954fd7d5368655();
    matrix[1] = Math.tan(theta);
    return matrix;
}
/**
 * Returns a 4x4 matrix describing 2D translation. The first
 * argument defines X-axis translation, and an optional second
 * argument defines Y-axis translation.
 *
 * @param  {number} distanceX   - Measured in pixels.
 * @param  {number} [distanceY] - Measured in pixels.
 * @return {array}
 */ function $2484436ba15d114c$export$d73ee8ef04f5226a(distanceX, distanceY) {
    var matrix = $2484436ba15d114c$export$f0954fd7d5368655();
    matrix[12] = distanceX;
    if (distanceY) matrix[13] = distanceY;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $2484436ba15d114c$export$5667f2d3f182f284(distance) {
    var matrix = $2484436ba15d114c$export$f0954fd7d5368655();
    matrix[12] = distance;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $2484436ba15d114c$export$a1f0f3245f0cf0a4(distance) {
    var matrix = $2484436ba15d114c$export$f0954fd7d5368655();
    matrix[13] = distance;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $2484436ba15d114c$export$6e43fd17fc519956(distance) {
    var matrix = $2484436ba15d114c$export$f0954fd7d5368655();
    matrix[14] = distance;
    return matrix;
}


var e = function(t) {
    return "number" == typeof t;
}, i = function(t) {
    return "function" == typeof t;
}, n = function(t) {
    return "[object Object]" === Object.prototype.toString.call(t);
}, r = function(t) {
    return Array.prototype.slice.apply(t);
}, s = function(t) {
    var e = t.reduce(function(t, e) {
        return t[e] = (t[e] || 0) + 1, t;
    }, {});
    return Object.keys(e).filter(function(t) {
        return e[t] > 1;
    });
};
function a(t) {
    return [].slice.call(arguments, 1).forEach(function(e) {
        if (e) for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }), t;
}
var o, l = function(t, e, i) {
    return t + (e - t) * i;
}, p = {
    __proto__: null,
    isNumber: e,
    isFunction: i,
    isObject: n,
    toArray: r,
    getDuplicateValsAsStrings: s,
    assign: a,
    tweenProp: l
}, c = "data-flip-id", u = "data-inverse-flip-id", d = "data-portal-key", f = "data-exit-container", h = {
    __proto__: null,
    DATA_FLIP_ID: c,
    DATA_INVERSE_FLIP_ID: u,
    DATA_FLIP_COMPONENT_ID: "data-flip-component-id",
    DATA_FLIP_CONFIG: "data-flip-config",
    DATA_PORTAL_KEY: d,
    DATA_EXIT_CONTAINER: f
}, g = {
    noWobble: {
        stiffness: 200,
        damping: 26
    },
    gentle: {
        stiffness: 120,
        damping: 14
    },
    veryGentle: {
        stiffness: 130,
        damping: 17
    },
    wobbly: {
        stiffness: 180,
        damping: 12
    },
    stiff: {
        stiffness: 260,
        damping: 26
    }
}, m = function(t) {
    return n(t) ? t : Object.keys(g).indexOf(t) > -1 ? g[t] : {};
};
"undefined" != typeof window && (o = window.requestAnimationFrame);
var v = o = o || function(t) {
    window.setTimeout(t, 1e3 / 60);
}, y = Date.now(), _ = "object" == typeof performance && "function" == typeof performance.now ? function() {
    return performance.now();
} : function() {
    return Date.now() - y;
};
function S(t, e) {
    var i = t.indexOf(e);
    -1 !== i && t.splice(i, 1);
}
var E = /*#__PURE__*/ function() {
    function t() {}
    return t.prototype.run = function() {
        var t = this;
        v(function() {
            t.springSystem.loop(_());
        });
    }, t;
}(), A = function() {
    this.position = 0, this.velocity = 0;
}, C = 0, b = .001, I = /*#__PURE__*/ function() {
    function t(t) {
        this._id = "s" + C++, this._springSystem = t, this.listeners = [], this._startValue = 0, this._currentState = new A, this._displacementFromRestThreshold = .001, this._endValue = 0, this._overshootClampingEnabled = !1, this._previousState = new A, this._restSpeedThreshold = .001, this._tempState = new A, this._timeAccumulator = 0, this._wasAtRest = !0, this._cachedSpringConfig = {};
    }
    var e = t.prototype;
    return e.getId = function() {
        return this._id;
    }, e.destroy = function() {
        this.listeners = [], this._springSystem.deregisterSpring(this);
    }, e.setSpringConfig = function(t) {
        return this._springConfig = t, this;
    }, e.getCurrentValue = function() {
        return this._currentState.position;
    }, e.getDisplacementDistanceForState = function(t) {
        return Math.abs(this._endValue - t.position);
    }, e.setEndValue = function(t) {
        if (t === this._endValue) return this;
        if (this.prevEndValue = t, this._endValue === t && this.isAtRest()) return this;
        this._startValue = this.getCurrentValue(), this._endValue = t, this._springSystem.activateSpring(this.getId());
        for(var e = 0, i = this.listeners.length; e < i; e++){
            var n = this.listeners[e].onSpringEndStateChange;
            n && n(this);
        }
        return this;
    }, e.setVelocity = function(t) {
        return t === this._currentState.velocity || (this._currentState.velocity = t, this._springSystem.activateSpring(this.getId())), this;
    }, e.setCurrentValue = function(t) {
        this._startValue = t, this._currentState.position = t;
        for(var e = 0, i = this.listeners.length; e < i; e++){
            var n = this.listeners[e];
            n.onSpringUpdate && n.onSpringUpdate(this);
        }
        return this;
    }, e.setAtRest = function() {
        return this._endValue = this._currentState.position, this._tempState.position = this._currentState.position, this._currentState.velocity = 0, this;
    }, e.setOvershootClampingEnabled = function(t) {
        return this._overshootClampingEnabled = t, this;
    }, e.isOvershooting = function() {
        var t = this._startValue, e = this._endValue;
        return this._springConfig.tension > 0 && (t < e && this.getCurrentValue() > e || t > e && this.getCurrentValue() < e);
    }, e.advance = function(t, e) {
        var i = this.isAtRest();
        if (!i || !this._wasAtRest) {
            var n = e;
            e > .064 && (n = .064), this._timeAccumulator += n;
            for(var r, s, a, o, l, p, c = this._springConfig.tension, u = this._springConfig.friction, d = this._currentState.position, f = this._currentState.velocity, h = this._tempState.position, g = this._tempState.velocity; this._timeAccumulator >= b;)this._timeAccumulator -= b, this._timeAccumulator < b && (this._previousState.position = d, this._previousState.velocity = f), s = c * (this._endValue - h) - u * f, o = c * (this._endValue - (h = d + (r = f) * b * .5)) - u * (g = f + s * b * .5), p = c * (this._endValue - (h = d + (a = g) * b * .5)) - u * (g = f + o * b * .5), h = d + (l = g) * b, d += 1 / 6 * (r + 2 * (a + l) + (g = f + p * b)) * b, f += 1 / 6 * (s + 2 * (o + p) + (c * (this._endValue - h) - u * g)) * b;
            this._tempState.position = h, this._tempState.velocity = g, this._currentState.position = d, this._currentState.velocity = f, this._timeAccumulator > 0 && this._interpolate(this._timeAccumulator / b), (this.isAtRest() || this._overshootClampingEnabled && this.isOvershooting()) && (this._springConfig.tension > 0 ? (this._startValue = this._endValue, this._currentState.position = this._endValue) : (this._endValue = this._currentState.position, this._startValue = this._endValue), this.setVelocity(0), i = !0);
            var m = !1;
            this._wasAtRest && (this._wasAtRest = !1, m = !0);
            var v = !1;
            i && (this._wasAtRest = !0, v = !0), this.notifyPositionUpdated(m, v);
        }
    }, e.notifyPositionUpdated = function(t, e) {
        var i = this;
        this.listeners.filter(Boolean).forEach(function(n) {
            t && n.onSpringActivate && !i._onActivateCalled && (n.onSpringActivate(i), i._onActivateCalled = !0), n.onSpringUpdate && n.onSpringUpdate(i), e && n.onSpringAtRest && n.onSpringAtRest(i);
        });
    }, e.systemShouldAdvance = function() {
        return !this.isAtRest() || !this.wasAtRest();
    }, e.wasAtRest = function() {
        return this._wasAtRest;
    }, e.isAtRest = function() {
        return Math.abs(this._currentState.velocity) < this._restSpeedThreshold && (this.getDisplacementDistanceForState(this._currentState) <= this._displacementFromRestThreshold || 0 === this._springConfig.tension);
    }, e._interpolate = function(t) {
        this._currentState.position = this._currentState.position * t + this._previousState.position * (1 - t), this._currentState.velocity = this._currentState.velocity * t + this._previousState.velocity * (1 - t);
    }, e.addListener = function(t) {
        return this.listeners.push(t), this;
    }, e.addOneTimeListener = function(t) {
        var e = this;
        return Object.keys(t).forEach(function(i) {
            var n;
            t[i] = (n = t[i], function() {
                n.apply(void 0, [].slice.call(arguments)), e.removeListener(t);
            });
        }), this.listeners.push(t), this;
    }, e.removeListener = function(t) {
        return S(this.listeners, t), this;
    }, t;
}(), w = /*#__PURE__*/ function() {
    function t(t) {
        this.looper = t || new E, this.looper.springSystem = this, this.listeners = [], this._activeSprings = [], this._idleSpringIndices = [], this._isIdle = !0, this._lastTimeMillis = -1, this._springRegistry = {};
    }
    var e = t.prototype;
    return e.createSpring = function(t, e) {
        return this.createSpringWithConfig({
            tension: t,
            friction: e
        });
    }, e.createSpringWithConfig = function(t) {
        var e = new I(this);
        return this.registerSpring(e), e.setSpringConfig(t), e;
    }, e.getIsIdle = function() {
        return this._isIdle;
    }, e.registerSpring = function(t) {
        this._springRegistry[t.getId()] = t;
    }, e.deregisterSpring = function(t) {
        S(this._activeSprings, t), delete this._springRegistry[t.getId()];
    }, e.advance = function(t, e) {
        for(var i = this; this._idleSpringIndices.length > 0;)this._idleSpringIndices.pop();
        for(this._activeSprings.filter(Boolean).forEach(function(n) {
            n.systemShouldAdvance() ? n.advance(t / 1e3, e / 1e3) : i._idleSpringIndices.push(i._activeSprings.indexOf(n));
        }); this._idleSpringIndices.length > 0;){
            var n = this._idleSpringIndices.pop();
            n >= 0 && this._activeSprings.splice(n, 1);
        }
    }, e.loop = function(t) {
        var e;
        -1 === this._lastTimeMillis && (this._lastTimeMillis = t - 1);
        var i = t - this._lastTimeMillis;
        this._lastTimeMillis = t;
        var n = 0, r = this.listeners.length;
        for(n = 0; n < r; n++)(e = this.listeners[n]).onBeforeIntegrate && e.onBeforeIntegrate(this);
        for(this.advance(t, i), 0 === this._activeSprings.length && (this._isIdle = !0, this._lastTimeMillis = -1), n = 0; n < r; n++)(e = this.listeners[n]).onAfterIntegrate && e.onAfterIntegrate(this);
        this._isIdle || this.looper.run();
    }, e.activateSpring = function(t) {
        var e = this._springRegistry[t];
        -1 === this._activeSprings.indexOf(e) && this._activeSprings.push(e), this.getIsIdle() && (this._isIdle = !1, this.looper.run());
    }, t;
}(), O = new w, x = function(t) {
    var e = t.springConfig, i = e.overshootClamping, n = t.getOnUpdateFunc, r = t.onAnimationEnd, s = t.onSpringActivate, a = O.createSpring(e.stiffness, e.damping);
    a.setOvershootClampingEnabled(!!i);
    var o = {
        onSpringActivate: s,
        onSpringAtRest: function() {
            a.destroy(), r();
        },
        onSpringUpdate: n({
            spring: a,
            onAnimationEnd: r
        })
    };
    return a.addListener(o), a;
}, U = function(t) {
    var e = x(t);
    return e.setEndValue(1), e;
}, V = function(t, e) {
    if (void 0 === e && (e = {}), t && t.length) {
        e.reverse && t.reverse();
        var i, n = "number" != typeof (i = e.speed) ? 1.1 : 1 + Math.min(Math.max(5 * i, 0), 5), r = 1 / Math.max(Math.min(t.length, 100), 10), s = t.map(function(t, e) {
            var i = t.getOnUpdateFunc;
            return t.getOnUpdateFunc = function(t) {
                var a = i(t);
                return function(t) {
                    var i = t.getCurrentValue();
                    (i = i < .01 ? 0 : i > .99 ? 1 : i) >= r && s[e + 1] && s[e + 1](Math.max(Math.min(i * n, 1), 0)), a(t);
                };
            }, t;
        }).map(function(t) {
            var e = x(t);
            if (e) return e.setEndValue.bind(e);
        }).filter(Boolean);
        s[0] && s[0](1);
    }
}, F = function(t) {
    return [
        0,
        1,
        4,
        5,
        12,
        13
    ].map(function(e) {
        return t[e];
    });
}, P = function(t) {
    return t.top < window.innerHeight && t.bottom > 0 && t.left < window.innerWidth && t.right > 0;
};
function D(t) {
    return JSON.parse(t.dataset.flipConfig || "{}");
}
var R = function(t, e) {
    var i;
    return a(t, ((i = {})[e[0]] = e[1], i));
}, T = function(t, e) {
    return r(e ? document.querySelectorAll("[" + d + '="' + e + '"]') : t.querySelectorAll("[" + c + "]"));
}, M = function(t) {
    return t.map(function(t) {
        return [
            t,
            t.getBoundingClientRect()
        ];
    });
}, k = !0, j = function() {
    return k = !1;
}, B = function() {
    return k = !0;
}, N = function() {
    return k;
}, L = function(n) {
    var o = n.cachedOrderedFlipIds, p = void 0 === o ? [] : o, f = n.inProgressAnimations, h = void 0 === f ? {} : f, v = n.flippedElementPositionsBeforeUpdate, y = void 0 === v ? {} : v, _ = n.flipCallbacks, S = void 0 === _ ? {} : _, E = n.containerEl, A = n.applyTransformOrigin, C = n.spring, b = n.debug, I = n.portalKey, w = n.staggerConfig, O = void 0 === w ? {} : w, x = n.decisionData, j = void 0 === x ? {} : x, B = n.handleEnterUpdateDelete, N = n.onComplete, L = n.onStart;
    if (k && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        var q, X = M(T((q = {
            element: E,
            portalKey: I
        }).element, q.portalKey)).map(function(t) {
            var e = t[0], i = t[1], n = window.getComputedStyle(e);
            return [
                e.dataset.flipId,
                {
                    element: e,
                    rect: i,
                    opacity: parseFloat(n.opacity),
                    transform: n.transform
                }
            ];
        }).reduce(R, {}), Y = function(t) {
            var e = t.containerEl, i = t.portalKey;
            return i ? function(t) {
                return function(e) {
                    return r(document.querySelectorAll("[" + d + '="' + t + '"]' + e));
                };
            }(i) : e ? function(t) {
                var e = Math.random().toFixed(5);
                return t.dataset.flipperId = e, function(i) {
                    return r(t.querySelectorAll('[data-flipper-id="' + e + '"] ' + i));
                };
            }(e) : function() {
                return [];
            };
        }({
            containerEl: E,
            portalKey: I
        }), W = function(t) {
            return function(e) {
                return t("[" + c + '="' + e + '"]')[0];
            };
        }(Y), K = function(t) {
            return y[t] && X[t];
        }, H = Object.keys(y).concat(Object.keys(X)).filter(function(t) {
            return !K(t);
        }), J = {
            flipCallbacks: S,
            getElement: W,
            flippedElementPositionsBeforeUpdate: y,
            flippedElementPositionsAfterUpdate: X,
            inProgressAnimations: h,
            decisionData: j
        }, z = function(t) {
            var e, i = t.unflippedIds, n = t.flipCallbacks, r = t.getElement, s = t.flippedElementPositionsBeforeUpdate, a = t.flippedElementPositionsAfterUpdate, o = t.inProgressAnimations, l = t.decisionData, p = i.filter(function(t) {
                return a[t];
            }).filter(function(t) {
                return n[t] && n[t].onAppear;
            }), c = i.filter(function(t) {
                return s[t] && n[t] && n[t].onExit;
            }), u = new Promise(function(t) {
                e = t;
            }), d = [], f = 0, h = c.map(function(t, i) {
                var r = s[t].domDataForExitAnimations, a = r.element, p = r.parent, c = r.childPosition, u = c.top, h = c.left, g = c.width, m = c.height;
                "static" === getComputedStyle(p).position && (p.style.position = "relative"), a.style.transform = "matrix(1, 0, 0, 1, 0, 0)", a.style.position = "absolute", a.style.top = u + "px", a.style.left = h + "px", a.style.height = m + "px", a.style.width = g + "px";
                var v = d.filter(function(t) {
                    return t[0] === p;
                })[0];
                v || (v = [
                    p,
                    document.createDocumentFragment()
                ], d.push(v)), v[1].appendChild(a), f += 1;
                var y = function() {
                    try {
                        p.removeChild(a);
                    } catch (t) {} finally{
                        0 == (f -= 1) && e();
                    }
                };
                return o[t] = {
                    stop: y
                }, function() {
                    return n[t].onExit(a, i, y, l);
                };
            });
            return d.forEach(function(t) {
                t[0].appendChild(t[1]);
            }), h.length || e(), {
                hideEnteringElements: function() {
                    p.forEach(function(t) {
                        var e = r(t);
                        e && (e.style.opacity = "0");
                    });
                },
                animateEnteringElements: function() {
                    p.forEach(function(t, e) {
                        var i = r(t);
                        i && n[t].onAppear(i, e, l);
                    });
                },
                animateExitingElements: function() {
                    return h.forEach(function(t) {
                        return t();
                    }), u;
                }
            };
        }(a({}, J, {
            unflippedIds: H
        })), G = z.hideEnteringElements, Q = z.animateEnteringElements, Z = z.animateExitingElements, $ = a({}, J, {
            containerEl: E,
            flippedIds: p.filter(K),
            applyTransformOrigin: A,
            spring: C,
            debug: b,
            staggerConfig: O,
            scopedSelector: Y,
            onComplete: N
        });
        L && L(E, j);
        var tt = function(n) {
            var o, p = n.flippedIds, c = n.flipCallbacks, d = n.inProgressAnimations, f = n.flippedElementPositionsBeforeUpdate, h = n.flippedElementPositionsAfterUpdate, v = n.applyTransformOrigin, y = n.spring, _ = n.getElement, S = n.debug, E = n.staggerConfig, A = void 0 === E ? {} : E, C = n.decisionData, b = void 0 === C ? {} : C, I = n.onComplete, w = n.containerEl, O = new Promise(function(t) {
                o = t;
            });
            if (I && O.then(function() {
                return I(w, b);
            }), !p.length) return function() {
                return o([]), O;
            };
            var x = [], R = _(p[0]), T = R ? R.ownerDocument.querySelector("body") : document.querySelector("body");
            s(p);
            var M = p.map(function(n) {
                var s = f[n].rect, p = h[n].rect, _ = f[n].opacity, S = h[n].opacity, E = p.width < 1 || p.height < 1, A = h[n].element;
                if (!P(s) && !P(p)) return !1;
                if (!A) return !1;
                var C, I, w, O = D(A), U = (w = (I = (C = {
                    flipperSpring: y,
                    flippedSpring: O.spring
                }, C)).flippedSpring, a({}, g.noWobble, m(I.flipperSpring), m(w))), V = !0 === O.stagger ? "default" : O.stagger, R = {
                    element: A,
                    id: n,
                    stagger: V,
                    springConfig: U
                };
                if (c[n] && c[n].shouldFlip && !c[n].shouldFlip(b.previous, b.current)) return !1;
                var k = Math.abs(s.left - p.left) + Math.abs(s.top - p.top), j = Math.abs(s.width - p.width) + Math.abs(s.height - p.height), B = Math.abs(S - _);
                if (0 === s.height && 0 === p.height || 0 === s.width && 0 === p.width || k < .5 && j < .5 && B < .01) return !1;
                var N = $2484436ba15d114c$export$98e6a39c04603d36(h[n].transform), L = {
                    matrix: N
                }, q = {
                    matrix: []
                }, X = [
                    N
                ];
                O.translate && (X.push($2484436ba15d114c$export$5667f2d3f182f284(s.left - p.left)), X.push($2484436ba15d114c$export$a1f0f3245f0cf0a4(s.top - p.top))), O.scale && (X.push($2484436ba15d114c$export$55295ade51f88202(Math.max(s.width, 1) / Math.max(p.width, 1))), X.push($2484436ba15d114c$export$2092e2a44ac13bb2(Math.max(s.height, 1) / Math.max(p.height, 1)))), O.opacity && (q.opacity = _, L.opacity = S);
                var Y = [];
                if (!c[n] || !c[n].shouldInvert || c[n].shouldInvert(b.previous, b.current)) {
                    var W = function(t, e) {
                        return r(t.querySelectorAll("[" + u + '="' + e + '"]'));
                    }(A, n);
                    Y = W.map(function(t) {
                        return [
                            t,
                            D(t)
                        ];
                    });
                }
                q.matrix = F(X.reduce($2484436ba15d114c$export$2060d2db72cce88f)), L.matrix = F(L.matrix);
                var K, H = function(t) {
                    var i = t.element, n = t.invertedChildren, r = t.body;
                    return function(t) {
                        var s = t.matrix, a = t.opacity, o = t.forceMinVals;
                        if (e(a) && (i.style.opacity = a + ""), o && (i.style.minHeight = "1px", i.style.minWidth = "1px"), s) {
                            var l = function(t) {
                                return "matrix(" + t.join(", ") + ")";
                            }(s);
                            i.style.transform = l, n && function(t) {
                                var e = t.matrix, i = t.body;
                                t.invertedChildren.forEach(function(t) {
                                    var n = t[0], r = t[1];
                                    if (i.contains(n)) {
                                        var s = e[0], a = e[3], o = e[5], l = {
                                            translateX: 0,
                                            translateY: 0,
                                            scaleX: 1,
                                            scaleY: 1
                                        }, p = "";
                                        r.translate && (l.translateX = -e[4] / s, l.translateY = -o / a, p += "translate(" + l.translateX + "px, " + l.translateY + "px)"), r.scale && (l.scaleX = 1 / s, l.scaleY = 1 / a, p += " scale(" + l.scaleX + ", " + l.scaleY + ")"), n.style.transform = p;
                                    }
                                });
                            }({
                                invertedChildren: n,
                                matrix: s,
                                body: r
                            });
                        }
                    };
                }({
                    element: A,
                    invertedChildren: Y,
                    body: T
                });
                if (c[n] && c[n].onComplete) {
                    var J = c[n].onComplete;
                    K = function() {
                        return J(A, b);
                    };
                }
                var z = e(q.opacity) && e(L.opacity) && q.opacity !== L.opacity, G = !1;
                return a({}, R, {
                    stagger: V,
                    springConfig: U,
                    getOnUpdateFunc: function(t) {
                        var e = t.spring, i = t.onAnimationEnd;
                        return d[n] = {
                            destroy: e.destroy.bind(e),
                            onAnimationEnd: i
                        }, function(t) {
                            c[n] && c[n].onSpringUpdate && c[n].onSpringUpdate(t.getCurrentValue()), G || (G = !0, c[n] && c[n].onStart && c[n].onStart(A, b));
                            var e = t.getCurrentValue();
                            if (T.contains(A)) {
                                var i = {
                                    matrix: []
                                };
                                i.matrix = q.matrix.map(function(t, i) {
                                    return l(t, L.matrix[i], e);
                                }), z && (i.opacity = l(q.opacity, L.opacity, e)), H(i);
                            } else t.destroy();
                        };
                    },
                    initializeFlip: function() {
                        H({
                            matrix: q.matrix,
                            opacity: z ? q.opacity : void 0,
                            forceMinVals: E
                        }), c[n] && c[n].onStartImmediate && c[n].onStartImmediate(A, b), O.transformOrigin ? A.style.transformOrigin = O.transformOrigin : v && (A.style.transformOrigin = "0 0"), Y.forEach(function(t) {
                            var e = t[0], i = t[1];
                            i.transformOrigin ? e.style.transformOrigin = i.transformOrigin : v && (e.style.transformOrigin = "0 0");
                        });
                    },
                    onAnimationEnd: function(t) {
                        delete d[n], i(K) && K(), A.style.transform = "", Y.forEach(function(t) {
                            t[0].style.transform = "";
                        }), E && A && (A.style.minHeight = "", A.style.minWidth = ""), t || (x.push(n), x.length >= M.length && o(x));
                    },
                    delayUntil: O.delayUntil
                });
            }).filter(Boolean);
            if (M.forEach(function(t) {
                return (0, t.initializeFlip)();
            }), S) return function() {};
            var k = M.filter(function(t) {
                var e;
                return t.delayUntil && (e = t.delayUntil, M.filter(function(t) {
                    return t.id === e;
                }).length);
            }), j = {}, B = {}, N = {};
            k.forEach(function(t) {
                t.stagger ? (N[t.stagger] = !0, B[t.delayUntil] ? B[t.delayUntil].push(t.stagger) : B[t.delayUntil] = [
                    t.stagger
                ]) : j[t.delayUntil] ? j[t.delayUntil].push(t) : j[t.delayUntil] = [
                    t
                ];
            });
            var L = M.filter(function(t) {
                return t.stagger;
            }).reduce(function(t, e) {
                return t[e.stagger] ? t[e.stagger].push(e) : t[e.stagger] = [
                    e
                ], t;
            }, {}), q = M.filter(function(t) {
                return -1 === k.indexOf(t);
            });
            return q.forEach(function(t) {
                t.onSpringActivate = function() {
                    j[t.id] && j[t.id].forEach(U), B[t.id] && Object.keys(B[t.id].reduce(function(t, e) {
                        var i;
                        return a(t, ((i = {})[e] = !0, i));
                    }, {})).forEach(function(t) {
                        V(L[t], A[t]);
                    });
                };
            }), function() {
                return M.length || o([]), q.filter(function(t) {
                    return !t.stagger;
                }).forEach(U), Object.keys(L).forEach(function(t) {
                    N[t] || V(L[t], A[t]);
                }), O;
            };
        }($);
        B ? B({
            hideEnteringElements: G,
            animateEnteringElements: Q,
            animateExitingElements: Z,
            animateFlippedElements: tt
        }) : (G(), Z().then(Q), tt());
    }
}, q = function(t) {
    var e = t.element, i = t.flipCallbacks, n = void 0 === i ? {} : i, s = t.inProgressAnimations, o = void 0 === s ? {} : s, l = T(e, t.portalKey), p = r(e.querySelectorAll("[" + u + "]")), c = {}, d = [], h = {};
    l.filter(function(t) {
        return n && n[t.dataset.flipId] && n[t.dataset.flipId].onExit;
    }).forEach(function(t) {
        var e = t.parentNode;
        if (t.closest) {
            var i = t.closest("[" + f + "]");
            i && (e = i);
        }
        var n = d.findIndex(function(t) {
            return t[0] === e;
        });
        -1 === n && (d.push([
            e,
            e.getBoundingClientRect()
        ]), n = d.length - 1), c[t.dataset.flipId] = d[n][1], h[t.dataset.flipId] = e;
    });
    var g = M(l), m = g.map(function(t) {
        var e = t[0], i = t[1], r = {};
        if (n && n[e.dataset.flipId] && n[e.dataset.flipId].onExit) {
            var s = c[e.dataset.flipId];
            a(r, {
                element: e,
                parent: h[e.dataset.flipId],
                childPosition: {
                    top: i.top - s.top,
                    left: i.left - s.left,
                    width: i.width,
                    height: i.height
                }
            });
        }
        return [
            e.dataset.flipId,
            {
                rect: i,
                opacity: parseFloat(window.getComputedStyle(e).opacity || "1"),
                domDataForExitAnimations: r
            }
        ];
    }).reduce(R, {});
    return function(t, e) {
        Object.keys(t).forEach(function(e) {
            t[e].destroy && t[e].destroy(), t[e].onAnimationEnd && t[e].onAnimationEnd(!0), delete t[e];
        }), e.forEach(function(t) {
            t.style.transform = "", t.style.opacity = "";
        });
    }(o, l.concat(p)), {
        flippedElementPositions: m,
        cachedOrderedFlipIds: g.map(function(t) {
            return t[0].dataset.flipId;
        })
    };
}, X = /*#__PURE__*/ function() {
    function t(t) {
        this.element = void 0, this.staggerConfig = void 0, this.applyTransformOrigin = !0, this.handleEnterUpdateDelete = void 0, this.debug = void 0, this.spring = void 0, this.inProgressAnimations = void 0, this.flipCallbacks = void 0, this.snapshot = void 0, this.onComplete = void 0, this.onStart = void 0, a(this, t), this.inProgressAnimations = {}, this.flipCallbacks = {}, this.recordBeforeUpdate = this.recordBeforeUpdate.bind(this), this.update = this.update.bind(this), this.addFlipped = this.addFlipped.bind(this), this.addInverted = this.addInverted.bind(this);
    }
    var e = t.prototype;
    return e.recordBeforeUpdate = function() {
        this.snapshot = q({
            element: this.element,
            flipCallbacks: this.flipCallbacks,
            inProgressAnimations: this.inProgressAnimations
        });
    }, e.update = function(t, e) {
        this.snapshot && (L({
            flippedElementPositionsBeforeUpdate: this.snapshot.flippedElementPositions,
            cachedOrderedFlipIds: this.snapshot.cachedOrderedFlipIds,
            containerEl: this.element,
            inProgressAnimations: this.inProgressAnimations,
            flipCallbacks: this.flipCallbacks,
            applyTransformOrigin: this.applyTransformOrigin,
            spring: this.spring,
            debug: this.debug,
            staggerConfig: this.staggerConfig,
            handleEnterUpdateDelete: this.handleEnterUpdateDelete,
            decisionData: {
                previous: t,
                current: e
            },
            onComplete: this.onComplete,
            onStart: this.onStart
        }), delete this.snapshot);
    }, e.addFlipped = function(t) {
        var e = t.element, i = t.flipId, n = t.opacity, r = t.translate, s = t.scale, o = t.transformOrigin, l = t.spring, p = t.stagger, c = t.delayUntil, u = t.onAppear, d = t.onStart, f = t.onSpringUpdate, h = t.onComplete, g = t.onExit, m = t.shouldFlip, v = t.shouldInvert;
        if (!e) throw new Error("no element provided");
        if (!i) throw new Error("No flipId provided");
        var y = {
            scale: s,
            translate: r,
            opacity: n,
            transformOrigin: o,
            spring: l,
            stagger: p,
            delayUntil: c
        };
        y.scale || y.translate || y.opacity || a(y, {
            translate: !0,
            scale: !0,
            opacity: !0
        }), i && (e.dataset.flipId = String(i)), e.dataset.flipConfig = JSON.stringify(y), this.flipCallbacks[i] = {
            shouldFlip: m,
            shouldInvert: v,
            onAppear: u,
            onStart: d,
            onSpringUpdate: f,
            onComplete: h,
            onExit: g
        };
    }, e.addInverted = function(t) {
        var e = t.element, i = t.parent, n = t.opacity, r = t.translate, s = t.scale, o = t.transformOrigin;
        if (!e) throw new Error("no element provided");
        if (!i) throw new Error("parent must be provided");
        var l = i.dataset.flipId, p = {
            scale: s,
            translate: r,
            opacity: n,
            transformOrigin: o
        };
        p.scale || p.translate || p.opacity || a(p, {
            translate: !0,
            scale: !0,
            opacity: !0
        }), e.dataset.inverseFlipId = l, e.dataset.flipConfig = JSON.stringify(p);
    }, t;
}(), Y = new w, W = function(t) {
    var e = t.values, i = t.onUpdate, n = t.delay, r = void 0 === n ? 0 : n, s = t.onComplete, o = a({}, g.noWobble, m(t.config)), p = o.overshootClamping, c = Y.createSpring(o.stiffness, o.damping);
    return c.setOvershootClampingEnabled(!!p), c.addListener({
        onSpringAtRest: function(t) {
            s && s(), t.destroy();
        },
        onSpringUpdate: function(t) {
            var n = t.getCurrentValue();
            if (!e) return i(n);
            var r = Object.keys(e).map(function(t) {
                return [
                    t,
                    l(e[t][0], e[t][1], n)
                ];
            }).reduce(function(t, e) {
                var i;
                return Object.assign(t, ((i = {})[e[0]] = e[1], i));
            }, {});
            i(r);
        }
    }), r ? setTimeout(function() {
        c.setEndValue(1);
    }, r) : c.setEndValue(1), c;
};
module.exports["utilities"] = p;
module.exports["constants"] = h;
module.exports["onFlipKeyUpdate"] = L;
module.exports["getFlippedElementPositionsBeforeUpdate"] = q;

});

parcelRegister("lgKMU", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d6607a34d68309a3$export$9542b2119eeb5eb4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2Q0Hi",
    name: "ShareAndRestrictDialogController",
    loader: async ()=>(await Promise.resolve((parcelRequire("4adOe")))).Controller
});
module.exports["ShareAndRestrictDialogController"] = $d6607a34d68309a3$export$9542b2119eeb5eb4;

});

parcelRegister("6S5EB", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $d5074feaeb7f756a$export$50d92d69a5c05c70 = ()=>{
    if ((0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname) || !!(0, $1NBp8.SHAREABLE_LINK).match(window.location.pathname);
    return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
};
module.exports["isExternalShareRequest"] = $d5074feaeb7f756a$export$50d92d69a5c05c70;

});

parcelRegister("3MKHu", function(module, exports) {
/* skeleton-heading-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a4c12900fc6163ed$var$N20A = 'rgba(9, 30, 66, 0.04)';
const $a4c12900fc6163ed$var$N30A = 'rgba(9, 30, 66, 0.08)';
const $a4c12900fc6163ed$var$styles = {
    skeleton: "_1rjcze3t _18zrpxbi _14mj53f4 _1ywu1ule _z0ai1r5k _1qdgu2gc _1hfkizff _aetrb3bt",
    customWidth: "_z0airzut"
}; /**
    * These styles are mirrored in:
    * packages/design-system/theme/src/constants.tsx
    * packages/design-system/menu/src/menu-item/skeleton-item.tsx
    *
    * Please update both.
    */ 
const $a4c12900fc6163ed$var$shimmerKeyframes = null; /**
                                * These styles are defined using `css` rather than `cssMap` as there is a
                                * bug when using `cssMap` that causes a build failure due to the use of keyframes.
                                */ 
const $a4c12900fc6163ed$var$shimmerStyles = null; /**
                             * __Skeleton heading item__
                             *
                             * A skeleton heading item is used in place of a heading item when its contents it not ready.
                             *
                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-heading-item)
                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                             */ 
const $a4c12900fc6163ed$var$SkeletonHeadingItem = ({ isShimmering: isShimmering = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $a4c12900fc6163ed$var$styles.skeleton,
            width && $a4c12900fc6163ed$var$styles.customWidth,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1254 _10881254 _18lgp3kn _zo24p3kn _1hfkizff _1rusizff",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-ds--menu--skeleton-heading-item": true,
        "data-testid": testId
    });
};
var $a4c12900fc6163ed$export$2e2bcd8739ae039 = $a4c12900fc6163ed$var$SkeletonHeadingItem;
module.exports["default"] = $a4c12900fc6163ed$export$2e2bcd8739ae039;

});

parcelRegister("cQDYl", function(module, exports) {
/* skeleton-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e0b2ee147542345d$var$skeletonItemElemSize = 20;
const $e0b2ee147542345d$var$N20A = 'rgba(9, 30, 66, 0.04)';
const $e0b2ee147542345d$var$N30A = 'rgba(9, 30, 66, 0.08)';
const $e0b2ee147542345d$var$styles = {
    root: "_1rjcze3t _18zrv47k _1e0c1txw _1tke1ylp _4cvr1h6o _lcxvglyw _14mj53f4 _1qdgrdoj _1hfkizff _aetrb3bt _3mxot94y",
    defaultWidth: "_sf1e1n8h _4rfy1ssb _baud1nrf _mr7o1vuk _69tq19wn _kt4d1n05",
    customWidth: "_11w8rzut",
    beforeElement: "_1mp4gktf _kfgtgktf _7bjqidpf _1rusizff _1kt9b3bt _1mbqdlk8 _1rhxv77o",
    avatar: "_rfx31rr0",
    icon: "_rfx3fajl",
    sideNavSkeleton: "_18zru2gc _kfgt1k8s _1mbqpxbi _1mp41k8s"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $e0b2ee147542345d$var$shimmerKeyframes = null; /**
                                * These styles are defined using `css` rather than `cssMap` as there is a bug when using
                                * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
                                */ 
const $e0b2ee147542345d$var$shimmerStyles = null; /**
                             * __Skeleton item__
                             *
                             * A skeleton item is used in place of an item when its contents it not ready.
                             *
                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                             */ 
const $e0b2ee147542345d$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $e0b2ee147542345d$var$styles.root,
            (hasAvatar || hasIcon) && $e0b2ee147542345d$var$styles.beforeElement,
            hasAvatar && $e0b2ee147542345d$var$styles.avatar,
            hasIcon && $e0b2ee147542345d$var$styles.icon,
            width ? $e0b2ee147542345d$var$styles.customWidth : $e0b2ee147542345d$var$styles.defaultWidth,
            isSideNavSkeleton && $e0b2ee147542345d$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1254 _10881254 _18lgp3kn _zo24p3kn _1hfkizff _1rusizff",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
var $e0b2ee147542345d$export$2e2bcd8739ae039 = $e0b2ee147542345d$var$SkeletonItem;
module.exports["default"] = $e0b2ee147542345d$export$2e2bcd8739ae039;

});

parcelRegister("3Fgla", function(module, exports) {
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $keVvA = parcelRequire("keVvA");


var $7lxQk = parcelRequire("7lxQk");


var $141Kq = parcelRequire("141Kq");


var $d2vda = parcelRequire("d2vda");


var $f3So1 = parcelRequire("f3So1");


var $2UdT0 = parcelRequire("2UdT0");


const $824f685f95a3a006$var$LazyGlobalInviteModalDialogContentWithRelayProvider = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6I0SM")).then((module)=>({
            default: module.ModalDialogContentWithRelayProvider
        })));
function $824f685f95a3a006$var$AsyncGlobalInviteModalDialogContentWithRelayProvider(props) {
    const modalContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $d2vda.ErrorState), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $f3So1.LoadingState), {}),
            children: /*#__PURE__*/ (0, $l998X.jsx)($824f685f95a3a006$var$LazyGlobalInviteModalDialogContentWithRelayProvider, {
                ...props
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $141Kq.default),
        loaderFn: (0, $7lxQk.fetchMessages),
        children: modalContent
    });
}
const $824f685f95a3a006$export$73b6b212789f5472 = (0, $2UdT0.withModalDialog)($824f685f95a3a006$var$AsyncGlobalInviteModalDialogContentWithRelayProvider);
module.exports["GlobalInviteWithLazyLoadedRelayProvider"] = $824f685f95a3a006$export$73b6b212789f5472;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the context and pass them downstream
   * This prevents the missing messages error
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    (0, $42omo.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
        return undefined;
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $fI8ba = parcelRequire("fI8ba");

var $gmMgo = parcelRequire("gmMgo");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $fI8ba.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $gmMgo.Context));
    if (!context) return (0, $1e2E5.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("7lxQk", function(module, exports) {

var $141Kq = parcelRequire("141Kq");


var $fzzWl = parcelRequire("fzzWl");

const $86f4c496838d0464$export$e4882a930a0d91f2 = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $fzzWl.asyncLanguages) ? locale : locale.replace(/-/g, '_') in (0, $fzzWl.asyncLanguages) ? locale.replace(/-/g, '_') : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $fzzWl.asyncLanguages)[languageLocale]?.();
        return localeMessages?.default ?? (0, $141Kq.default);
    } catch (e) {
    // ignore
    }
    return 0, $141Kq.default;
};
module.exports["fetchMessages"] = $86f4c496838d0464$export$e4882a930a0d91f2;

});

parcelRegister("141Kq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $62841e239617d5e4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $333Q2 = parcelRequire("333Q2");

var $62841e239617d5e4$export$2e2bcd8739ae039 = (0, $333Q2.default);

});

parcelRegister("333Q2", function(module, exports) {
$parcel$export(module.exports, "default", () => $57b8ef09e6472437$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $57b8ef09e6472437$export$2e2bcd8739ae039 = {
    'navigation.global-invite.error-state-description': 'Try refreshing the page or contact us if the problem persists.',
    'navigation.global-invite.error-state-heading': "We can't load the invite list right now",
    'navigation.global-invite.loading-visually-hidden-label': 'Loading',
    'navigation.global-invite.modal-dialog-label': 'Invite people'
};

});

parcelRegister("fzzWl", function(module, exports) {
// https://parceljs.org/features/dependency-resolution/#glob-specifiers

























const $9f7a555e7f9dfa42$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("6yQVJ")),
    da: ()=>(parcelRequire("bzSID")),
    de: ()=>(parcelRequire("2FP6T")),
    'en-GB': ()=>(parcelRequire("25qh2")),
    'en-ZZ': ()=>(parcelRequire("3tbTt")),
    en: ()=>Promise.resolve((parcelRequire("141Kq"))),
    es: ()=>(parcelRequire("5HmEI")),
    fi: ()=>(parcelRequire("2JrHA")),
    fr: ()=>(parcelRequire("7K1vi")),
    hu: ()=>(parcelRequire("lvhk9")),
    it: ()=>(parcelRequire("dolI8")),
    ja: ()=>(parcelRequire("hqns1")),
    ko: ()=>(parcelRequire("1vs1T")),
    nb: ()=>(parcelRequire("BAT91")),
    nl: ()=>(parcelRequire("l079O")),
    pl: ()=>(parcelRequire("jEFBo")),
    'pt-BR': ()=>(parcelRequire("gTjoB")),
    ru: ()=>(parcelRequire("kq4sh")),
    sv: ()=>(parcelRequire("bbLxs")),
    th: ()=>(parcelRequire("gfPHN")),
    tr: ()=>(parcelRequire("gMTmr")),
    uk: ()=>(parcelRequire("6ZJsB")),
    vi: ()=>(parcelRequire("dDMw7")),
    zh_TW: ()=>(parcelRequire("bbzob")),
    zh: ()=>(parcelRequire("c4U6C"))
};
module.exports["asyncLanguages"] = $9f7a555e7f9dfa42$export$3770c7a7737d463c;

});

parcelRegister("6yQVJ", function(module, exports) {

let $4c6ef9e5e74dd184$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c6ef9e5e74dd184$var$load("5iVCs").then(()=>parcelRequire('5xx4Y'));

});

parcelRegister("bzSID", function(module, exports) {

let $86dd689af41ba059$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86dd689af41ba059$var$load("k7RZQ").then(()=>parcelRequire('hAVgU'));

});

parcelRegister("2FP6T", function(module, exports) {

let $1f270e83f32cb461$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f270e83f32cb461$var$load("9CFJc").then(()=>parcelRequire('lk8G1'));

});

parcelRegister("25qh2", function(module, exports) {

let $18506dd820d78f5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18506dd820d78f5b$var$load("3fPuK").then(()=>parcelRequire('aR1vS'));

});

parcelRegister("3tbTt", function(module, exports) {

let $286d4e6469420b68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $286d4e6469420b68$var$load("dUyEb").then(()=>parcelRequire('cryKi'));

});

parcelRegister("5HmEI", function(module, exports) {

let $42628adeb16c1acd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $42628adeb16c1acd$var$load("PAD2J").then(()=>parcelRequire('6UEa7'));

});

parcelRegister("2JrHA", function(module, exports) {

let $1fd545cce82aadd1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fd545cce82aadd1$var$load("GNuQo").then(()=>parcelRequire('eMR6r'));

});

parcelRegister("7K1vi", function(module, exports) {

let $5a2dfeea5ec5d421$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5a2dfeea5ec5d421$var$load("fvsAU").then(()=>parcelRequire('lqRs8'));

});

parcelRegister("lvhk9", function(module, exports) {

let $fa79ee67eedd7f9c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fa79ee67eedd7f9c$var$load("h7dGJ").then(()=>parcelRequire('abQPO'));

});

parcelRegister("dolI8", function(module, exports) {

let $9bfe5b94426f2bc1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9bfe5b94426f2bc1$var$load("kg6sH").then(()=>parcelRequire('koNv9'));

});

parcelRegister("hqns1", function(module, exports) {

let $caf70e3c2540bb6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caf70e3c2540bb6b$var$load("fqF5W").then(()=>parcelRequire('lHGQG'));

});

parcelRegister("1vs1T", function(module, exports) {

let $118e6dc5e8cffb51$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $118e6dc5e8cffb51$var$load("1WNp5").then(()=>parcelRequire('hfuHa'));

});

parcelRegister("BAT91", function(module, exports) {

let $07101216ee604e5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $07101216ee604e5b$var$load("iHPxa").then(()=>parcelRequire('4M9Uw'));

});

parcelRegister("l079O", function(module, exports) {

let $f49f26543ad6bdf7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f49f26543ad6bdf7$var$load("Qf3VH").then(()=>parcelRequire('8jbH9'));

});

parcelRegister("jEFBo", function(module, exports) {

let $e4f2060beb20487f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4f2060beb20487f$var$load("79OEV").then(()=>parcelRequire('4zJCj'));

});

parcelRegister("gTjoB", function(module, exports) {

let $c4c0d3fbc9057528$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c4c0d3fbc9057528$var$load("27dMt").then(()=>parcelRequire('h0wiX'));

});

parcelRegister("kq4sh", function(module, exports) {

let $edd9b112db2caa32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $edd9b112db2caa32$var$load("bkVVv").then(()=>parcelRequire('fARzr'));

});

parcelRegister("bbLxs", function(module, exports) {

let $825598f47ca268c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $825598f47ca268c9$var$load("MLhYA").then(()=>parcelRequire('7wkkR'));

});

parcelRegister("gfPHN", function(module, exports) {

let $bd5627a8923fc90c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bd5627a8923fc90c$var$load("ap7kW").then(()=>parcelRequire('7Ud5x'));

});

parcelRegister("gMTmr", function(module, exports) {

let $c38c128fb79e0a80$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c38c128fb79e0a80$var$load("45YAR").then(()=>parcelRequire('dyiwH'));

});

parcelRegister("6ZJsB", function(module, exports) {

let $517bb411b7d3988c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $517bb411b7d3988c$var$load("kqhVG").then(()=>parcelRequire('i54xW'));

});

parcelRegister("dDMw7", function(module, exports) {

let $9ee48d5fc1aa3060$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9ee48d5fc1aa3060$var$load("1susf").then(()=>parcelRequire('6kAMA'));

});

parcelRegister("bbzob", function(module, exports) {

let $824c2c56cd8c0a11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $824c2c56cd8c0a11$var$load("dl3k2").then(()=>parcelRequire('cIqRB'));

});

parcelRegister("c4U6C", function(module, exports) {

let $8cb1612c1183126f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8cb1612c1183126f$var$load("aquXY").then(()=>parcelRequire('ffYaF'));

});

parcelRegister("d2vda", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $cO1el = parcelRequire("cO1el");


var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $dkLyX = parcelRequire("dkLyX");

const $89f8b391742ea365$var$styles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.1000',
    paddingInline: 'space.100',
    textAlign: 'center'
});
function $89f8b391742ea365$export$c1ed4f415b9e7023() {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
        space: "space.050",
        testId: "global-invite--error-state",
        xcss: $89f8b391742ea365$var$styles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "xsmall",
                children: formatMessage((0, $dkLyX.messages).errorStateHeading)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                color: "color.text.subtle",
                children: formatMessage((0, $dkLyX.messages).errorStateDescription)
            })
        ]
    });
}
module.exports["ErrorState"] = $89f8b391742ea365$export$c1ed4f415b9e7023;

});

parcelRegister("dkLyX", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $45a6eb3a76009dad$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    errorStateHeading: {
        id: "navigation.global-invite.error-state-heading",
        defaultMessage: "We can't load the invite list right now"
    },
    errorStateDescription: {
        id: "navigation.global-invite.error-state-description",
        defaultMessage: "Try refreshing the page or contact us if the problem persists."
    }
});
module.exports["messages"] = $45a6eb3a76009dad$export$defe85febe8b728c;

});

parcelRegister("f3So1", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $kpYGL = parcelRequire("kpYGL");


var $6F6hl = parcelRequire("6F6hl");


var $jtIsq = parcelRequire("jtIsq");

const $1823c8a7ae00001a$var$styles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.500',
    paddingInline: 'space.300'
});
function $1823c8a7ae00001a$export$62aa48085237e36f() {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const items = Array.from({
        length: 5
    }, (_, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
            isShimmering: true,
            width: "100%",
            height: "var(--ds-space-200, 16px)",
            testId: "skeleton-shimmering"
        }, index));
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $1823c8a7ae00001a$var$styles,
        testId: "global-invite--loading-state",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: formatMessage((0, $jtIsq.messages).loadingLabel)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
                space: "space.100",
                testId: "skeleton-group",
                children: items
            })
        ]
    });
}
module.exports["LoadingState"] = $1823c8a7ae00001a$export$62aa48085237e36f;

});

parcelRegister("jtIsq", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $527f6b7f46807211$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    loadingLabel: {
        id: "navigation.global-invite.loading-visually-hidden-label",
        defaultMessage: "Loading"
    }
});
module.exports["messages"] = $527f6b7f46807211$export$defe85febe8b728c;

});

parcelRegister("2UdT0", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $7TH2w = parcelRequire("7TH2w");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $6xdDU = parcelRequire("6xdDU");


var $hqHXQ = parcelRequire("hqHXQ");


var $8m1UD = parcelRequire("8m1UD");


var $7VhND = parcelRequire("7VhND");

function $b2599bb59f3b7568$export$2d7d84d397d9a585(Content) {
    return function ModalDialog({ testId: testId = (0, $hqHXQ.DEFAULT_TEST_ID), triggerElement: TriggerElement, children: children, ...props }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, $8C5kA.default)();
        const [isModalDialogOpen, setIsModalDialogOpen] = (0, $42omo.useState)(false);
        const [adminHasNavigatedAway, setAdminHasNavigatedAway] = (0, $42omo.useState)(false);
        const openModalDialog = (0, $42omo.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $7TH2w.UI_EVENT_TYPE),
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'globalInviteButton',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $hqHXQ.ANALYTICS_CHANNEL));
            setIsModalDialogOpen(true);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const onAdminMenuItemClick = (0, $42omo.useCallback)((event)=>{
            // See packages/people-and-teams/invite-people/src/components/DropdownMenu/AdminMenuGroup.tsx for where these items are created.
            // Handle the click event happening on a link directly, or on an inner <span> or similar
            const isLink = event?.target?.tagName === 'A';
            const link = isLink ? event?.target : event?.target?.closest('a');
            if (link && (link?.getAttribute('target') === 'new' || link?.getAttribute('target') === '_blank')) setAdminHasNavigatedAway(true);
        }, []);
        const onCancel = (0, $42omo.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $7TH2w.UI_EVENT_TYPE),
                action: adminHasNavigatedAway ? 'closed' : 'cancelled',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $hqHXQ.ANALYTICS_CHANNEL));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product,
            adminHasNavigatedAway
        ]);
        const onInviteCompleted = (0, $42omo.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $7TH2w.UI_EVENT_TYPE),
                action: 'completed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $hqHXQ.ANALYTICS_CHANNEL));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const focusDialog = (0, $42omo.useCallback)((node)=>{
            // Focus the dialog's container when it finishes opening
            node.focus();
        }, []);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $8m1UD.AnalyticsContextWrapper), {
            product: props.product,
            children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                "data-testid": testId,
                children: [
                    TriggerElement ? /*#__PURE__*/ (0, $l998X.jsx)(TriggerElement, {
                        onClick: openModalDialog
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        shouldFitContainer: true,
                        onClick: openModalDialog,
                        testId: `${testId}--${(0, $hqHXQ.TRIGGER_ELEMENT_TEST_ID)}`,
                        children: children
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                        children: isModalDialogOpen ? /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
                            width: "small",
                            shouldScrollInViewport: true,
                            shouldReturnFocus: true,
                            onClose: onCancel,
                            onOpenComplete: focusDialog,
                            label: formatMessage((0, $7VhND.messages).modalDialogLabel),
                            testId: `${testId}--${(0, $hqHXQ.MODAL_DIALOG_TEST_ID)}`,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)(Content, {
                                    onAdminMenuItemClick: onAdminMenuItemClick,
                                    onCancel: onCancel,
                                    onInviteCompleted: onInviteCompleted,
                                    ...props
                                })
                            })
                        }) : null
                    })
                ]
            })
        });
    };
}
module.exports["withModalDialog"] = $b2599bb59f3b7568$export$2d7d84d397d9a585;

});

parcelRegister("hqHXQ", function(module, exports) {
const $52241f5d84d6a74c$export$bb76aeb9f599715c = 'global-invite';
const $52241f5d84d6a74c$export$7622d28bacf170d1 = 'modal-dialog';
const $52241f5d84d6a74c$export$1dab7caa4b20a4cc = 'trigger-element';
const $52241f5d84d6a74c$export$85183a312807388d = 'navigation';
module.exports["DEFAULT_TEST_ID"] = $52241f5d84d6a74c$export$bb76aeb9f599715c;
module.exports["MODAL_DIALOG_TEST_ID"] = $52241f5d84d6a74c$export$7622d28bacf170d1;
module.exports["TRIGGER_ELEMENT_TEST_ID"] = $52241f5d84d6a74c$export$1dab7caa4b20a4cc;
module.exports["ANALYTICS_CHANNEL"] = $52241f5d84d6a74c$export$85183a312807388d;

});

parcelRegister("8m1UD", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ffCOo = parcelRequire("ffCOo");

function $c1f1e75d1b3ddd53$export$804bcbe0913c6ba3({ product: product, children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.NavigationAnalyticsContext), {
        data: {
            componentName: 'globalInvite',
            source: 'globalInviteButton',
            product: product
        },
        children: children
    });
}
module.exports["AnalyticsContextWrapper"] = $c1f1e75d1b3ddd53$export$804bcbe0913c6ba3;

});

parcelRegister("7VhND", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $1fe379e53d021c39$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    modalDialogLabel: {
        id: "navigation.global-invite.modal-dialog-label",
        defaultMessage: "Invite people"
    }
});
module.exports["messages"] = $1fe379e53d021c39$export$defe85febe8b728c;

});

parcelRegister("6I0SM", function(module, exports) {

let $4e27896532564234$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4e27896532564234$var$load("9XYQ9"),
    $4e27896532564234$var$load("k8XPW"),
    $4e27896532564234$var$load("fWCRm"),
    $4e27896532564234$var$load("eY3St"),
    $4e27896532564234$var$load("bkd4T"),
    $4e27896532564234$var$load("kAAjo"),
    $4e27896532564234$var$load("fbRdC"),
    $4e27896532564234$var$load("6wr18"),
    $4e27896532564234$var$load("7EorR"),
    $4e27896532564234$var$load("lYvov"),
    $4e27896532564234$var$load("5uN9h"),
    $4e27896532564234$var$load("1TOYq"),
    $4e27896532564234$var$load("a5ri9"),
    $4e27896532564234$var$load("cfK8L"),
    $4e27896532564234$var$load("ffEVr"),
    $4e27896532564234$var$load("Wowvf"),
    $4e27896532564234$var$load("kHOMt"),
    $4e27896532564234$var$load("hhss7"),
    $4e27896532564234$var$load("iqKwT"),
    $4e27896532564234$var$load("gY1B8")
]).then(()=>parcelRequire('gFKFJ'));

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("ihDPC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $diswb = parcelRequire("diswb");


var $6Co6F = parcelRequire("6Co6F");


var $inPa6 = parcelRequire("inPa6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $cb6fO = parcelRequire("cb6fO");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $1NBp8 = parcelRequire("1NBp8");


var $gEtAQ = parcelRequire("gEtAQ");


var $bQm3c = parcelRequire("bQm3c");


var $dbAK7 = parcelRequire("dbAK7");


var $h29WE = parcelRequire("h29WE");


var $1N269 = parcelRequire("1N269");


var $lI2Uj = parcelRequire("lI2Uj");


var $3WXN2 = parcelRequire("3WXN2");

const $83f6f30777feeeb0$var$ANALYTICS_SOURCE = 'useShareToEntities';
const $83f6f30777feeeb0$var$i18n = (0, $cgtv4.defineMessages)({
    emptyTitleDefault: {
        id: "share.default.title",
        defaultMessage: "Untitled"
    }
});
const $83f6f30777feeeb0$export$6b48d216ed523828 = ({ routesContext: routesContext, contentType: contentType, contentId: contentId, spaceKey: spaceKey, isEditMode: isEditMode, getCopyContentLink: getCopyContentLink })=>{
    /**
   * Should always use the refactor version if isEditMode = true (which is only for presence feature).
   * If `getCopyContentLink` returns undefined, use the original code
   */ let contentShareLink = getCopyContentLink();
    if (isEditMode && contentShareLink) return contentShareLink;
    // ShareButton constructs the URL to send based on routes context (current
    // location in Confluence app). We are matching ShareButton logic as closely
    // as we can to provide a consistent experience, but given that we could
    // embed Share anywhere in the app, we should consider constructing URLs
    // based on a combination of content data from the BE (eg fetch content
    // type, status etc) + consumer specifications (give me a view vs edit URL)
    // and maintain an explicit set of link generation rules in this package.
    const namedRoute = routesContext.match;
    const draftShareId = (0, $c3Qwv.getSingleParam)(routesContext.getQueryParams(), 'draftShareId');
    // If user is coming from edit page/blog, we want to send a "view content"
    // link, NOT the current edit URL. (Drafts are an exception; they have
    // no valid view page URL so we must construct a separate link.)
    if (namedRoute && (0, $gEtAQ.isEditPage)(String(namedRoute)) && !draftShareId) {
        const spaceKeyParam = spaceKey ?? namedRoute?.params.spaceKey;
        return contentType === 'blog' ? new URL((0, $1NBp8.VIEW_BLOG).toUrl({
            spaceKey: spaceKeyParam,
            contentId: contentId
        }), document.baseURI).toString() : new URL((0, $1NBp8.VIEW_PAGE).toUrl({
            spaceKey: spaceKeyParam,
            contentId: contentId
        }), document.baseURI).toString();
    }
    // At this point we know we want to share content in the VIEW mode + double checks that getCopyContentLink didn't return undefined
    if (contentShareLink) return contentShareLink;
    contentShareLink = (0, $lI2Uj.getViewContentShareUrl)();
    if (draftShareId !== undefined) contentShareLink = (0, $cb6fO.addQueryParams)(contentShareLink, {
        draftShareId: draftShareId
    });
    return contentShareLink;
};
const $83f6f30777feeeb0$var$SUPPORTED_CONTENT_TYPES = [
    'page',
    'blogpost',
    'whiteboard'
];
const $83f6f30777feeeb0$export$ff54c7fb660648d5 = (contentId, analyticsSource, contentMode)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    // Query BE as source of truth for content type, but we can also derive it from
    // page context (routes-based) as a fallback
    const [contentTypeFromPageContext] = (0, $ep3mz.useContentType)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { getCopyContentLink: getCopyContentLink } = (0, $3WXN2.useCopyContentLink)({
        pageMode: contentMode,
        contentType: contentTypeFromPageContext ?? '',
        contentId: contentId,
        spaceKey: spaceKey,
        source: 'useShareToEntities'
    });
    const { data: data, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $dbAK7.ShareToEntitiesContentQuery), {
        variables: {
            contentId: contentId
        }
    });
    // Swallow the error; not having the data will be
    // fairly inconsequential for the user experience
    error && (0, $7Sm4c.markErrorAsHandled)(error);
    const handleShareComplete = (result)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: analyticsSource ?? $83f6f30777feeeb0$var$ANALYTICS_SOURCE,
                actionSubject: 'notify',
                action: 'completed',
                attributes: {
                    contentId: contentId,
                    success: Boolean(result?.experimentalShare?.success),
                    status: result?.experimentalShare?.status
                }
            }
        }).fire();
    };
    const [share] = (0, $h29WE.useExperimentalShareMutation)({
        onCompleted: handleShareComplete
    });
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const contentType = data?.singleContent?.type ?? contentTypeFromPageContext ?? '';
    const contentTitle = data?.singleContent?.title;
    const originTracingFactory = (0, $42omo.useCallback)(()=>new (0, $6Co6F.default)({
            product: 'confluence'
        }), []);
    return {
        shareToEntities: async (entities, isEditMode)=>{
            if (!$83f6f30777feeeb0$var$SUPPORTED_CONTENT_TYPES.includes(contentType)) throw new Error('Not a supported content type');
            if (!contentId) throw new Error('No content ID');
            const entityList = entities.map((entity)=>({
                    id: entity.id,
                    type: entity.type
                }));
            const requestBody = {
                content: {
                    link: $83f6f30777feeeb0$export$6b48d216ed523828({
                        routesContext: routesContext,
                        contentType: contentType,
                        contentId: contentId,
                        spaceKey: spaceKey,
                        isEditMode: isEditMode,
                        getCopyContentLink: getCopyContentLink
                    }),
                    ari: (0, $1N269.getContentAri)({
                        activationId: activationId,
                        contentId: contentId,
                        cloudId: cloudId,
                        contentType: contentType
                    }),
                    title: contentTitle || intl.formatMessage($83f6f30777feeeb0$var$i18n.emptyTitleDefault),
                    type: contentType
                },
                recipients: entityList,
                metadata: {
                    productId: 'confluence',
                    atlOriginId: String(originTracingFactory().id),
                    // even if we are in edit mode we want to share the "view" page URL, not edit
                    shareeAction: isEditMode ? 'edit' : 'view'
                }
            };
            const result = await share({
                variables: {
                    requestBody: requestBody
                }
            });
            return {
                success: Boolean(result?.data?.experimentalShare?.success)
            };
        }
    };
};
module.exports["useShareToEntities"] = $83f6f30777feeeb0$export$ff54c7fb660648d5;

});

parcelRegister("dbAK7", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $f634b10f7aada1fb$export$9d0797899767ec47 = (0, $eSUdr.default)`query ShareToEntitiesContentQuery($contentId:ID!){singleContent(id:$contentId){title type id}}`;
module.exports["ShareToEntitiesContentQuery"] = $f634b10f7aada1fb$export$9d0797899767ec47;

});

parcelRegister("h29WE", function(module, exports) {

var $aBfpe = parcelRequire("aBfpe");


var $9o40q = parcelRequire("9o40q");

const $463aa542b11689d5$export$e838a1a4824c7c3b = (options)=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: '/gateway/api/share',
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: (response)=>({
                experimentalShare: {
                    status: String(response.status),
                    success: Boolean(response.ok),
                    __typename: 'ExperimentalShareResponse'
                }
            }),
        parseResponseOnSuccess: (response)=>({
                status: response.status,
                ok: response.ok
            }),
        parseResponseOnError: (error)=>{
            // Handle rate limiting errors from share service
            if ('response' in error && error.response?.status) return {
                status: error.response.status,
                ok: false
            };
            throw error;
        },
        onCompleted: options?.onCompleted
    });
};
module.exports["useExperimentalShareMutation"] = $463aa542b11689d5$export$e838a1a4824c7c3b;

});

parcelRegister("9o40q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5JnOJ = parcelRequire("5JnOJ");


var $6mKj3 = parcelRequire("6mKj3");


var $1GTIR = parcelRequire("1GTIR");


var $bjeS8 = parcelRequire("bjeS8");


var $hNILR = parcelRequire("hNILR");

function $ca37881e75cd694f$export$59b64e912820d0fb({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    if (!(0, $6mKj3.expValEquals)('cc_move_legacy-schema-bridge-code-into-interops', 'isEnabled', true)) // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return (0, $hNILR.useExperimentalMutationLegacy)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        maxRetries: maxRetries,
        variables: defaultVariables,
        update: update,
        optimisticResponse: optimisticResponse
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const fetchDataWithRetry = (0, $42omo.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return $ca37881e75cd694f$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $ca37881e75cd694f$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: update, optimisticResponse: optimisticResponse }) {
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $5JnOJ.useApolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        update: update,
        optimisticResponse: optimisticResponse,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["useExperimentalMutation"] = $ca37881e75cd694f$export$59b64e912820d0fb;
module.exports["useExperimentalMutationBase"] = $ca37881e75cd694f$export$a2949d410ca8baf1;

});

parcelRegister("5JnOJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $7Sm4c = parcelRequire("7Sm4c");

function $0e0c7f21ad093cb8$export$36caaad0aa36f272({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse, convertToApolloError: convertToApolloError }) {
    const [result, setResult] = (0, $42omo.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const apolloError = await Promise.resolve(convertToApolloError(error));
            if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
                (0, $7Sm4c.processError)(e);
            });
            onError?.(apolloError);
            const newResult = {
                data: undefined,
                loading: false,
                error: apolloError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw apolloError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useApolloCompatibleMutation"] = $0e0c7f21ad093cb8$export$36caaad0aa36f272;

});

parcelRegister("hNILR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $hR9WV = parcelRequire("hR9WV");

function $fa6207d2b246a38d$export$9aaca330ad9c982e({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    const fetchDataWithRetry = (0, $42omo.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    return $fa6207d2b246a38d$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $fa6207d2b246a38d$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse }) {
    const [result, setResult] = (0, $42omo.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            const newResult = {
                data: undefined,
                loading: false,
                error: finalError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw finalError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useExperimentalMutationLegacy"] = $fa6207d2b246a38d$export$9aaca330ad9c982e;

});

parcelRegister("1N269", function(module, exports) {

var $eB56w = parcelRequire("eB56w");

var $iH7AG = parcelRequire("iH7AG");

var $a2xFu = parcelRequire("a2xFu");

var $a5Dk4 = parcelRequire("a5Dk4");


var $gw4Eo = parcelRequire("gw4Eo");

const $59924e77ba236685$export$3bb5b6748490a3c9 = ({ activationId: activationId, cloudId: cloudId, contentId: contentId, contentType: contentType })=>{
    // Build ARI for embeds via `getConfluenceContentAri` until support is added to `@atlassian/ari`
    // TODO: Replace with `@atlassian/ari` https://hello.jira.atlassian.cloud/browse/CTIA-1835
    if (contentType === 'embed' && activationId) return (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    if (contentType === 'database' && activationId) return (0, $iH7AG.ConfluenceDatabaseAri).create({
        siteId: cloudId,
        databaseId: contentId,
        activationId: activationId
    }).toString();
    let ari = null;
    // A space ari should not have spacekey as it is UGC (HOT-96075)
    // A space should have a page based ARI as only then it will generate the
    // notification that will be propagated to mobile as well and will be consistent with Mobile.
    // So a space will also have page based ARI. (Discussed in HOT-96778)
    switch(contentType){
        case 'blogpost':
            ari = (0, $eB56w.ConfluenceBlogpostAri).create({
                siteId: cloudId,
                blogpostId: contentId
            });
            break;
        case 'whiteboard':
            ari = (0, $a5Dk4.ConfluenceWhiteboardAri).create({
                siteId: cloudId,
                whiteboardId: contentId
            });
            break;
        default:
            ari = (0, $a2xFu.ConfluencePageAri).create({
                siteId: cloudId,
                pageId: contentId
            });
            break;
    }
    return ari.toString();
};
const $59924e77ba236685$export$6c15baa16fd4c6da = (routeName)=>{
    // This function deliberately doesn't know about new content types. It's a fallback
    // for deriving content type from a URL, but for new types, it's better to
    // explicitly pass a `shareContentType` and `shareFormTitle` to the `<ShareButton>` if possible.
    if (!routeName) return 'page';
    // either page, or blog
    if (routeName.includes('BLOG')) return 'blogpost';
    return 'page';
};
const $59924e77ba236685$export$601eeb6344384d42 = (contentType)=>{
    return contentType !== 'embed' && contentType !== 'database';
};
module.exports["getContentAri"] = $59924e77ba236685$export$3bb5b6748490a3c9;
module.exports["getContentTypeForShare"] = $59924e77ba236685$export$6c15baa16fd4c6da;
module.exports["isSlackIntegrationSupported"] = $59924e77ba236685$export$601eeb6344384d42;

});

parcelRegister("lI2Uj", function(module, exports) {

var $cb6fO = parcelRequire("cb6fO");

const $173b05a835ca24a4$export$8142721d7112d638 = (json)=>{
    try {
        return JSON.parse(json);
    } catch (e) {}
    return null;
};
const $173b05a835ca24a4$export$f31b9480a5e4fdcf = ()=>{
    const match = window.location.search.match(/draftShareId=([^&#]*)/);
    return match && match[1] || undefined;
};
const $173b05a835ca24a4$export$8071740a02e53ce2 = (shareeAction)=>{
    // eslint-disable-next-line no-restricted-syntax
    const str = window.location.href;
    if (/\/wiki\/spaces\/.*\/history\//.test(str)) return 'history';
    if (shareeAction === 'edit') return 'edit';
    return undefined;
};
const $173b05a835ca24a4$export$ed19bcf3c49c4c69 = ()=>{
    // Drop non-required params from the URL so we are not sharing UGC or
    // sending a link focused on comments or anchors
    return(// eslint-disable-next-line no-restricted-syntax
    // eslint-disable-next-line no-restricted-syntax
    window?.location?.href && (0, $cb6fO.removeEverythingAfterContentSlug)(window.location.href));
};
module.exports["safeJSONParse"] = $173b05a835ca24a4$export$8142721d7112d638;
module.exports["getDraftShareId"] = $173b05a835ca24a4$export$f31b9480a5e4fdcf;
module.exports["getLinkType"] = $173b05a835ca24a4$export$8071740a02e53ce2;
module.exports["getViewContentShareUrl"] = $173b05a835ca24a4$export$ed19bcf3c49c4c69;

});

parcelRegister("3WXN2", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $inPa6 = parcelRequire("inPa6");


var $7zgzO = parcelRequire("7zgzO");


var $1NBp8 = parcelRequire("1NBp8");


var $3JQXa = parcelRequire("3JQXa");


var $9WYR7 = parcelRequire("9WYR7");

const $1e41cfcb0548d2ef$var$useCopyContentLinkCopyLinkQuery = (0, $eSUdr.default)`query useCopyContentLinkCopyLinkQuery($contentId:ID!){singleContent(id:$contentId){id links{editui webui tinyui base}}}`;
var $1e41cfcb0548d2ef$export$61634440d18842d5 = /*#__PURE__*/ function(SUPPORTED_CONTENT_TYPES) {
    SUPPORTED_CONTENT_TYPES["PAGE"] = "page";
    SUPPORTED_CONTENT_TYPES["BLOGPOST"] = "blogpost";
    SUPPORTED_CONTENT_TYPES["OVERVIEW"] = "overview";
    SUPPORTED_CONTENT_TYPES["WHITEBOARD"] = "whiteboard";
    SUPPORTED_CONTENT_TYPES["EMBED"] = "embed";
    SUPPORTED_CONTENT_TYPES["DATABASE"] = "database";
    return SUPPORTED_CONTENT_TYPES;
}({});
const $1e41cfcb0548d2ef$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $42omo.useState)();
    const { toUrl: toUrl } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $3JQXa.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $j1Ss3.useQuery)($1e41cfcb0548d2ef$var$useCopyContentLinkCopyLinkQuery, {
        variables: {
            contentId: contentId
        }
    });
    const getCopyContentLink = (0, $42omo.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === (0, $9WYR7.PAGE_MODE).EDIT) copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) return `${links.base}${copyLink}`;
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === (0, $9WYR7.PAGE_MODE).EDIT) {
            routeName = contentType === "blogpost" ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === "blogpost" ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case "overview":
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case "blogpost":
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case "page":
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case "whiteboard":
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            case "embed":
                routeName = (0, $1NBp8.EMBED_VIEW).name;
                break;
            case "database":
                routeName = (0, $1NBp8.DATABASE_VIEW).name;
            // omit unsupported content types
            default:
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $9WYR7.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'copied',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $9WYR7.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            return `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $42omo.useCallback)(()=>{
        return copyToClipboard(getCopyContentLink());
    }, [
        getCopyContentLink,
        copyToClipboard
    ]);
    return (0, $42omo.useMemo)(()=>({
            queryError: queryError,
            unsupportedLinkError: unsupportedLinkError,
            getCopyContentLink: getCopyContentLink,
            copyContentLink: copyContentLink
        }), [
        queryError,
        unsupportedLinkError,
        getCopyContentLink,
        copyContentLink
    ]);
};
module.exports["SUPPORTED_CONTENT_TYPES"] = $1e41cfcb0548d2ef$export$61634440d18842d5;
module.exports["useCopyContentLink"] = $1e41cfcb0548d2ef$export$a049904f049cf16d;

});

parcelRegister("3JQXa", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $e2866f1e30f0246d$export$b2199c37e85de4a7 = ()=>{
    const copyToClipboard = (0, $42omo.useCallback)(async (value)=>{
        // check if the browser supports the clipboard API
        if (value && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') await navigator.clipboard.writeText(value);
    }, []);
    return (0, $42omo.useMemo)(()=>({
            copyToClipboard: copyToClipboard
        }), [
        copyToClipboard
    ]);
};
module.exports["useCopyToClipboard"] = $e2866f1e30f0246d$export$b2199c37e85de4a7;

});

parcelRegister("9WYR7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $1bY7o = parcelRequire("1bY7o");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $56QzY = parcelRequire("56QzY");


var $irVI7 = parcelRequire("irVI7");


var $hjygH = parcelRequire("hjygH");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $3WXN2 = parcelRequire("3WXN2");

const $5e79baa87b282684$var$i18n = (0, $cgtv4.defineMessages)({
    copyLinkLabel: {
        id: "share.copylink.icon.label",
        defaultMessage: "Copy link"
    },
    copiedTextLabel: {
        id: "share.copylink.copied.tooltip",
        defaultMessage: "Copied!"
    },
    errorCopyingTextLabel: {
        id: "share.copylink.error.tooltip",
        defaultMessage: "Something went wrong."
    }
});
const $5e79baa87b282684$var$RESET_COPYTEXT_TIMEOUT = 5000;
const $5e79baa87b282684$export$9957974f8b4d8f74 = 'copyShareLink';
var $5e79baa87b282684$export$e82cf716cce37b4e = /*#__PURE__*/ function(PAGE_MODE) {
    PAGE_MODE["VIEW"] = "view";
    PAGE_MODE["EDIT"] = "edit";
    return PAGE_MODE;
}({});
const $5e79baa87b282684$var$CopyLinkComponent = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, shouldResetOnHover: shouldResetOnHover = false, buttonAppearance: buttonAppearance = 'subtle', tooltipPosition: tooltipPosition = 'bottom', referencedContentId: referencedContentId })=>{
    const intl = (0, $8C5kA.default)();
    const [isCopied, setIsCopied] = (0, $42omo.useState)(false);
    const [errorDuringCopy, setErrorDuringCopy] = (0, $42omo.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const cleanupCopiedTimer = (0, $42omo.useRef)();
    const updateTooltipPosition = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        if (isCopied) cleanupCopiedTimer.current = setTimeout(()=>setIsCopied(false), $5e79baa87b282684$var$RESET_COPYTEXT_TIMEOUT);
        return ()=>{
            clearTimeout(cleanupCopiedTimer.current);
        };
    }, [
        isCopied
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                actionSubject: 'copyShareLink',
                action: 'shown',
                source: source,
                attributes: {
                    contentType: contentType,
                    pageMode: pageMode,
                    isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentType,
        source,
        pageMode
    ]);
    const { queryError: queryError, unsupportedLinkError: unsupportedLinkError, copyContentLink: copyContentLink } = (0, $3WXN2.useCopyContentLink)({
        pageMode: pageMode,
        contentType: contentType,
        contentId: contentId,
        spaceKey: spaceKey,
        source: source
    });
    (0, $42omo.useLayoutEffect)(()=>{
        updateTooltipPosition.current?.();
    }, [
        isCopied
    ]);
    const handleCopyLink = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: $5e79baa87b282684$export$9957974f8b4d8f74,
                source: source,
                attributes: {
                    pageMode: pageMode,
                    contentType: contentType,
                    navdexPointType: (0, $56QzY.END),
                    isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
                }
            }
        }).fire();
        try {
            await copyContentLink();
        } catch (e) {
            setErrorDuringCopy(e);
        }
        setIsCopied(true);
    };
    const handleHover = ()=>{
        experienceTracker.start({
            name: (0, $irVI7.COPY_CONTENT_LINK_EXPERIENCE)
        });
    };
    // report errors from the hook's query silently since we have fallback link retrieval
    // methods, but show user error tooltip text and fail experience if we actually
    // couldn't get any link to copy or the copy itself failed
    const copyError = unsupportedLinkError || errorDuringCopy;
    const copyLinkText = intl.formatMessage($5e79baa87b282684$var$i18n.copyLinkLabel);
    const confirmationText = intl.formatMessage(copyError ? $5e79baa87b282684$var$i18n.errorCopyingTextLabel : $5e79baa87b282684$var$i18n.copiedTextLabel);
    const isAnyError = Boolean(queryError || copyError);
    const buttonAriaProps = (0, $9wGTI.fg)('confluence_title_copy_link_a11y_fix') ? {
        'aria-labelledby': referencedContentId
    } : {
        'aria-label': isCopied ? confirmationText : copyLinkText
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAnyError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: queryError || copyError
    }), Boolean(copyError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
        name: (0, $irVI7.COPY_CONTENT_LINK_EXPERIENCE),
        error: copyError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: ({ update: update })=>{
            updateTooltipPosition.current = update;
            return isCopied ? confirmationText : copyLinkText;
        },
        position: tooltipPosition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "copy-link-button",
        ...buttonAriaProps,
        appearance: buttonAppearance,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: "",
            color: isCopied ? "var(--ds-icon-selected, #1868DB)" : undefined,
            spacing: "spacious"
        }),
        onClick: handleCopyLink,
        onMouseEnter: handleHover,
        // Some consumers of CopyLink only reveal the button on hover, and
        // for those ones we need to reset the button to default post hover.
        // state after mouse leaves the component (because the button gets
        // hidden when no longer hovering)
        onMouseLeave: ()=>{
            if (shouldResetOnHover) setIsCopied(false);
            experienceTracker.abort({
                name: (0, $irVI7.COPY_CONTENT_LINK_EXPERIENCE),
                reason: 'user navigated away'
            });
        },
        shouldFitContainer: true
    })), isCopied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.COPY_CONTENT_LINK_EXPERIENCE)
    }));
};
const $5e79baa87b282684$export$1711531201a0c4b7 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
})($5e79baa87b282684$var$CopyLinkComponent);
module.exports["ACTION_SUBJECT_ID"] = $5e79baa87b282684$export$9957974f8b4d8f74;
module.exports["PAGE_MODE"] = $5e79baa87b282684$export$e82cf716cce37b4e;
module.exports["CopyLink"] = $5e79baa87b282684$export$1711531201a0c4b7;

});

parcelRegister("hjygH", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

const $1aeb691895c5954d$export$85823f26dca064c3 = (0, $3u0dr.isReactCompilerActiveV1)() ? function ExperienceStop(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>{
            if (error) experienceTracker.stopOnError({
                name: name,
                error: error,
                attributes: attributes
            });
            else experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        };
        t2 = [
            experienceTracker,
            name,
            attributes,
            error
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
} : function ExperienceStop({ name: name, error: error, attributes: attributes }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        if (error) experienceTracker.stopOnError({
            name: name,
            error: error,
            attributes: attributes
        });
        else experienceTracker.succeed({
            name: name,
            attributes: attributes
        });
    }, [
        experienceTracker,
        name,
        attributes,
        error
    ]);
    return null;
};
module.exports["ExperienceStop"] = $1aeb691895c5954d$export$85823f26dca064c3;

});

parcelRegister("cVfpT", function(module, exports) {
$parcel$export(module.exports, "PAGE_MODE", () => (parcelRequire("9WYR7")).PAGE_MODE);

var $jmjWc = parcelRequire("jmjWc");


var $h5hpR = parcelRequire("h5hpR");


var $9WYR7 = parcelRequire("9WYR7");


const $77a17cdb2708e975$export$9d30156e45c09e81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qHKXp",
    name: "CopyLinkButtonLoader",
    loader: async ()=>{
        return (await Promise.resolve((parcelRequire("9WYR7")))).CopyLink;
    },
    loading: (0, $h5hpR.CopyLinkButtonPlaceholder)
});
module.exports["CopyLinkButtonLoader"] = $77a17cdb2708e975$export$9d30156e45c09e81;

});

parcelRegister("h5hpR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1bY7o = parcelRequire("1bY7o");


var $eEA8O = parcelRequire("eEA8O");

const $585272eb5e339a55$var$i18n = (0, $cgtv4.defineMessages)({
    copyLinkLabel: {
        id: "share.copylink.icon.label",
        defaultMessage: "Copy link"
    }
});
const $585272eb5e339a55$export$1f3200a5b8d4d8e1 = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "copy-link-button-placeholder",
        "data-test-id": "copy-link-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: intl.formatMessage($585272eb5e339a55$var$i18n.copyLinkLabel),
            spacing: "spacious"
        }),
        isDisabled: true
    });
};
module.exports["CopyLinkButtonPlaceholder"] = $585272eb5e339a55$export$1f3200a5b8d4d8e1;

});

parcelRegister("kDhla", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $1P1Tu.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $9zUhf.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $9zUhf.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $9zUhf.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("e4o8D", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $2679ebd914f0a083$export$96e8e9e8e57310bb = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    return renderServerPlaceholder;
} : (renderServerPlaceholderOnNonHydrate = false)=>{
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    !isTransition || Boolean(undefined) : // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    (0, $42omo.useEffect)(()=>{
        setRenderServerPlaceholder(false);
    }, []);
    return renderServerPlaceholder;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("hYoU4", function(module, exports) {

var $3wgAM = parcelRequire("3wgAM");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $1P1Tu.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $FOT9i.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $9zUhf.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $9zUhf.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("3wgAM", function(module, exports) {

var $2LrJx = parcelRequire("2LrJx");


var $5Nw7l = parcelRequire("5Nw7l");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $29013b23581f9040$var$pick = $5Nw7l(function(object, paths) {
    return object == null ? {} : $2LrJx(object, paths);
});
module.exports = $29013b23581f9040$var$pick;

});

parcelRegister("2LrJx", function(module, exports) {

var $egNUN = parcelRequire("egNUN");


var $7U49l = parcelRequire("7U49l");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $20357bdd9d2fadfb$var$basePick(object, paths) {
    return $egNUN(object, paths, function(value, path) {
        return $7U49l(object, path);
    });
}
module.exports = $20357bdd9d2fadfb$var$basePick;

});

parcelRegister("5Nw7l", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $iK2Oc = parcelRequire("iK2Oc");


var $gnVVm = parcelRequire("gnVVm");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $438a713c021efc47$var$flatRest(func) {
    return $gnVVm($iK2Oc(func, undefined, $5qOzM), func + '');
}
module.exports = $438a713c021efc47$var$flatRest;

});

parcelRegister("5qOzM", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $3f469ccb29f16086$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8jC8i(array, 1) : [];
}
module.exports = $3f469ccb29f16086$var$flatten;

});

parcelRegister("8KbKw", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $j8hiR = parcelRequire("j8hiR");


var $9137z = parcelRequire("9137z");


var $3pJBd = parcelRequire("3pJBd");


var $1sAC2 = parcelRequire("1sAC2");

const $6f395e426fb151a0$var$isContentNotFoundError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.message.includes('Invalid content id'));
    return false;
};
const $6f395e426fb151a0$export$e344958ab47793df = (0, $2XqLN.default)((contentId, draftShareId)=>async ()=>{
        const permissionsTokenState = (0, $1sAC2.nativeCollabPermissionsTokenState).getPermissionsTokenState(contentId);
        if (permissionsTokenState) {
            const { getToken: getToken, isUsedForDraftFetch: isUsedForDraftFetch, isUsedForWSInitialization: isUsedForWSInitialization } = permissionsTokenState;
            // fetchCollabPermissionToken should only return the token if it is valid and has successfully been passed to the getDraft call
            if (isUsedForDraftFetch && !isUsedForWSInitialization) {
                const token = await getToken;
                if (token) {
                    (0, $1sAC2.nativeCollabPermissionsTokenState).setIsUsedForWSInitialization(contentId, true);
                    return token;
                }
            }
        }
        const apolloClient = (0, $hp2SH.getApolloClient)();
        try {
            (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            const result = await apolloClient.query({
                query: (0, $3pJBd.GetCollabPermissionTokenQuery),
                variables: {
                    contentId: contentId,
                    ...draftShareId && {
                        draftShareId: draftShareId
                    }
                },
                fetchPolicy: 'network-only',
                context: {
                    fetchOptions: {
                        // If we have a "no network error" this will never resolve and subsequent calls will
                        // be in limbo. This means we are unable to ever connect to NCS again (requiring a page reset)
                        ignoreNoNetworkError: true
                    }
                }
            });
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            return result.data?.collabToken?.token ?? null; // if token is null, collab service will fall back to permissions service check
        } catch (e) {
            (0, $7Sm4c.markErrorAsHandled)(e);
            if ($6f395e426fb151a0$var$isContentNotFoundError(e)) // nasty fragile hack, mimic 404 exception which goes through collab-provider, then gets wrapped and emitted and handled in `useError`.
            // collab provider simply emits errors thrown in permissionTokenRefresh directly on its internal channel, so we have to conform to their error type
            // prettier-ignore
            throw {
                message: "Content not found",
                data: {
                    status: 404,
                    code: "INSUFFICIENT_EDITING_PERMISSION",
                    meta: {
                        description: "RESOURCE_DELETED",
                        reason: "RESOURCE_DELETED"
                    }
                }
            };
            else if (e?.networkError?.response?.status === 503) // prettier-ignore
            throw {
                message: "Service unavailable",
                data: {
                    meta: {
                        reason: "RESOURCE_DELETED"
                    }
                }
            }; // temporary hack to ensure draft cannot be edited during tenant migration, but we should throw TENANT_INSTANCE_MAINTENANCE once supported by collab-provider
            return null;
        }
    });
module.exports["fetchCollabPermissionToken"] = $6f395e426fb151a0$export$e344958ab47793df;

});

parcelRegister("j8hiR", function(module, exports) {
var $fbca710eb28c4147$export$d0a57beabaefb993 = /*#__PURE__*/ function(COLLAB_EDIT_PROVIDER_MEASURES) {
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH"] = "collabEditProviderAnalyticsFetch";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CREATED"] = "collabEditProviderCreated";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_DISABLED"] = "collabEditProviderDisabled";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT"] = "collabEditProviderInitialized";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRE_CONNECTED"] = "collabEditProviderPreconnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CONNECTED"] = "collabEditProviderConnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT_DOC"] = "collabEditProviderInitDoc";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT"] = "collabEditProviderFetchNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT"] = "collabEditProviderPreloadNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT_TIMEOUT"] = "collabEditProviderPreloadNCSDraftTimeout";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_PERMS_TOKEN_FETCH"] = "collabEditProviderPermsTokenFetch";
    return COLLAB_EDIT_PROVIDER_MEASURES;
}({});
module.exports["COLLAB_EDIT_PROVIDER_MEASURES"] = $fbca710eb28c4147$export$d0a57beabaefb993;

});

parcelRegister("9137z", function(module, exports) {

var $kGrzq = parcelRequire("kGrzq");

const $e77725a58fc80757$export$d93492bf620814be = new (0, $kGrzq.BaseMeasures)();
module.exports["CollabEditProviderMeasures"] = $e77725a58fc80757$export$d93492bf620814be;

});

parcelRegister("3pJBd", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $8fbe44097771f132$export$20260f2c545eeec0 = (0, $eSUdr.default)`query getCollabToken($contentId:ID!$draftShareId:String){collabToken(id:$contentId draftShareId:$draftShareId){token}}`;
module.exports["GetCollabPermissionTokenQuery"] = $8fbe44097771f132$export$20260f2c545eeec0;

});

parcelRegister("1sAC2", function(module, exports) {
class $3f756fb591e8330c$export$88b5d10ee0ed72d9 {
    getPermissionsTokenState(contentId) {
        return this.tokenState[contentId];
    }
    setToken(contentId, tokenPromise = Promise.resolve(null)) {
        // clear any existing tokens/bools in state
        this.tokenState[contentId] = {
            getToken: tokenPromise,
            isUsedForDraftFetch: false,
            isUsedForWSInitialization: false
        };
    }
    setIsUsedForDraftFetch(contentId, isUsedForDraftFetch) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForDraftFetch = isUsedForDraftFetch;
    }
    setIsUsedForWSInitialization(contentId, isUsedForWSInitialization) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForWSInitialization = isUsedForWSInitialization;
    }
    setTimestamp(contentId) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].timestamp = performance.now();
    }
    clearPermissionsTokenState(contentId) {
        if (this.tokenState[contentId]) delete this.tokenState[contentId];
    }
    constructor(){
        this.tokenState = {};
    }
}
const $3f756fb591e8330c$export$8e63d30e585828b3 = new $3f756fb591e8330c$export$88b5d10ee0ed72d9();
module.exports["nativeCollabPermissionsTokenState"] = $3f756fb591e8330c$export$8e63d30e585828b3;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("fEmGS", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    return $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data, variables: variables } = params;
    if (!data) return;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, root, queryFields, data, variables || {});
    });
}
function $f0827a369f0dafa9$var$writeQueryFields(storeProxy, record, fields, data, variables) {
    if (!record || !data) return;
    for (const field of fields){
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldData = data[linkedField.name];
            if (fieldData !== undefined) {
                if (Array.isArray(fieldData)) {
                    const linkedRecords = fieldData.map((item)=>{
                        if (item && typeof item === 'object') {
                            const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                            const existingRecord = record.getLinkedRecord(fieldKey);
                            if (existingRecord && linkedField.selections) {
                                $f0827a369f0dafa9$var$writeQueryFields(storeProxy, existingRecord, linkedField.selections, item, variables);
                                return existingRecord;
                            }
                        }
                        return null;
                    }).filter((rec)=>rec !== null);
                    if (linkedRecords.length > 0) {
                        const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                        record.setLinkedRecords(linkedRecords, fieldKey);
                    }
                } else if (fieldData && typeof fieldData === 'object') {
                    const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                    const linkedRecord = record.getLinkedRecord(fieldKey);
                    // If no linked record exists but we have data with an ID, we can try to get the existing record,
                    // or create a new record based on __typename. However, this shouldn't be a common use-case across the codebase,
                    // so we'll skip these code paths for now
                    if (linkedRecord && linkedField.selections) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, linkedRecord, linkedField.selections, fieldData, variables);
                }
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            if (data[scalarField.name] !== undefined) record.setValue(data[scalarField.name], scalarField.name);
        }
    }
}
function $f0827a369f0dafa9$var$getFieldKey(field, variables) {
    if (!field.args || field.args.length === 0) return field.name;
    // Compute storage key for fields with arguments
    const args = field.args.map((arg)=>{
        let value;
        if (arg.kind === 'Literal') value = JSON.stringify(arg.value);
        else if (arg.kind === 'Variable') value = JSON.stringify(variables[arg.variableName]);
        else // Fallback for other argument types
        value = JSON.stringify(arg.value);
        return `${arg.name}:${value}`;
    }).join(',');
    return `${field.name}(${args})`;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("l1uFv", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $65c7b8940c778902$export$627cb922211284f(params) {
    return $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("cOrQJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8z9j5 = parcelRequire("8z9j5");


var $60yhz = parcelRequire("60yhz");

/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $3ebd34920f1cc52c$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $42omo.useState)((0, $8z9j5.default)());
    (0, $42omo.useEffect)(()=>{
        const observer = new (0, $60yhz.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $3ebd34920f1cc52c$export$2e2bcd8739ae039 = $3ebd34920f1cc52c$var$useThemeObserver;
module.exports["default"] = $3ebd34920f1cc52c$export$2e2bcd8739ae039;

});

parcelRegister("77wHb", function(module, exports) {

var $gETEr = parcelRequire("gETEr");


var $bSxMj = parcelRequire("bSxMj");


var $hWvFC = parcelRequire("hWvFC");


var $fZxmY = parcelRequire("fZxmY");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $52f28c800c0dec0e$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $fZxmY(collection) ? $gETEr : $bSxMj, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $hWvFC(iteratee, 2), accumulator);
    };
}
module.exports = $52f28c800c0dec0e$var$createAggregator;

});

parcelRegister("gETEr", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $c20b8cf123ccbac3$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $c20b8cf123ccbac3$var$arrayAggregator;

});

parcelRegister("bSxMj", function(module, exports) {

var $iawSg = parcelRequire("iawSg");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $8a5ef07d195ea024$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $iawSg(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $8a5ef07d195ea024$var$baseAggregator;

});

parcelRegister("8Yfbq", function(module, exports) {

var $jSnXV = parcelRequire("jSnXV");


var $lc9ud = parcelRequire("lc9ud");

/** Error message constants. */ var $687fb4659a5afde2$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $687fb4659a5afde2$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($687fb4659a5afde2$var$FUNC_ERROR_TEXT);
    if ($lc9ud(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $jSnXV(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $687fb4659a5afde2$var$throttle;

});

parcelRegister("9NwnH", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");


var $ks2lK = parcelRequire("ks2lK");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $5jGZY = parcelRequire("5jGZY");

class $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd {
    constructor(step, inverted, origin){
        this.step = step;
        this.inverted = inverted;
        this.origin = origin;
    }
}
function $c4b7da7a59ba31a1$export$bced9e015fcf3afa(steps, over, transform) {
    for(let i = steps.length - 1; i >= 0; i--)transform.step(steps[i].inverted);
    for(let i = 0; i < over.length; i++)transform.step(over[i]);
    const result = [];
    for(let i = 0, mapFrom = steps.length; i < steps.length; i++){
        const mapped = steps[i].step.map(transform.mapping.slice(mapFrom));
        const movedStep = (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) ? (0, $5jGZY.mapStep)(steps, transform, i, mapped) : undefined;
        mapFrom--;
        if (mapped && !transform.maybeStep(mapped).failed) {
            // Open ticket for setMirror https://github.com/ProseMirror/prosemirror/issues/869
            // @ts-expect-error
            transform.mapping.setMirror(mapFrom, transform.steps.length - 1);
            result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(mapped, mapped.invert(transform.docs[transform.docs.length - 1]), steps[i].origin));
        }
        // If the step is a "move" step - apply the additional step
        if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) {
            if (movedStep && !transform.maybeStep(movedStep).failed) result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(movedStep, movedStep.invert(transform.docs[transform.docs.length - 1]), transform));
        }
    }
    return result;
}
// This state field accumulates changes that have to be sent to the
// central authority in the collaborating group and makes it possible
// to integrate changes made by peers into our local document. It is
// defined by the plugin, and will be available as the `collab` field
// in the resulting editor state.
class $c4b7da7a59ba31a1$var$CollabState {
    constructor(// The version number of the last update received from the central
    // authority. Starts at 0 or the value of the `version` property
    // in the option object, for the editor's value when the option
    // was enabled.
    version, // The local steps that havent been successfully sent to the
    // server yet.
    unconfirmed){
        this.version = version;
        this.unconfirmed = unconfirmed;
    }
}
function $c4b7da7a59ba31a1$var$unconfirmedFrom(transform) {
    const result = [];
    for(let i = 0; i < transform.steps.length; i++)result.push(new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(transform.steps[i], transform.steps[i].invert(transform.docs[i]), transform));
    return result;
}
const $c4b7da7a59ba31a1$var$collabKey = new (0, $ks2lK.PluginKey)('collab');
function $c4b7da7a59ba31a1$export$995d9de96d1b2e26(config = {}) {
    const conf = {
        version: config.version || 0,
        clientID: // eslint-disable-next-line eqeqeq
        // generate a temporary id as clientId when it is null or undefined
        // prefix temp-pc- indicates prosemirror-collab
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        config.clientID == null || !config.clientID ? `temp-pc-${(0, $dQl1W.v4)()}` : config.clientID
    };
    const transformUnconfirmed = config.transformUnconfirmed ?? ((steps)=>steps);
    return new (0, $ks2lK.Plugin)({
        key: $c4b7da7a59ba31a1$var$collabKey,
        state: {
            init: ()=>new $c4b7da7a59ba31a1$var$CollabState(conf.version, []),
            apply (tr, collab) {
                const newState = tr.getMeta($c4b7da7a59ba31a1$var$collabKey);
                if (newState) {
                    if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) || (0, $1oCLl.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true)) return new $c4b7da7a59ba31a1$var$CollabState(newState.version, transformUnconfirmed(newState.unconfirmed));
                    else return newState;
                }
                if (tr.docChanged) return new $c4b7da7a59ba31a1$var$CollabState(collab.version, transformUnconfirmed(collab.unconfirmed.concat($c4b7da7a59ba31a1$var$unconfirmedFrom(tr))));
                return collab;
            }
        },
        config: conf,
        // This is used to notify the history plugin to not merge steps,
        // so that the history can be rebased.
        historyPreserveItems: true
    });
}
function $c4b7da7a59ba31a1$export$5af1c9a2797f6d8e(state) {
    const tr = state.tr;
    const { version: version, unconfirmed: unconfirmed } = $c4b7da7a59ba31a1$var$collabKey.getState(state) ?? {};
    if (version === undefined || !unconfirmed) return tr.doc;
    // undo unconfirmed steps
    for(let i = unconfirmed.length - 1; i >= 0; i--)tr.step(unconfirmed[i].inverted);
    return tr.doc;
}
function $c4b7da7a59ba31a1$export$852bd88de4de2d35(state, version, // eslint-disable-next-line @typescript-eslint/no-explicit-any
docJSON, unconfirmedSteps) {
    const tr = state.tr;
    const doc = state.schema.nodeFromJSON(docJSON);
    const { from: from, to: to } = tr.selection;
    tr.replaceWith(0, state.doc.content.size, doc);
    // apply new unconfirmed steps to doc
    for(let i = 0; i < unconfirmedSteps.length; i++)tr.step(unconfirmedSteps[i]);
    const offset = 1; // offset by 1 to account for the initial replace step
    const newUnconfirmed = tr.steps.slice(offset).map((step, i)=>{
        const index = i + offset;
        const doc = tr.docs[index];
        return new $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd(step, step.invert(doc), tr);
    });
    // Because we are replacing the entire document from 0 to end, the selection mapping is incorrect.
    // For now, the best we can do is set the selection to the original positions. Otherwise, it will move to the end of the doc on every change.
    tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, Math.min(from, tr.doc.content.size), Math.min(to, tr.doc.content.size)));
    return tr.setMeta('addToHistory', false).setMeta($c4b7da7a59ba31a1$var$collabKey, new $c4b7da7a59ba31a1$var$CollabState(version, newUnconfirmed));
}
function $c4b7da7a59ba31a1$export$7581d8ca0d559ec6(state, steps, clientIDs, options = {}) {
    // Pushes a set of steps (received from the central authority) into
    // the editor state (which should have the collab plugin enabled).
    // Will recognize its own changes, and confirm unconfirmed steps as
    // appropriate. Remaining unconfirmed steps will be rebased over
    // remote steps.
    const collabState = $c4b7da7a59ba31a1$var$collabKey.getState(state);
    const version = (collabState?.version || 0) + steps.length;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion,  @typescript-eslint/no-explicit-any
    const ourID = $c4b7da7a59ba31a1$var$collabKey.get(state).spec.config.clientID;
    // Find out which prefix of the steps originated with us
    let ours = 0;
    // eslint-disable-next-line eqeqeq
    while(ours < clientIDs.length && clientIDs[ours] == ourID)++ours;
    let unconfirmed = collabState?.unconfirmed.slice(ours) || [];
    steps = ours ? steps.slice(ours) : steps;
    // If all steps originated with us, we're done.
    if (!steps.length) return state.tr.setMeta($c4b7da7a59ba31a1$var$collabKey, new $c4b7da7a59ba31a1$var$CollabState(version, unconfirmed));
    const nUnconfirmed = unconfirmed.length;
    const tr = state.tr;
    if (nUnconfirmed) unconfirmed = $c4b7da7a59ba31a1$export$bced9e015fcf3afa(unconfirmed, steps, tr);
    else {
        for(let i = 0; i < steps.length; i++)tr.step(steps[i]);
        unconfirmed = [];
    }
    const newCollabState = new $c4b7da7a59ba31a1$var$CollabState(version, unconfirmed);
    if (options && options.mapSelectionBackward && state.selection instanceof (0, $ks2lK.TextSelection)) {
        tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(tr.mapping.map(state.selection.anchor, -1)), tr.doc.resolve(tr.mapping.map(state.selection.head, -1))));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tr.updated &= -2;
    }
    return tr.setMeta('rebased', nUnconfirmed).setMeta('rebasedData', {
        unconfirmedSteps: collabState?.unconfirmed.slice(ours) || [],
        remoteSteps: steps,
        stepsAfterRebase: unconfirmed,
        versionBefore: version
    }).setMeta('addToHistory', false).setMeta($c4b7da7a59ba31a1$var$collabKey, newCollabState);
}
function $c4b7da7a59ba31a1$export$4da2109e7644e6c2(state) {
    const collabState = $c4b7da7a59ba31a1$var$collabKey.getState(state);
    if (!collabState) return null;
    // eslint-disable-next-line eqeqeq
    if (collabState.unconfirmed.length == 0) return null;
    return {
        version: collabState.version,
        steps: collabState.unconfirmed.map((s)=>s.step),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
        clientID: $c4b7da7a59ba31a1$var$collabKey.get(state).spec.config.clientID,
        get origins () {
            return(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins || (// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins = collabState?.unconfirmed.map((s)=>s.origin)));
        }
    };
}
function $c4b7da7a59ba31a1$export$971539697c176258(state) {
    return $c4b7da7a59ba31a1$var$collabKey.getState(state);
}
module.exports["Rebaseable"] = $c4b7da7a59ba31a1$export$c6d36d70c8e9d8cd;
module.exports["rebaseSteps"] = $c4b7da7a59ba31a1$export$bced9e015fcf3afa;
module.exports["collab"] = $c4b7da7a59ba31a1$export$995d9de96d1b2e26;
module.exports["getDocBeforeUnconfirmedSteps"] = $c4b7da7a59ba31a1$export$5af1c9a2797f6d8e;
module.exports["syncFromAnotherSource"] = $c4b7da7a59ba31a1$export$852bd88de4de2d35;
module.exports["receiveTransaction"] = $c4b7da7a59ba31a1$export$7581d8ca0d559ec6;
module.exports["sendableSteps"] = $c4b7da7a59ba31a1$export$4da2109e7644e6c2;
module.exports["getCollabState"] = $c4b7da7a59ba31a1$export$971539697c176258;

});

parcelRegister("5jGZY", function(module, exports) {

var $jy7VG = parcelRequire("jy7VG");


var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");

// Iterate from the specified starting index down to 0
const $33dcd085767efb3e$var$findPreviousStepInverseIndex = (steps, startIndex = steps.length - 1)=>{
    for(let i = startIndex; i >= 0; i--){
        if (!(steps[i] instanceof (0, $jy7VG.AnalyticsStep))) return i;
    }
};
const $33dcd085767efb3e$export$798cdecdcbbf9755 = (steps, transform, index, mapped)=>{
    if (index < 1) return undefined;
    const previousRebaseableStepIndex = $33dcd085767efb3e$var$findPreviousStepInverseIndex(steps.map((s)=>s.step), index - 1);
    // This checks the local steps are a "move" sequence
    if (previousRebaseableStepIndex !== undefined && $33dcd085767efb3e$export$17bbdbb89ac2acbd(steps[previousRebaseableStepIndex], steps[index].step)) {
        const previousStepInverseIndex = $33dcd085767efb3e$var$findPreviousStepInverseIndex(transform.steps);
        // Creates a new step based on the "current" steps (partially through the rebase)
        if (previousStepInverseIndex !== undefined) return $33dcd085767efb3e$export$ad07b298545ed98d(mapped, transform.steps[previousStepInverseIndex], transform, previousStepInverseIndex);
    }
};
// Only consider ReplaceStep (ReplaceAroundStep do not occur for moves)
const $33dcd085767efb3e$var$isReplaceTypeStep = (step)=>step instanceof (0, $aXG5V.ReplaceStep);
const $33dcd085767efb3e$export$17bbdbb89ac2acbd = (previousRebaseableStep, currentStep)=>{
    if (// The both steps are replace
    $33dcd085767efb3e$var$isReplaceTypeStep(previousRebaseableStep.step) && $33dcd085767efb3e$var$isReplaceTypeStep(currentStep) && // The current step is a deletion
    previousRebaseableStep.step.slice.size === 0 && // The following step is an insertion with the same length that was deleted by the current step
    Math.abs(previousRebaseableStep.step.to - previousRebaseableStep.step.from) === currentStep.slice.size) {
        // Ensure we're getting the doc before our step changes so we can compare node contents
        const originStepIndex = previousRebaseableStep.origin.steps.findIndex((s)=>s === previousRebaseableStep.step);
        if (originStepIndex === -1) return false;
        const originalDoc = previousRebaseableStep.origin.docs[originStepIndex];
        if (!originalDoc) return false;
        const currentSlice = originalDoc.slice(previousRebaseableStep.step.from, previousRebaseableStep.step.to);
        // The content from the deleted + inserted slice is exactly the same (cut + paste or drag + drop)
        if (currentSlice.eq(currentStep.slice)) return true;
    }
    return false;
};
const $33dcd085767efb3e$export$ad07b298545ed98d = (mapped, previousStep, transform, previousStepIndex)=>{
    if (!$33dcd085767efb3e$var$isReplaceTypeStep(previousStep) || mapped && !$33dcd085767efb3e$var$isReplaceTypeStep(mapped) || !mapped || // Ensure previous step index is valid
    !(previousStepIndex >= 0 && previousStepIndex < transform.docs.length && typeof previousStep?.from === 'number')) return undefined;
    const newSlice = transform.docs[previousStepIndex].slice(previousStep?.from, previousStep?.to);
    const diff = $33dcd085767efb3e$var$getDiffRange(mapped.slice.content, newSlice.content);
    if (diff === undefined) return undefined;
    const start = mapped.from + diff.start;
    const offset = newSlice.content.size - mapped.slice.content.size === 0 ? diff.end - diff.start : 0;
    // If the new slice is smaller then we're doing a deletion of content - this needs
    // to be a replace step with empty content to delete content
    if (newSlice.content.size - mapped.slice.content.size < 0) return new (0, $aXG5V.ReplaceStep)(start, start + mapped.slice.content.size - newSlice.content.size, (0, $5SAOw.Slice).empty);
    // Replace the diff range with the latest content in the document (at the old position)
    return new (0, $aXG5V.ReplaceStep)(start, start + offset, transform.docs[previousStepIndex].slice(previousStep?.from + diff.start, previousStep?.from + diff.end));
};
/**
 * Get start and end diff position values for two fragments (old, new).
 * @param {Fragment} before - content that is planned to move
 * @param {Fragment} after - content that was in paragraph being deleted (updated content)
 * @returns {object} - { start, end }
 */ function $33dcd085767efb3e$var$getDiffRange(before, after) {
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffStart
    const start = before.findDiffStart(after);
    // Important: diffEnd value is {a,b} object since end pos will differ.
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffEnd
    const diffEnd = before.findDiffEnd(after);
    if (start === null || diffEnd === null) return undefined;
    // WARNING: diffEnd may be lower than diffStart.
    // If so, add overlap to get correct range.
    // https://discuss.prosemirror.net/t/overlap-handling-of-finddiffstart-and-finddiffend/2856
    const overlap = start - Math.min(diffEnd.a, diffEnd.b);
    let end = diffEnd.b;
    if (overlap > 0) end += overlap;
    return {
        start: start,
        end: end
    };
}
module.exports["mapStep"] = $33dcd085767efb3e$export$798cdecdcbbf9755;

});


//# sourceMappingURL=ContentHeaderPresence.828581fb.js.map
